/* Options:
Date: 2026-10-15 14:06:15
Version: 8.30
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: https://localhost:5001

//GlobalNamespace: 
//MakePropertiesOptional: False
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion: 
//AddDescriptionAsComments: True
//IncludeTypes: 
ExcludeTypes: SqlGeography
//DefaultImports: immerable:immer
*/

import { immerable } from "immer";

export interface IReturn<T>
{
    createResponse(): T;
}

export interface IReturnVoid
{
    createResponse(): void;
}

export interface IHasSessionId
{
    sessionId?: string;
}

export interface IHasBearerToken
{
    bearerToken?: string;
}

export interface IPost
{
}

export interface IGet
{
}

export interface IPut
{
}

export interface IDelete
{
}

// @Flags()
export enum CommunityGroupMemberStatus
{
    Pending = 0,
    Accepted = 1,
    Declined = 2,
    Resigned = 3,
    Removed = 4,
}

export enum Species
{
    Rabbit = 1,
    Fox = 2,
    Camel = 3,
    FeralPig = 4,
    Myna = 5,
    WildDog = 6,
    Toad = 7,
    FeralGoat = 8,
    Starling = 9,
    Deer = 10,
    FeralFish = 11,
    Mouse = 12,
    FeralCat = 15,
    NewPests = 17,
    OtherPests = 18,
    None = 99,
}

// @DataContract
export class ExternalRecord
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public species: Species;

    // @DataMember(Order=3)
    public latitude?: number;

    // @DataMember(Order=4)
    public longitude?: number;

    // @DataMember(Order=5)
    public eventDate?: string;

    // @DataMember(Order=6)
    public uuid?: string;

    // @DataMember(Order=7)
    public dataResource?: string;

    // @DataMember(Order=8)
    public dataResourceUid?: string;

    // @DataMember(Order=9)
    public commonName?: string;

    // @DataMember(Order=10)
    public apiResource?: string;

    // @DataMember(Order=11)
    public obsolete?: boolean;

    public constructor(init?: Partial<ExternalRecord>) { (Object as any).assign(this, init); }
}

export class RegionDo
{
    [immerable] = true;

    public regionId: number;
    public state: string;
    public name: string;
    public polygon: string;
    public geoPolygon: MyGeographyDto;
    public rank: number;
    public dateModified: string;
    public obsolete?: boolean;
    public kmlFileName?: string;
    public isLLS?: boolean;

    public constructor(init?: Partial<RegionDo>) { (Object as any).assign(this, init); }
}

export class UserApplicationRoleDo implements IUserRole
{
    [immerable] = true;

    public id: number;
    // @References("typeof(FeralScan.ServiceModel.Models.Dos.UserDo)")
    public userId: number;

    public createdDate: string;
    public createdByUserId?: number;
    // @References("typeof(FeralScan.ServiceModel.Models.Dos.Roles.ApplicationRoleDo)")
    public applicationRoleId: number;

    public speciesId?: Species;
    // @References("typeof(FeralScan.ServiceModel.Models.Dos.RegionDo)")
    public regionId?: number;

    public region: RegionDo;

    public constructor(init?: Partial<UserApplicationRoleDo>) { (Object as any).assign(this, init); }
}

// @DataContract
export class User
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public fullName?: string;

    // @DataMember(Order=3)
    public userName?: string;

    // @DataMember(Order=4)
    public email?: string;

    // @DataMember(Order=5)
    public mobile?: string;

    // @DataMember(Order=6)
    public postCode?: string;

    // @DataMember(Order=7)
    public state?: string;

    // @DataMember(Order=8)
    public beNotified?: boolean;

    // @DataMember(Order=9)
    public roles?: string[];

    // @DataMember(Order=10)
    public matchingRegionAdminRoles?: UserApplicationRoleDo[];

    // @DataMember(Order=11)
    public disableSendingNotifications?: boolean;

    public constructor(init?: Partial<User>) { (Object as any).assign(this, init); }
}

export enum ContentCodeType
{
    ContentHero = 0,
    ContentMappingResultsLine = 1,
}

export interface ISearch
{
    skip?: number;
    take?: number;
}

export enum SiteEventType
{
    Sighting = 1,
    Damage = 2,
    Control = 3,
    Disease = 4,
    Management = 5,
    External = 6,
}

export enum SpeciesSiteEventType
{
    ControlCamel = 1,
    ControlDeer = 2,
    ControlFeralFish = 3,
    ControlFeralGoat = 4,
    ControlFeralPig = 5,
    ControlFox = 6,
    ControlMouse = 7,
    ControlMyna = 8,
    ControlRabbit = 9,
    ControlStarling = 10,
    ControlToad = 11,
    ControlWildDog = 13,
    DamageCamel = 14,
    DamageDeer = 15,
    DamageFeralFish = 16,
    DamageFeralGoat = 17,
    DamageFeralPig = 18,
    DamageFox = 19,
    DamageMouse = 20,
    DamageMyna = 21,
    DamageRabbit = 22,
    DamageStarling = 23,
    DamageToad = 24,
    DamageWildDog = 26,
    SightingCamel = 27,
    SightingDeer = 28,
    SightingFeralFish = 29,
    SightingFeralGoat = 30,
    SightingFeralPig = 31,
    SightingFox = 32,
    SightingMouse = 33,
    SightingMyna = 34,
    SightingRabbit = 35,
    SightingStarling = 36,
    SightingToad = 37,
    SightingWildDog = 39,
    ControlFeralCat = 43,
    DamageFeralCat = 44,
    SightingFeralCat = 45,
    DiseaseRabbit = 46,
    SightingNewPests = 48,
    SightingOtherPests = 49,
    DamageOtherPests = 50,
    ControlOtherPests = 51,
    ManagementWildDog = 52,
    ManagementDeer = 53,
}

export interface ISiteEventGetCollection extends ISiteEventGetCollectionExtra
{
    getChartAndTableData?: boolean;
}

export interface ISiteEventGetCollectionExtra extends ISearch, IAccessToken
{
    startDateOnOrAfter?: string;
    startDateOnOrBefore?: string;
    onlyPublicData: boolean;
    id?: number;
    userId?: number;
    userIdNotEqualTo?: number;
    locatedInRegionIds: number[];
    memberOfCommunityGroupIds: number[];
    subSpeciesId?: number;
    dataAccessId?: number;
    skip?: number;
    take?: number;
}

export interface IAccessToken
{
    accessToken: string;
}

export interface ISiteEventGetCollectionGallery extends ISiteEventGetCollectionExtra
{
}

export interface ISiteEventGetHistory extends IHasId, IAccessToken
{
}

export interface IHasId
{
    id?: number;
}

export interface ISiteEventPostInsert
{
}

// @DataContract
export class QueryBase
{
    [immerable] = true;

    // @DataMember(Order=1)
    public skip?: number;

    // @DataMember(Order=2)
    public take?: number;

    // @DataMember(Order=3)
    public orderBy: string;

    // @DataMember(Order=4)
    public orderByDesc: string;

    // @DataMember(Order=5)
    public include: string;

    // @DataMember(Order=6)
    public fields: string;

    // @DataMember(Order=7)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<QueryBase>) { (Object as any).assign(this, init); }
}

export class QueryDb<T> extends QueryBase
{
    [immerable] = true;


    public constructor(init?: Partial<QueryDb<T>>) { super(init); (Object as any).assign(this, init); }
}

export class EmailNotificationLogDetailsDo
{
    [immerable] = true;

    public emailNotificationLogId: number;
    public emailNotificationSendLogId: number;
    public logDate: string;
    public triggeredNotification: number;
    public emailNotificationConfigId: number;
    public emailNotificationDescription: string;
    public intendedRecipients: string;
    public actualRecipients: string;
    public siteEventId: number;
    public siteEventSpecies: string;
    public siteEventType: SiteEventType;
    public siteEventEmail: string;
    public siteEventUserId: number;
    public userAccountEmail: string;

    public constructor(init?: Partial<EmailNotificationLogDetailsDo>) { (Object as any).assign(this, init); }
}

export enum BySubmitter
{
    PublicData = 1,
    AllData = 2,
    MyData = 3,
    MyGroup = 4,
}

// @DataContract
export class MinMaxRange
{
    [immerable] = true;

    // @DataMember(Order=1)
    public minimum: number;

    // @DataMember(Order=2)
    public maximum: number;

    public constructor(init?: Partial<MinMaxRange>) { (Object as any).assign(this, init); }
}

export class QueryData<T> extends QueryBase
{
    [immerable] = true;


    public constructor(init?: Partial<QueryData<T>>) { super(init); (Object as any).assign(this, init); }
}

// @DataContract
export class Region
{
    [immerable] = true;

    // @DataMember(Order=1)
    public regionId: number;

    // @DataMember(Order=2)
    public state: string;

    // @DataMember(Order=3)
    public name: string;

    // @DataMember(Order=4)
    public polygon: string;

    // @DataMember(Order=5)
    public rank: number;

    // @DataMember(Order=6)
    public dateModified: string;

    // @DataMember(Order=7)
    public obsolete?: boolean;

    public constructor(init?: Partial<Region>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EmailNotificationConfig
{
    [immerable] = true;

    // @DataMember(Order=1)
    public emailNotificationConfigId: number;

    // @DataMember(Order=2)
    public emailNotificationDescription?: string;

    // @DataMember(Order=3)
    public sightingTypeId: SpeciesSiteEventType;

    // @DataMember(Order=4)
    public sendToCommunityGroupId: number;

    // @DataMember(Order=5)
    public grantAccessToSightingPhoto: boolean;

    // @DataMember(Order=6)
    public grantAccessToPhoneNumber: boolean;

    // @DataMember(Order=7)
    public additionalInformation: string;

    // @DataMember(Order=8)
    public active: boolean;

    // @DataMember(Order=9)
    public triggerForCommunityGroupId?: number;

    // @DataMember(Order=10)
    public region?: Region;

    public constructor(init?: Partial<EmailNotificationConfig>) { (Object as any).assign(this, init); }
}

export interface ISiteEventGetSingleById extends IHasId
{
}

export class SiteEventControlCamel implements ISiteEventControlCamel
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public endDateTime?: string;
    public techniqueMustering?: boolean;
    public techniqueGroundShootingToLeave?: boolean;
    public techniqueGroundShootingForCommercialPetMeat?: boolean;
    public techniqueGroundShootingForNonCommercialPetMeat?: boolean;
    public techniqueAerialShooting?: boolean;
    public techniqueOther?: boolean;
    public techniqueOtherSpec: string;
    public controlCoordinatedScore?: number;
    public controlCoordinatedSpec: string;
    public camelsRemoved: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventControlCamel>) { (Object as any).assign(this, init); }
}

export class SiteEventControlDeer implements ISiteEventControlDeer
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public endDateTime?: string;
    public subSpeciesId?: number;
    public techniqueGroundShooting?: boolean;
    public techniqueNoiseDisturbance?: boolean;
    public techniqueFencing?: boolean;
    public techniqueOther?: boolean;
    public techniqueOtherSpec: string;
    public techniqueOtherSpecScore?: number;
    public techniqueAerialShooting?: boolean;
    public techniqueAerialShootingScore?: number;
    public techniqueGuardian?: boolean;
    public techniqueRepellents?: boolean;
    public propertyName: string;
    public siteNumber: string;
    public techniqueGroundShootingScore?: number;
    public sampleNumber: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    public cameraInstalledScore?: number;
    public techniqueGroundShootingThermal?: boolean;
    public techniqueGroundShootingThermalScore?: number;
    public techniqueTrapping?: boolean;
    public techniqueTrappingScore?: number;
    public techniqueTrappingDeerTrappedScore?: number;
    public techniqueCommercialShooting?: boolean;
    public techniqueCommercialShootingScore?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventControlDeer>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralCat implements ISiteEventControlFeralCat
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public endDateTime?: string;
    public testData?: boolean;
    public techniqueJawTraps?: boolean;
    public techniqueJawTrapsScore?: number;
    public techniqueCageTraps?: boolean;
    public techniqueCageTrapsScore?: number;
    public techniqueGroundShooting?: boolean;
    public techniqueGroundShootingScore?: number;
    public techniqueGuardAnimals?: boolean;
    public techniqueExclusion?: boolean;
    public techniqueOther?: boolean;
    public techniqueOtherSpec: string;
    public techniqueGroundShootingNight?: boolean;
    public techniqueGroundShootingNightScore?: number;
    public ageScore?: number;
    public sexScore?: number;
    public colourScore?: number;
    public lureType?: string;
    public siteNumber: string;
    public propertyName: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventControlFeralCat>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralFish implements ISiteEventControlFeralFish
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public endDateTime?: string;
    public techniqueFishingNoRelease?: boolean;
    public techniqueChemical?: boolean;
    public techniqueElectro?: boolean;
    public techniqueTrapping?: boolean;
    public techniqueFishwayTraps?: boolean;
    public techniqueOther?: boolean;
    public techniqueOtherSpec: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventControlFeralFish>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralGoat implements ISiteEventControlFeralGoat
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public endDateTime?: string;
    public techniqueGroundShooting?: boolean;
    public techniqueAerialShooting?: boolean;
    public techniqueCommercialShooting?: boolean;
    public techniqueMustering?: boolean;
    public techniqueTrapping?: boolean;
    public techniqueJudasGoat?: boolean;
    public techniqueFencing?: boolean;
    public techniqueOther?: boolean;
    public techniqueOtherSpec: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public propertyName: string;
    public siteNumber: string;
    public techniqueGroundShootingScore?: number;
    public techniqueAerialShootingScore?: number;
    public techniqueCommercialShootingScore?: number;
    public techniqueMusteringScore?: number;
    public techniqueMusteringWithWorkingDogs?: boolean;
    public techniqueMusteringWithWorkingDogsScore?: number;
    public techniqueMusteringAerialAssisted?: boolean;
    public techniqueMusteringAerialAssistedScore?: number;
    public techniqueTrappingScore?: number;
    public herdCompositionBillies?: boolean;
    public herdCompositionNannies?: boolean;
    public herdCompositionKids?: boolean;
    public herdCompositionCombination?: boolean;
    public managementFieldProcessed?: boolean;
    public managementFieldProcessedScore?: number;
    public managementTransportElsewhere?: boolean;
    public managementTransportElsewhereScore?: number;
    public managementHumaneEuthanasia?: boolean;
    public managementHumaneEuthanasiaScore?: number;
    public managementOther?: boolean;
    public managementOtherSpec?: string;
    public managementOtherScore?: number;
    // @Ignore()
    public moreDataCheckbox: boolean;

    public constructor(init?: Partial<SiteEventControlFeralGoat>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralPig implements ISiteEventControlFeralPig
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public endDateTime?: string;
    public techniqueWarningSigns?: boolean;
    public techniqueCamera?: boolean;
    public techniquePoisonGrain?: boolean;
    public techniquePoisonMeat?: boolean;
    public techniquePoisonManufactured?: boolean;
    public techniqueTrapping?: boolean;
    public techniqueGroundShooting?: boolean;
    public techniqueAerialShooting?: boolean;
    public techniqueAerialShootingScore?: number;
    public techniqueCommercialShooting?: boolean;
    public techniqueCommercialShootingScore?: number;
    public techniqueFencing?: boolean;
    public techniqueJudasPig?: boolean;
    public techniqueOther?: boolean;
    public techniqueOtherSpec: string;
    public techniqueGroundBaiting?: boolean;
    public techniqueGroundBaitingScore?: number;
    public techniqueGroundBaitingBaitTakenScore?: number;
    public techniqueAerialBaiting?: boolean;
    public techniqueTrappingScore?: number;
    public techniqueGroundShootingScore?: number;
    public techniqueGroundShootingThermal?: boolean;
    public techniqueGroundShootingThermalScore?: number;
    public techniqueGroundBaitingHoggone?: boolean;
    public techniqueGroundBaitingHoggoneScore?: number;
    public techniqueGroundBaitingHoggonePoisonBaitTakenScore?: number;
    public techniqueTrappingPigsTrappedScore?: number;
    public propertyName: string;
    public siteNumber: string;
    public preFeedType: string;
    public sampleNumber: string;
    public removedPigs: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    public cameraInstalledScore?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventControlFeralPig>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFox implements ISiteEventControlFox
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public endDateTime?: string;
    public techniqueWarningSigns?: boolean;
    public techniqueGroundBaiting?: boolean;
    public techniqueGroundBaitingScore?: number;
    public techniqueAerialBaiting?: boolean;
    public techniqueJawTraps?: boolean;
    public techniqueJawTrapsScore?: number;
    public techniqueCageTraps?: boolean;
    public techniqueCageTrapsScore?: number;
    public techniqueTrapping?: boolean;
    public techniqueGroundShooting?: boolean;
    public techniqueGroundShootingScore?: number;
    public techniqueGroundShootingThermal?: boolean;
    public techniqueGroundShootingThermalScore?: number;
    public techniqueGuard?: boolean;
    public techniqueExclusion?: boolean;
    public techniqueFumigation?: boolean;
    public techniqueFoxDrives?: boolean;
    public techniqueOther?: boolean;
    public techniqueOtherSpec: string;
    public techniqueGroundBaitingPAPP?: boolean;
    public techniqueGroundBaitingPAPPScore?: number;
    public techniqueCanidPestEjector?: boolean;
    public techniqueCanidPestEjectorScore?: number;
    public siteNumber: string;
    public lureType: string;
    public propertyName: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventControlFox>) { (Object as any).assign(this, init); }
}

export class SiteEventControlMouse implements ISiteEventControlMouse
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public endDateTime?: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventControlMouse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlMyna implements ISiteEventControlMyna
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public endDateTime?: string;
    public propertyName: string;
    public siteNumber: string;
    public techniqueTrapping?: boolean;
    public techniqueTrappingScore?: number;
    public techniqueShooting?: boolean;
    public techniqueShootingScore?: number;
    public techniqueExclusion?: boolean;
    public techniqueOther?: boolean;
    public techniqueOtherSpec: string;
    public mynasRemoved?: number;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventControlMyna>) { (Object as any).assign(this, init); }
}

export class SiteEventControlOtherPests implements ISiteEventControlOtherPests
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public propertyName: string;
    public siteNumber: string;
    public subSpeciesId?: number;
    public techniqueMustering: boolean;
    public techniqueMusteringScore?: number;
    public techniqueGroundShootingToLeave: boolean;
    public techniqueGroundShootingToLeaveScore?: number;
    public techniqueGroundShootingToUse: boolean;
    public techniqueGroundShootingToUseScore?: number;
    public techniqueAerialShooting: boolean;
    public techniqueAerialShootingScore?: number;
    public techniqueExclusionFencing: boolean;
    public techniqueTrapping?: boolean;
    public techniqueTrappingScore?: number;
    public techniqueOther: boolean;
    public techniqueOtherSpec: string;
    public animalsRemoved: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventControlOtherPests>) { (Object as any).assign(this, init); }
}

export class SiteEventControlRabbit implements ISiteEventControlRabbit
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public techniqueWarningSigns?: boolean;
    public techniqueRipping?: boolean;
    public techniqueRippingNumberDestroyed?: number;
    public techniqueFumigation?: boolean;
    public techniqueFumigationNumberFumigated?: number;
    public techniqueBioNatMyxo?: boolean;
    public techniqueBioNatRHDV?: boolean;
    public techniqueBioIntroRHDV?: boolean;
    public techniqueTrapping?: boolean;
    public techniqueTrappingScore?: number;
    public techniqueShooting?: boolean;
    public techniqueShootingNumberShot?: number;
    public techniquePoison?: boolean;
    public techniquePoison1080?: boolean;
    public techniquePoison1080Score?: number;
    public techniquePoisonPindone?: boolean;
    public techniquePoisonPindoneScore?: number;
    public techniqueExclusion?: boolean;
    public techniqueHarbourRemoval?: boolean;
    public techniqueOther?: boolean;
    public techniqueOtherSpec: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public siteNumber: string;
    public propertyName: string;

    public constructor(init?: Partial<SiteEventControlRabbit>) { (Object as any).assign(this, init); }
}

export class SiteEventControlStarling implements ISiteEventControlStarling
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public endDateTime?: string;
    public techniqueTrapping?: boolean;
    public techniqueShooting?: boolean;
    public techniqueExclusion?: boolean;
    public techniqueOther?: boolean;
    public techniqueOtherSpec: string;
    public starlingsRemoved?: number;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventControlStarling>) { (Object as any).assign(this, init); }
}

export class SiteEventControlToad implements ISiteEventControlToad
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    // @Ignore()
    public emailNsw: string;

    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public endDateTime?: string;
    public techniqueMuster?: boolean;
    public techniqueIncidential?: boolean;
    public techniqueCollection?: boolean;
    public techniqueTrapping?: boolean;
    public techniqueExclusion?: boolean;
    public techniqueSpray?: boolean;
    public techniqueDetection?: boolean;
    public techniqueOther?: boolean;
    public techniqueOtherSpec: string;
    public toadsRemoved?: number;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    public propertyName: string;
    public siteNumber?: string;
    public techniqueCollectionAdults?: boolean;
    public techniqueCollectionAdultsScore?: number;
    public techniqueCollectionJuveniles?: boolean;
    public techniqueCollectionJuvenilesScore?: number;
    public techniqueCollectionTadpoles?: boolean;
    public techniqueCollectionTadpolesScore?: number;
    public techniqueCollectionEggs?: boolean;
    public techniqueCollectionEggsScore?: number;
    public techniqueCollectionMetamorphs?: boolean;
    public techniqueCollectionMetamorphsScore?: number;
    public techniqueTrappingScore?: number;
    public sexMale?: boolean;
    public sexFemale?: boolean;
    public sexUnknown?: boolean;
    public evidenceOfBreedingScore?: number;
    public streetAddress?: string;
    public possessionScore?: number;
    public sightingTypeScore?: number;
    public fullName?: string;
    public phoneNumber?: string;
    public adminAssessmentScore?: number;
    public adminEnvironmentScore?: number;
    public adminNotes?: string;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventControlToad>) { (Object as any).assign(this, init); }
}

export class SiteEventControlWildDog implements ISiteEventControlWildDog
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public techniqueWarningSigns?: boolean;
    public techniqueCamera?: boolean;
    public techniqueGroundBaiting?: boolean;
    public techniqueGroundBaitingScore?: number;
    public techniqueAerialBaiting?: boolean;
    public techniqueJawTraps?: boolean;
    public techniqueJawTrapsScore?: number;
    public techniqueCageTraps?: boolean;
    public techniqueCageTrapsScore?: number;
    public techniqueGroundShooting?: boolean;
    public techniqueGroundShootingScore?: number;
    public techniqueAerialShooting?: boolean;
    public techniqueAerialShootingScore?: number;
    public techniqueLivestock?: boolean;
    public techniqueExclusion?: boolean;
    public techniqueOther?: boolean;
    public techniqueOtherSpec: string;
    public techniqueGroundBaitingPAPP?: boolean;
    public techniqueGroundBaitingPAPPScore?: number;
    public techniqueCanidPestEjector?: boolean;
    public techniqueCanidPestEjectorScore?: number;
    public siteNumber: string;
    public propertyName: string;
    public techniqueStrychnineTraps?: boolean;
    public techniqueStrychnineTrapsScore?: number;
    public sex?: number;
    public age?: number;
    public colour?: number;
    public sampleNumber: string;
    public lureType: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    public cameraInstalledScore?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventControlWildDog>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageCamel implements ISiteEventDamageCamel
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public damageWetland?: boolean;
    public damageWater?: boolean;
    public damageBuildings?: boolean;
    public damageFences?: boolean;
    public damageCultural?: boolean;
    public damageBiodiversity?: boolean;
    public damageNative?: boolean;
    public damageCompetition?: boolean;
    public damageAgricultural?: boolean;
    public damageTucker?: boolean;
    public damageSafety?: boolean;
    public damageRoad?: boolean;
    public damageEnjoyment?: boolean;
    public damageOther?: boolean;
    public damageOtherSpec: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventDamageCamel>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageDeer implements ISiteEventDamageDeer
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public damageLivestock?: boolean;
    public damageCrops?: boolean;
    public damageNativeVegetation?: boolean;
    public damageTreePlanting?: boolean;
    public damageWeeds?: boolean;
    public damageSoil?: boolean;
    public damageFences?: boolean;
    public damageBrowsingSensitive?: boolean;
    public damageWater?: boolean;
    public damageDisease?: boolean;
    public damageDiseaseSpread?: boolean;
    public damageSacred?: boolean;
    public damageTucker?: boolean;
    public damageEcoTourism?: boolean;
    public damageNearCollisionVehicle?: boolean;
    public damageVehicle?: boolean;
    public damageOther?: boolean;
    public damageOtherSpec: string;
    public damageNativeHerbivores?: boolean;
    public damagePlantation?: boolean;
    public damageFruitTree?: boolean;
    public damageVineyard?: boolean;
    public damageTrampleCrops?: boolean;
    public damageNutCereal?: boolean;
    public damageVegeCrop?: boolean;
    public damageMarketGarden?: boolean;
    public damageAggressive?: boolean;
    public damageFlowers?: boolean;
    public propertyName: string;
    public siteNumber: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventDamageDeer>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralCat implements ISiteEventDamageFeralCat
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public damageNativeReptiles?: boolean;
    public damageDomesticGoats?: boolean;
    public damageNativeBirds?: boolean;
    public damageNativeFrogs?: boolean;
    public damageDomesticPoultry?: boolean;
    public damageDomestic?: boolean;
    public damageDomesticLambs?: boolean;
    public damageNative?: boolean;
    public damageNativeMammals?: boolean;
    public damageDomesticOther?: boolean;
    public damageDomesticBirds?: boolean;
    public damageOther?: boolean;
    public damageOtherSpec: string;
    public damageDomesticOtherSpec: string;
    public testData?: boolean;
    public damageAnnoyance?: boolean;
    public siteNumber: string;
    public propertyName: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventDamageFeralCat>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralFish implements ISiteEventDamageFeralFish
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public damageCompetition?: boolean;
    public damageRiverErosion?: boolean;
    public damageRiverSedimentation?: boolean;
    public damageMacrophyte?: boolean;
    public damageInvertebrates?: boolean;
    public damageNativeAnimals?: boolean;
    public damageCreationalFishing?: boolean;
    public damageEcoTourism?: boolean;
    public damageOther?: boolean;
    public damageOtherSpec: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventDamageFeralFish>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralGoat implements ISiteEventDamageFeralGoat
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public damageLivestock?: boolean;
    public damageCrops?: boolean;
    public damageNativeVegetation?: boolean;
    public damageTreePlanting?: boolean;
    public damageWeeds?: boolean;
    public damageSoil?: boolean;
    public damageFences?: boolean;
    public damageBrowsingSensitive?: boolean;
    public damageWater?: boolean;
    public damageDisease?: boolean;
    public damageDiseaseSpread?: boolean;
    public damageSacred?: boolean;
    public damageTucker?: boolean;
    public damageEcoTourism?: boolean;
    public damageOther?: boolean;
    public damageOtherSpec: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventDamageFeralGoat>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralPig implements ISiteEventDamageFeralPig
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public damagePredationLambs?: boolean;
    public damageLivestock?: boolean;
    public damageCrops?: boolean;
    public damageFruit?: boolean;
    public damageNative?: boolean;
    public damageWeeds?: boolean;
    public damageSoil?: boolean;
    public damageDisease?: boolean;
    public damageDiseaseSpread?: boolean;
    public damageWetlands?: boolean;
    public damageWater?: boolean;
    public damageSacred?: boolean;
    public damageTucker?: boolean;
    public damageFences?: boolean;
    public damageHuman?: boolean;
    public damageEcoTourism?: boolean;
    public damageOther?: boolean;
    public damageOtherSpec: string;
    public propertyName: string;
    public siteNumber: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventDamageFeralPig>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFox implements ISiteEventDamageFox
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public damageLambsOrGoatKids?: boolean;
    public damageNative?: boolean;
    public damagePoultry?: boolean;
    public damagePets?: boolean;
    public damageWeeds?: boolean;
    public damageDisease?: boolean;
    public damageOther?: boolean;
    public damageOtherSpec: string;
    public damageSheep?: boolean;
    public damageSheepNumberKilled: string;
    public damageSheepNumberMauled: string;
    public damageLambs?: boolean;
    public damageLambsNumberKilled: string;
    public damageLambsNumberMauled: string;
    public damageGoats?: boolean;
    public damageGoatsNumberKilled: string;
    public damageGoatsNumberMauled: string;
    public damageGoatKids?: boolean;
    public damageGoatKidsNumberKilled: string;
    public damageGoatKidsNumberMauled: string;
    public damagePoultryNumberKilled: string;
    public damagePoultryNumberMauled: string;
    public damagePetsNumberKilled: string;
    public damagePetsNumberMauled: string;
    public siteNumber: string;
    public propertyName: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventDamageFox>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageMouse implements ISiteEventDamageMouse
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventDamageMouse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageMyna implements ISiteEventDamageMyna
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public propertyName: string;
    public siteNumber: string;
    public damageRoof?: boolean;
    public damageNative?: boolean;
    public damageCrops?: boolean;
    public damageScavenging?: boolean;
    public damageSocialGrounds?: boolean;
    public damagePets?: boolean;
    public damagePetFood?: boolean;
    public damageRoosting?: boolean;
    public damageHumans?: boolean;
    public damageFoodStock?: boolean;
    public damageHome?: boolean;
    public damageBirdDroppings?: boolean;
    public damageOther?: boolean;
    public damageOtherSpec: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventDamageMyna>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageOtherPests implements ISiteEventDamageOtherPests
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public propertyName: string;
    public siteNumber: string;
    public subSpeciesId?: number;
    public damageRoad: boolean;
    public damageSafety: boolean;
    public damageLivestockCompetition: boolean;
    public damageNativeCompetition: boolean;
    public damageNativeVegetation: boolean;
    public damageSensitiveVegetation: boolean;
    public damageWeeds: boolean;
    public damageWetland: boolean;
    public damageBiodiversity: boolean;
    public damageWater: boolean;
    public damageBuildings: boolean;
    public damageFences: boolean;
    public damageCultural: boolean;
    public damageTucker: boolean;
    public damageLivestockDisease: boolean;
    public damageNuisance: boolean;
    public damageOther: boolean;
    public damageOtherSpec: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventDamageOtherPests>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageRabbit implements ISiteEventDamageRabbit
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public damageCompetitionPasture?: boolean;
    public damageSoil?: boolean;
    public damageProductivity?: boolean;
    public damageBuildings?: boolean;
    public damageNativeVeg?: boolean;
    public damageWeeds?: boolean;
    public damageCompetitionAnimals?: boolean;
    public damageSites?: boolean;
    public damageGarden?: boolean;
    public damageBiodiversity?: boolean;
    public damageCrops?: boolean;
    public damagePrograms?: boolean;
    public damageVehicles?: boolean;
    public damageSport?: boolean;
    public damageDigging?: boolean;
    public damageOther?: boolean;
    public damageOtherSpec: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public siteNumber: string;
    public propertyName: string;

    public constructor(init?: Partial<SiteEventDamageRabbit>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageStarling implements ISiteEventDamageStarling
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public damageRoof?: boolean;
    public damageNative?: boolean;
    public damageCrops?: boolean;
    public damageScavenging?: boolean;
    public damageSocialGrounds?: boolean;
    public damagePets?: boolean;
    public damagePetFood?: boolean;
    public damageRoosting?: boolean;
    public damageHumans?: boolean;
    public damageFoodStock?: boolean;
    public damageHome?: boolean;
    public damageBirdDroppings?: boolean;
    public damageOther?: boolean;
    public damageOtherSpec: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventDamageStarling>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageToad implements ISiteEventDamageToad
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    // @Ignore()
    public emailNsw: string;

    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public damagePoison?: boolean;
    public damagePets?: boolean;
    public damageHome?: boolean;
    public damageWater?: boolean;
    public damageNative?: boolean;
    public damageBees?: boolean;
    public damagePublic?: boolean;
    public damageHumans?: boolean;
    public damageSwimmingPools?: boolean;
    public damageCompetition?: boolean;
    public damageDungBeetles?: boolean;
    public damageFinacial?: boolean;
    public damageTucker?: boolean;
    public damageSacred?: boolean;
    public damageEcoTourism?: boolean;
    public damageOther?: boolean;
    public damageOtherSpec: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    public propertyName: string;
    public siteNumber?: string;
    public phoneNumber?: string;
    public fullName?: string;
    public streetAddress?: string;
    public adminAssessmentScore?: number;
    public adminNotes?: string;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventDamageToad>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageWildDog implements ISiteEventDamageWildDog
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public damageSheep?: boolean;
    public damageSheepNumberKilled: string;
    public damageSheepNumberMauled: string;
    public damageGoats?: boolean;
    public damageGoatsNumberKilled: string;
    public damageGoatsNumberMauled: string;
    public damageCalves?: boolean;
    public damageCalvesNumberKilled: string;
    public damageCalvesNumberMauled: string;
    public damageCattle?: boolean;
    public damageCattleNumberKilled: string;
    public damageCattleNumberMauled: string;
    public damagePoultry?: boolean;
    public damagePoultryNumberKilled: string;
    public damagePoultryNumberMauled: string;
    public damageDomestic?: boolean;
    public damageDomesticNumberKilled: string;
    public damageDomesticNumberMauled: string;
    public damageDogs?: boolean;
    public damageNative?: boolean;
    public damageHuman?: boolean;
    public damageAttackHuman?: boolean;
    public damageRubbish?: boolean;
    public damageHorses?: boolean;
    public damageOther?: boolean;
    public damageOtherSpec: string;
    public damageLambs?: boolean;
    public damageLambsNumberKilled: string;
    public damageLambsNumberMauled: string;
    public damageGoatKids?: boolean;
    public damageGoatKidsNumberKilled: string;
    public damageGoatKidsNumberMauled: string;
    public damageDogsNumberKilled: string;
    public damageDogsNumberMauled: string;
    public siteNumber: string;
    public propertyName: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventDamageWildDog>) { (Object as any).assign(this, init); }
}

export class SiteEventDiseaseRabbit implements ISiteEventDiseaseRabbit
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public diseaseTypeScore?: number;
    public samplingKit?: number;
    public postalAddress: string;
    public diseaseStatusScore?: number;
    public broadscaleSite?: boolean;
    public uniqueLabel: string;
    public vialNumber: string;
    public siteNumber: string;
    public k5ReleasedRecently?: number;
    public rabbitTypeScore?: number;
    public petBreed: string;
    public petNumberAtRisk: string;
    public petNumberSick: string;
    public petNumberDead: string;
    public vaccinatedScore?: number;
    public juvenileScore?: number;
    public sexScore?: number;
    public k5ReleasedRecentlyDate?: string;
    public vaccinatedDate?: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventDiseaseRabbit>) { (Object as any).assign(this, init); }
}

export class SiteEventManagementDeer implements ISiteEventManagementDeer
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public latitude: string;
    public longitude: string;
    public approved?: boolean;
    public geoPoint: MyGeographyDto;
    public dateFrom?: string;
    public dateTo?: string;
    public aggregateDateFrom?: string;
    public aggregateDateTo?: string;
    public title: string;
    public regionId?: number;
    public showLocationOnPopup?: boolean;
    public showKml?: boolean;
    public displaySighting?: boolean;
    public displayDamage?: boolean;
    public displayControl?: boolean;
    public displayDiseased?: boolean;
    public customDataGroupTitle: string;
    public customDataSubTitles: string;
    public customDataDetails: string;
    public recordTypeId?: number;
    public details: string;
    public additionalInfoLink: string;
    public enteredByUserId?: number;
    public modifiedByUserId?: number;
    public obsolete?: boolean;
    public platformType?: number;
    public dateEntered: string;
    public comments: string;
    public email: string;
    public parentId?: number;
    public privateData?: boolean;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public state: string;
    public startDateTime?: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventManagementDeer>) { (Object as any).assign(this, init); }
}

export class SiteEventManagementWildDog implements ISiteEventManagementWildDog
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public latitude: string;
    public longitude: string;
    public approved?: boolean;
    public geoPoint: MyGeographyDto;
    public dateFrom?: string;
    public dateTo?: string;
    public aggregateDateFrom?: string;
    public aggregateDateTo?: string;
    public title: string;
    public regionId?: number;
    public showLocationOnPopup?: boolean;
    public showKml?: boolean;
    public displaySighting?: boolean;
    public displayDamage?: boolean;
    public displayControl?: boolean;
    public displayDiseased?: boolean;
    public customDataGroupTitle: string;
    public customDataSubTitles: string;
    public customDataDetails: string;
    public recordTypeId?: number;
    public details: string;
    public additionalInfoLink: string;
    public enteredByUserId?: number;
    public modifiedByUserId?: number;
    public obsolete?: boolean;
    public platformType?: number;
    public dateEntered: string;
    public comments: string;
    public email: string;
    public parentId?: number;
    public privateData?: boolean;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public state: string;
    public startDateTime?: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventManagementWildDog>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingCamel implements ISiteEventSightingCamel
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public camelAbundanceScore?: number;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventSightingCamel>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingDeer implements ISiteEventSightingDeer
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public deerAbundanceScore?: number;
    public subSpeciesId?: number;
    public deerAgeScore?: number;
    public deerSexScore?: number;
    public propertyName: string;
    public siteNumber: string;
    public deerSightingType?: number;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventSightingDeer>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralCat implements ISiteEventSightingFeralCat
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public siteNumber: string;
    public propertyName: string;
    public startDateTime?: string;
    public feralCatAbundanceScore?: number;
    public feralCatSightingType?: number;
    public feralCatSightingAgeScore?: number;
    public feralCatSightingTypeScat?: boolean;
    public feralCatSightingTypeTrack?: boolean;
    public feralCatSightingTypeOdour?: boolean;
    public feralCatColourScore?: number;
    public feralCatSexScore?: number;
    public feralCatColourOtherSpec: string;
    public feralCatHabitatRoadside?: boolean;
    public feralCatHabitatVegetation?: boolean;
    public feralCatHabitatFarmland?: boolean;
    public feralCatHabitatOther?: boolean;
    public feralCatHabitatOtherSpec: string;
    public testData?: boolean;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventSightingFeralCat>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralFish implements ISiteEventSightingFeralFish
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public testData?: boolean;
    public subSpeciesId?: number;
    public feralFishSightingType?: number;
    public feralFishSize?: number;
    public behaviourSpawning?: boolean;
    public behaviourSchooling?: boolean;
    public behaviourFeeding?: boolean;
    public behaviourSwimming?: boolean;
    public behaviourNotApplicable?: boolean;
    public behaviourOther?: boolean;
    public behaviourOtherSpec: string;
    public feralFishAbundanceScore?: number;
    public feralFishHabitat?: number;
    public feralFishHabitatOtherSpec: string;
    public microHabitatLogsSnags?: boolean;
    public microHabitatAmongRocks?: boolean;
    public microHabitatOpenWaterAtSurface?: boolean;
    public microHabitatAmongWaterPlants?: boolean;
    public microHabitatAtWatersEdge?: boolean;
    public microHabitatOther?: boolean;
    public microHabitatOtherSpec: string;
    public habitatDegradationTurbidMuddyWater?: boolean;
    public habitatDegradationInstreamBankErosion?: boolean;
    public habitatDegradationErosionInRiparianZone?: boolean;
    public habitatDegradationWillowsPresent?: boolean;
    public habitatDegradationLivestockPresent?: boolean;
    public habitatDegradationSiltSandBuildUp?: boolean;
    public habitatDegradationNoDegradation?: boolean;
    public habitatDegradationOther?: boolean;
    public habitatDegradationOtherSpec: string;
    public feralFishSpeciesOther: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventSightingFeralFish>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralGoat implements ISiteEventSightingFeralGoat
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public feralGoatAbundanceScore?: number;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public propertyName: string;
    public siteNumber?: string;
    public feralGoatAbundanceScoreNew?: number;
    public feralGoatSightingTypeScore?: number;
    public sexMale?: boolean;
    public sexFemale?: boolean;
    public sexBoth?: boolean;
    public sexUnknown?: boolean;

    public constructor(init?: Partial<SiteEventSightingFeralGoat>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralPig implements ISiteEventSightingFeralPig
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public feralPigAbundanceScore?: number;
    public feralPigSightingType?: number;
    public propertyName: string;
    public siteNumber: string;
    public ageScore?: number;
    public sexScore?: number;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventSightingFeralPig>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFox implements ISiteEventSightingFox
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public foxSightingType?: number;
    public foxAbundanceScore?: number;
    public foxNightScore?: number;
    public foxAbundanceScoreNew?: number;
    public foxSightingAgeScore?: number;
    public siteNumber: string;
    public propertyName: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventSightingFox>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingMouse implements ISiteEventSightingMouse
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public testData?: boolean;
    public mouseCroppingStageScore?: number;
    public mouseAbundanceNotAssessed?: boolean;
    public mouseAbundanceScore?: number;
    public mouseAbundanceEstimate?: number;
    public mouseAbundanceEstimateSpec: string;
    public damageSeenPasture?: number;
    public damageSeenFarmBuildings?: number;
    public damageSeenStubble?: number;
    public damageSeenStubbleWheat?: number;
    public damageSeenStubbleCanola?: number;
    public damageSeenStubbleSorghum?: number;
    public damageSeenStubbleBarley?: number;
    public damageSeenStubbleOther?: number;
    public damageSeenStubbleOtherSpec: string;
    public damageSeenCrop?: number;
    public damageSeenCropWheat?: number;
    public damageSeenCropCanola?: number;
    public damageSeenCropSorghum?: number;
    public damageSeenCropBarley?: number;
    public damageSeenCropOther?: number;
    public damageSeenCropOtherSpec: string;
    public damageNone?: boolean;
    public damageScore?: number;
    public damageWheat?: boolean;
    public damageStoredGrain?: boolean;
    public damageElecOrMachinery?: boolean;
    public damageNuisance?: boolean;
    public damageCanola?: boolean;
    public damageSorghum?: boolean;
    public damageBarley?: boolean;
    public damageOther?: boolean;
    public damageOtherSpec: string;
    public damageTotalArea: string;
    public damageOccurredSowing?: boolean;
    public damageOccurredSeedling?: boolean;
    public damageOccurredTillering?: boolean;
    public damageOccurredFlowering?: boolean;
    public damageOccurredPriorToHarvest?: boolean;
    public damageOccurredOther?: boolean;
    public damageOccurredOtherSpec: string;
    public techniqueNone?: boolean;
    public techniqueBurnStubble?: boolean;
    public techniqueSprayWeeds?: boolean;
    public techniqueCultivate?: boolean;
    public techniqueBaitWithPoison?: boolean;
    public techniqueSetMouseTraps?: boolean;
    public techniqueCoverFood?: boolean;
    public techniqueOther?: boolean;
    public techniqueOtherSpec: string;
    public poisonBaitApplication?: number;
    public poisonBaitApplicationOtherSpec: string;
    public farmingCroppingOnly?: boolean;
    public farmingCropping80Grazing20?: boolean;
    public farmingCropping50Grazing50?: boolean;
    public farmingConservationDirectDrill?: boolean;
    public farmingIrrigation?: boolean;
    public farmingOther?: boolean;
    public farmingOtherSpec: string;
    public mobile: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventSightingMouse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingMyna implements ISiteEventSightingMyna
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public propertyName: string;
    public siteNumber: string;
    public mynaAbundanceScore?: number;
    public mynaNestingScore?: number;
    public mynaRoostingScore?: number;
    public mynaSightingType?: number;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventSightingMyna>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingNewPests implements ISiteEventSightingNewPests
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public siteNumber: string;
    public phoneNumber: string;
    public fullName: string;
    public streetAddress: string;
    public species?: number;
    public sightingDescription: string;
    public abundance?: number;
    public describeWhere: string;
    public possession?: number;
    public type?: number;
    public agreeShareReport?: boolean;
    public adminAssessment?: number;
    public adminEnvironment?: number;
    public adminNotes: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventSightingNewPests>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingOtherPests implements ISiteEventSightingOtherPests
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    public propertyName: string;
    public siteNumber: string;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public otherPestsAbundanceScore?: number;
    public subSpeciesId?: number;
    public sightingType?: number;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventSightingOtherPests>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingRabbit implements ISiteEventSightingRabbit
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public inspectionArea?: number;
    public rabbitAbundanceScore?: number;
    public rabbitDungSightings?: number;
    public rabbitWarrensBurrows?: number;
    public rabbitAbundanceScoreOld?: number;
    public rabbitSpotlightAbundanceScore?: number;
    public rabbitActiveEntrancesScore?: number;
    public k5Released: boolean;
    public broadscaleSite: boolean;
    public siteNumber: string;
    public propertyName: string;
    public spotlightTransectLength?: number;
    public spotlightCount1?: number;
    public spotlightCount2?: number;
    public spotlightCount3?: number;
    public platformVersion: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventSightingRabbit>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingStarling implements ISiteEventSightingStarling
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public starlingAbundanceScore?: number;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventSightingStarling>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingToad implements ISiteEventSightingToad
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    // @Ignore()
    public emailNsw: string;

    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public phoneNumber: string;
    public fullName: string;
    public streetAddress: string;
    public describeWhere: string;
    public toadAbundanceScore?: number;
    public age?: number;
    public possessionScore?: number;
    public typeScore?: number;
    public removedFromEnvironment?: number;
    public administratorAssessment?: number;
    public administratorNotes: string;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    public audioRecordingScore?: number;
    public propertyName: string;
    public siteNumber?: string;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventSightingToad>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingWildDog implements ISiteEventSightingWildDog
{
    [immerable] = true;

    public id?: number;
    public userId?: number;
    public modifiedByUserId?: number;
    public latitude: string;
    public longitude: string;
    public geoPoint: MyGeographyDto;
    public obsolete?: boolean;
    public parentId?: number;
    public platformType?: number;
    // @Ignore()
    public sightingTypeId: SiteEventType;

    public comments: string;
    public dateEntered: string;
    public email: string;
    public privateData?: boolean;
    public state: string;
    public startDateTime?: string;
    public wildDogAbundanceScore?: number;
    public wildDogSightingType?: number;
    public wildDogSightingAgeScore?: number;
    public siteNumber: string;
    public propertyName: string;
    public sex?: number;
    public colour?: number;
    public recommendationMonitor?: boolean;
    public recommendationMonitorScore?: number;
    public recommendationConsider?: boolean;
    public recommendationConsiderScore?: number;
    public recommendationNone?: boolean;
    public recommendationOther?: boolean;
    public uuid?: string;
    public llsRegionId?: number;
    public lgaRegionId?: number;
    // @Ignore()
    public guid?: string;

    public constructor(init?: Partial<SiteEventSightingWildDog>) { (Object as any).assign(this, init); }
}

export enum FormFieldType
{
    TextField = 1,
    TextArea = 2,
    NumberField = 3,
    NumberScroll = 4,
    Date = 5,
    DateTime = 6,
    Time = 7,
    Radio = 8,
    RadioGroup = 9,
    Checkbox = 10,
    CheckboxGroup = 11,
    Dropdown = 12,
    Custom = 13,
    GoogleAutocomplete = 14,
    AutoSuggest = 15,
    DropdownWithNumber = 16,
}

export enum TitlePosition
{
    Left = 1,
    Top = 2,
    TopLeft = 3,
    TopRight = 4,
    Right = 5,
}

export enum FormValidationType
{
    Required = 1,
    Equal = 2,
    NotEqual = 3,
    GreaterThan = 4,
    GreaterThanOrEqual = 5,
    LessThan = 6,
    LessThanOrEqual = 7,
    Email = 8,
    Regex = 9,
    Custom = 10,
}

// @DataContract
export class FormValidation
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public parentId?: number;

    // @DataMember(Order=3)
    public fieldId: number;

    // @DataMember(Order=4)
    public fieldType: FormFieldType;

    // @DataMember(Order=5)
    public validationType: FormValidationType;

    // @DataMember(Order=6)
    public meta?: { [index: string]: string; };

    // @DataMember(Order=7)
    public children?: FormValidation[];

    public constructor(init?: Partial<FormValidation>) { (Object as any).assign(this, init); }
}

export enum ConditionType
{
    Equal = 1,
    NotEqual = 2,
    GreaterThan = 3,
    GreaterThanOrEqual = 4,
    LessThan = 5,
    LessThanOrEqual = 6,
    Custom = 7,
}

// @DataContract
export class FormFieldDisplayCondition
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public fieldId: number;

    // @DataMember(Order=3)
    public fieldType: FormFieldType;

    // @DataMember(Order=4)
    public condition: ConditionType;

    // @DataMember(Order=5)
    public targetName: string;

    // @DataMember(Order=6)
    public targetValue: string;

    // @DataMember(Order=7)
    public meta?: { [index: string]: string; };

    // @DataMember(Order=8)
    public children?: FormFieldDisplayCondition[];

    // @DataMember(Order=9)
    public parentId?: number;

    public constructor(init?: Partial<FormFieldDisplayCondition>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AutoSuggestFormField implements IFormField, IHasParent, IFormFieldRow, IFormFieldRowNative, IFormFieldTitle, IFormFieldTitleNative
{
    [immerable] = true;

    public static __name = 'AutoSuggestFormField';

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public questionId?: number;

    // @DataMember(Order=3)
    public fieldType?: FormFieldType;

    // @DataMember(Order=4)
    public isNative?: boolean;

    // @DataMember(Order=5)
    public name?: string;

    // @DataMember(Order=6)
    public order: number;

    // @DataMember(Order=7)
    public parentId?: number;

    // @DataMember(Order=8)
    public parentType?: FormFieldType;

    // @DataMember(Order=9)
    public title?: string;

    // @DataMember(Order=10)
    public titleWidth?: number;

    // @DataMember(Order=11)
    public titleHeight?: number;

    // @DataMember(Order=12)
    public titlePos?: TitlePosition;

    // @DataMember(Order=13)
    public titleNative?: string;

    // @DataMember(Order=14)
    public titleNativeWidth?: number;

    // @DataMember(Order=15)
    public titleNativeHeight?: number;

    // @DataMember(Order=16)
    public titleNativePos?: TitlePosition;

    // @DataMember(Order=17)
    public row?: boolean;

    // @DataMember(Order=18)
    public rowRatio?: number;

    // @DataMember(Order=19)
    public rowNative?: boolean;

    // @DataMember(Order=20)
    public rowNativeRatio?: number;

    // @DataMember(Order=21)
    public default?: string;

    // @DataMember(Order=22)
    public placeholder?: string;

    // @DataMember(Order=23)
    public maxSuggestions?: number;

    // @DataMember(Order=24)
    public validation?: FormValidation[];

    // @DataMember(Order=25)
    public conditions?: FormFieldDisplayCondition[];

    public constructor(init?: Partial<AutoSuggestFormField>) { (Object as any).assign(this, init); }
}

export interface IFormField extends IFormFieldValidation, IFormFieldDisplayCondition
{
    id?: number;
    questionId?: number;
    fieldType?: FormFieldType;
    isNative?: boolean;
    name?: string;
    order: number;
}

// @DataContract
export class CheckboxFormField implements IFormField, IHasParent, IHasChildren, IFormFieldRow, IFormFieldRowNative, IFormFieldTitle, IFormFieldTitleNative
{
    [immerable] = true;

    public static __name = 'CheckboxFormField';

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public questionId?: number;

    // @DataMember(Order=3)
    public fieldType?: FormFieldType;

    // @DataMember(Order=4)
    public isNative?: boolean;

    // @DataMember(Order=5)
    public name?: string;

    // @DataMember(Order=6)
    public order: number;

    // @DataMember(Order=7)
    public parentId?: number;

    // @DataMember(Order=8)
    public parentType?: FormFieldType;

    // @DataMember(Order=9)
    public children?: IFormField[];

    // @DataMember(Order=10)
    public title?: string;

    // @DataMember(Order=11)
    public titleWidth?: number;

    // @DataMember(Order=12)
    public titleHeight?: number;

    // @DataMember(Order=13)
    public titlePos?: TitlePosition;

    // @DataMember(Order=14)
    public titleNative?: string;

    // @DataMember(Order=15)
    public titleNativeWidth?: number;

    // @DataMember(Order=16)
    public titleNativeHeight?: number;

    // @DataMember(Order=17)
    public titleNativePos?: TitlePosition;

    // @DataMember(Order=18)
    public row?: boolean;

    // @DataMember(Order=19)
    public rowRatio?: number;

    // @DataMember(Order=20)
    public rowNative?: boolean;

    // @DataMember(Order=21)
    public rowNativeRatio?: number;

    // @DataMember(Order=22)
    public checked?: boolean;

    // @DataMember(Order=23)
    public validation?: FormValidation[];

    // @DataMember(Order=24)
    public conditions?: FormFieldDisplayCondition[];

    // @DataMember(Order=25)
    public checkboxGroupId?: number;

    public constructor(init?: Partial<CheckboxFormField>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CheckboxGroupFormField implements IFormField, IHasParent
{
    [immerable] = true;

    public static __name = 'CheckboxGroupFormField';

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public questionId?: number;

    // @DataMember(Order=3)
    public fieldType?: FormFieldType;

    // @DataMember(Order=4)
    public isNative?: boolean;

    // @DataMember(Order=5)
    public name?: string;

    // @DataMember(Order=6)
    public order: number;

    // @DataMember(Order=7)
    public parentId?: number;

    // @DataMember(Order=8)
    public parentType?: FormFieldType;

    // @DataMember(Order=9)
    public checkboxes?: CheckboxFormField[];

    // @DataMember(Order=10)
    public validation?: FormValidation[];

    // @DataMember(Order=11)
    public conditions?: FormFieldDisplayCondition[];

    public constructor(init?: Partial<CheckboxGroupFormField>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CustomFormField implements IFormField, IHasParent, IFormFieldRow, IFormFieldRowNative
{
    [immerable] = true;

    public static __name = 'CustomFormField';

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public questionId?: number;

    // @DataMember(Order=3)
    public fieldType?: FormFieldType;

    // @DataMember(Order=4)
    public isNative?: boolean;

    // @DataMember(Order=5)
    public row?: boolean;

    // @DataMember(Order=6)
    public rowRatio?: number;

    // @DataMember(Order=7)
    public rowNative?: boolean;

    // @DataMember(Order=8)
    public rowNativeRatio?: number;

    // @DataMember(Order=9)
    public name?: string;

    // @DataMember(Order=10)
    public order: number;

    // @DataMember(Order=11)
    public parentId?: number;

    // @DataMember(Order=12)
    public parentType?: FormFieldType;

    // @DataMember(Order=13)
    public validation?: FormValidation[];

    // @DataMember(Order=14)
    public conditions?: FormFieldDisplayCondition[];

    // @DataMember(Order=15)
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<CustomFormField>) { (Object as any).assign(this, init); }
}

export enum DateTimeDefaultType
{
    Now = 1,
}

// @DataContract
export class DateFormField implements IFormField, IHasParent, IFormFieldRow, IFormFieldRowNative, IFormFieldTitle, IFormFieldTitleNative
{
    [immerable] = true;

    public static __name = 'DateFormField';

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public questionId?: number;

    // @DataMember(Order=3)
    public fieldType?: FormFieldType;

    // @DataMember(Order=4)
    public isNative?: boolean;

    // @DataMember(Order=5)
    public name?: string;

    // @DataMember(Order=6)
    public order: number;

    // @DataMember(Order=7)
    public parentId?: number;

    // @DataMember(Order=8)
    public parentType?: FormFieldType;

    // @DataMember(Order=9)
    public title?: string;

    // @DataMember(Order=10)
    public titleWidth?: number;

    // @DataMember(Order=11)
    public titleHeight?: number;

    // @DataMember(Order=12)
    public titlePos?: TitlePosition;

    // @DataMember(Order=13)
    public titleNative?: string;

    // @DataMember(Order=14)
    public titleNativeWidth?: number;

    // @DataMember(Order=15)
    public titleNativeHeight?: number;

    // @DataMember(Order=16)
    public titleNativePos?: TitlePosition;

    // @DataMember(Order=17)
    public row?: boolean;

    // @DataMember(Order=18)
    public rowRatio?: number;

    // @DataMember(Order=19)
    public rowNative?: boolean;

    // @DataMember(Order=20)
    public rowNativeRatio?: number;

    // @DataMember(Order=21)
    public default?: DateTimeDefaultType;

    // @DataMember(Order=22)
    public validation?: FormValidation[];

    // @DataMember(Order=23)
    public conditions?: FormFieldDisplayCondition[];

    public constructor(init?: Partial<DateFormField>) { (Object as any).assign(this, init); }
}

// @DataContract
export class DropdownFormFieldOption
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public dropdownFormFieldId?: number;

    // @DataMember(Order=3)
    public name: string;

    // @DataMember(Order=4)
    public title: string;

    // @DataMember(Order=5)
    public value: number;

    // @DataMember(Order=6)
    public order: number;

    public constructor(init?: Partial<DropdownFormFieldOption>) { (Object as any).assign(this, init); }
}

// @DataContract
export class DropdownFormField implements IFormField, IHasParent, IFormFieldTitle, IFormFieldTitleNative, IFormFieldRow, IFormFieldRowNative
{
    [immerable] = true;

    public static __name = 'DropdownFormField';

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public questionId?: number;

    // @DataMember(Order=3)
    public fieldType?: FormFieldType;

    // @DataMember(Order=4)
    public isNative?: boolean;

    // @DataMember(Order=5)
    public name?: string;

    // @DataMember(Order=6)
    public order: number;

    // @DataMember(Order=7)
    public parentId?: number;

    // @DataMember(Order=8)
    public parentType?: FormFieldType;

    // @DataMember(Order=9)
    public title?: string;

    // @DataMember(Order=10)
    public titleWidth?: number;

    // @DataMember(Order=11)
    public titleHeight?: number;

    // @DataMember(Order=12)
    public titlePos?: TitlePosition;

    // @DataMember(Order=13)
    public titleNative?: string;

    // @DataMember(Order=14)
    public titleNativeWidth?: number;

    // @DataMember(Order=15)
    public titleNativeHeight?: number;

    // @DataMember(Order=16)
    public titleNativePos?: TitlePosition;

    // @DataMember(Order=17)
    public row?: boolean;

    // @DataMember(Order=18)
    public rowRatio?: number;

    // @DataMember(Order=19)
    public rowNative?: boolean;

    // @DataMember(Order=20)
    public rowNativeRatio?: number;

    // @DataMember(Order=21)
    public default?: number;

    // @DataMember(Order=22)
    public dropdownOptions?: DropdownFormFieldOption[];

    // @DataMember(Order=23)
    public validation?: FormValidation[];

    // @DataMember(Order=24)
    public conditions?: FormFieldDisplayCondition[];

    // @DataMember(Order=25)
    public nullOption?: boolean;

    public constructor(init?: Partial<DropdownFormField>) { (Object as any).assign(this, init); }
}

// @DataContract
export class DropdownWithNumberFormField implements IFormField, IHasParent, IFormFieldTitle, IFormFieldTitleNative, IFormFieldRow, IFormFieldRowNative
{
    [immerable] = true;

    public static __name = 'DropdownWithNumberFormField';

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public questionId?: number;

    // @DataMember(Order=3)
    public fieldType?: FormFieldType;

    // @DataMember(Order=4)
    public isNative?: boolean;

    // @DataMember(Order=5)
    public name?: string;

    // @DataMember(Order=6)
    public order: number;

    // @DataMember(Order=7)
    public parentId?: number;

    // @DataMember(Order=8)
    public parentType?: FormFieldType;

    // @DataMember(Order=9)
    public title?: string;

    // @DataMember(Order=10)
    public titleWidth?: number;

    // @DataMember(Order=11)
    public titleHeight?: number;

    // @DataMember(Order=12)
    public titlePos?: TitlePosition;

    // @DataMember(Order=13)
    public titleNative?: string;

    // @DataMember(Order=14)
    public titleNativeWidth?: number;

    // @DataMember(Order=15)
    public titleNativeHeight?: number;

    // @DataMember(Order=16)
    public titleNativePos?: TitlePosition;

    // @DataMember(Order=17)
    public row?: boolean;

    // @DataMember(Order=18)
    public rowRatio?: number;

    // @DataMember(Order=19)
    public rowNative?: boolean;

    // @DataMember(Order=20)
    public rowNativeRatio?: number;

    // @DataMember(Order=21)
    public default?: number;

    // @DataMember(Order=22)
    public nullOption?: boolean;

    // @DataMember(Order=23)
    public minValue?: number;

    // @DataMember(Order=24)
    public maxValue?: number;

    // @DataMember(Order=25)
    public step?: number;

    // @DataMember(Order=26)
    public minLabel?: string;

    // @DataMember(Order=27)
    public maxLabel?: string;

    // @DataMember(Order=28)
    public validation?: FormValidation[];

    // @DataMember(Order=29)
    public conditions?: FormFieldDisplayCondition[];

    public constructor(init?: Partial<DropdownWithNumberFormField>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GoogleAutocompleteFormField implements IFormField, IHasParent, IFormFieldRow, IFormFieldRowNative, IFormFieldTitle, IFormFieldTitleNative
{
    [immerable] = true;

    public static __name = 'GoogleAutocompleteFormField';

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public questionId?: number;

    // @DataMember(Order=3)
    public fieldType?: FormFieldType;

    // @DataMember(Order=4)
    public isNative?: boolean;

    // @DataMember(Order=5)
    public name?: string;

    // @DataMember(Order=6)
    public order: number;

    // @DataMember(Order=7)
    public parentId?: number;

    // @DataMember(Order=8)
    public parentType?: FormFieldType;

    // @DataMember(Order=9)
    public title?: string;

    // @DataMember(Order=10)
    public titleWidth?: number;

    // @DataMember(Order=11)
    public titleHeight?: number;

    // @DataMember(Order=12)
    public titlePos?: TitlePosition;

    // @DataMember(Order=13)
    public titleNative?: string;

    // @DataMember(Order=14)
    public titleNativeWidth?: number;

    // @DataMember(Order=15)
    public titleNativeHeight?: number;

    // @DataMember(Order=16)
    public titleNativePos?: TitlePosition;

    // @DataMember(Order=17)
    public row?: boolean;

    // @DataMember(Order=18)
    public rowRatio?: number;

    // @DataMember(Order=19)
    public rowNative?: boolean;

    // @DataMember(Order=20)
    public rowNativeRatio?: number;

    // @DataMember(Order=21)
    public default?: string;

    // @DataMember(Order=22)
    public placeholder?: string;

    // @DataMember(Order=23)
    public validation?: FormValidation[];

    // @DataMember(Order=24)
    public conditions?: FormFieldDisplayCondition[];

    public constructor(init?: Partial<GoogleAutocompleteFormField>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RadioFormField implements IFormField, IHasParent, IHasChildren, IFormFieldTitle, IFormFieldTitleNative, IFormFieldRow, IFormFieldRowNative
{
    [immerable] = true;

    public static __name = 'RadioFormField';

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public questionId?: number;

    // @DataMember(Order=3)
    public fieldType?: FormFieldType;

    // @DataMember(Order=4)
    public isNative?: boolean;

    // @DataMember(Order=5)
    public name?: string;

    // @DataMember(Order=6)
    public order: number;

    // @DataMember(Order=7)
    public parentId?: number;

    // @DataMember(Order=8)
    public parentType?: FormFieldType;

    // @DataMember(Order=9)
    public children?: IFormField[];

    // @DataMember(Order=10)
    public title?: string;

    // @DataMember(Order=11)
    public titleWidth?: number;

    // @DataMember(Order=12)
    public titleHeight?: number;

    // @DataMember(Order=13)
    public titlePos?: TitlePosition;

    // @DataMember(Order=14)
    public titleNative?: string;

    // @DataMember(Order=15)
    public titleNativeWidth?: number;

    // @DataMember(Order=16)
    public titleNativeHeight?: number;

    // @DataMember(Order=17)
    public titleNativePos?: TitlePosition;

    // @DataMember(Order=18)
    public row?: boolean;

    // @DataMember(Order=19)
    public rowRatio?: number;

    // @DataMember(Order=20)
    public rowNative?: boolean;

    // @DataMember(Order=21)
    public rowNativeRatio?: number;

    // @DataMember(Order=22)
    public radioGroupId?: number;

    // @DataMember(Order=23)
    public value?: number;

    // @DataMember(Order=24)
    public validation?: FormValidation[];

    // @DataMember(Order=25)
    public conditions?: FormFieldDisplayCondition[];

    public constructor(init?: Partial<RadioFormField>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RadioGroupFormField implements IFormField, IHasParent, IFormFieldTitle, IFormFieldTitleNative, IFormFieldRow, IFormFieldRowNative
{
    [immerable] = true;

    public static __name = 'RadioGroupFormField';

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public questionId?: number;

    // @DataMember(Order=3)
    public fieldType?: FormFieldType;

    // @DataMember(Order=4)
    public isNative?: boolean;

    // @DataMember(Order=5)
    public name?: string;

    // @DataMember(Order=6)
    public order: number;

    // @DataMember(Order=7)
    public parentId?: number;

    // @DataMember(Order=8)
    public parentType?: FormFieldType;

    // @DataMember(Order=9)
    public title?: string;

    // @DataMember(Order=10)
    public titleWidth?: number;

    // @DataMember(Order=11)
    public titleHeight?: number;

    // @DataMember(Order=12)
    public titlePos?: TitlePosition;

    // @DataMember(Order=13)
    public titleNative?: string;

    // @DataMember(Order=14)
    public titleNativeWidth?: number;

    // @DataMember(Order=15)
    public titleNativeHeight?: number;

    // @DataMember(Order=16)
    public titleNativePos?: TitlePosition;

    // @DataMember(Order=17)
    public row?: boolean;

    // @DataMember(Order=18)
    public rowRatio?: number;

    // @DataMember(Order=19)
    public rowNative?: boolean;

    // @DataMember(Order=20)
    public rowNativeRatio?: number;

    // @DataMember(Order=21)
    public defaultValue?: number;

    // @DataMember(Order=22)
    public radios?: RadioFormField[];

    // @DataMember(Order=23)
    public validation?: FormValidation[];

    // @DataMember(Order=24)
    public conditions?: FormFieldDisplayCondition[];

    public constructor(init?: Partial<RadioGroupFormField>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TextFieldFormField implements IFormField, IHasParent, IFormFieldRow, IFormFieldRowNative, IFormFieldTitle, IFormFieldTitleNative
{
    [immerable] = true;

    public static __name = 'TextFieldFormField';

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public questionId?: number;

    // @DataMember(Order=3)
    public fieldType?: FormFieldType;

    // @DataMember(Order=4)
    public isNative?: boolean;

    // @DataMember(Order=5)
    public name?: string;

    // @DataMember(Order=6)
    public order: number;

    // @DataMember(Order=7)
    public parentId?: number;

    // @DataMember(Order=8)
    public parentType?: FormFieldType;

    // @DataMember(Order=9)
    public title?: string;

    // @DataMember(Order=10)
    public titleWidth?: number;

    // @DataMember(Order=11)
    public titleHeight?: number;

    // @DataMember(Order=12)
    public titlePos?: TitlePosition;

    // @DataMember(Order=13)
    public titleNative?: string;

    // @DataMember(Order=14)
    public titleNativeWidth?: number;

    // @DataMember(Order=15)
    public titleNativeHeight?: number;

    // @DataMember(Order=16)
    public titleNativePos?: TitlePosition;

    // @DataMember(Order=17)
    public row?: boolean;

    // @DataMember(Order=18)
    public rowRatio?: number;

    // @DataMember(Order=19)
    public rowNative?: boolean;

    // @DataMember(Order=20)
    public rowNativeRatio?: number;

    // @DataMember(Order=21)
    public default?: string;

    // @DataMember(Order=22)
    public textFieldType?: string;

    // @DataMember(Order=23)
    public validation?: FormValidation[];

    // @DataMember(Order=24)
    public conditions?: FormFieldDisplayCondition[];

    // @DataMember(Order=25)
    public placeholder?: string;

    public constructor(init?: Partial<TextFieldFormField>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TimeFormField implements IFormField, IHasParent, IFormFieldRow, IFormFieldRowNative, IFormFieldTitle, IFormFieldTitleNative
{
    [immerable] = true;

    public static __name = 'TimeFormField';

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public questionId?: number;

    // @DataMember(Order=3)
    public fieldType?: FormFieldType;

    // @DataMember(Order=4)
    public isNative?: boolean;

    // @DataMember(Order=5)
    public name?: string;

    // @DataMember(Order=6)
    public order: number;

    // @DataMember(Order=7)
    public parentId?: number;

    // @DataMember(Order=8)
    public parentType?: FormFieldType;

    // @DataMember(Order=9)
    public title?: string;

    // @DataMember(Order=10)
    public titleWidth?: number;

    // @DataMember(Order=11)
    public titleHeight?: number;

    // @DataMember(Order=12)
    public titlePos?: TitlePosition;

    // @DataMember(Order=13)
    public titleNative?: string;

    // @DataMember(Order=14)
    public titleNativeWidth?: number;

    // @DataMember(Order=15)
    public titleNativeHeight?: number;

    // @DataMember(Order=16)
    public titleNativePos?: TitlePosition;

    // @DataMember(Order=17)
    public row?: boolean;

    // @DataMember(Order=18)
    public rowRatio?: number;

    // @DataMember(Order=19)
    public rowNative?: boolean;

    // @DataMember(Order=20)
    public rowNativeRatio?: number;

    // @DataMember(Order=21)
    public default?: DateTimeDefaultType;

    // @DataMember(Order=22)
    public validation?: FormValidation[];

    // @DataMember(Order=23)
    public conditions?: FormFieldDisplayCondition[];

    public constructor(init?: Partial<TimeFormField>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseError
{
    [immerable] = true;

    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public fieldName: string;

    // @DataMember(Order=3)
    public message: string;

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ResponseError>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseStatus
{
    [immerable] = true;

    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public message: string;

    // @DataMember(Order=3)
    public stackTrace: string;

    // @DataMember(Order=4)
    public errors: ResponseError[];

    // @DataMember(Order=5)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ResponseStatus>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CommunityGroupExport
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public adminUserId?: number;

    // @DataMember(Order=3)
    public createdByUserId?: number;

    // @DataMember(Order=4)
    public name?: string;

    // @DataMember(Order=5)
    public dateEntered?: string;

    // @DataMember(Order=6)
    public dateModified?: string;

    // @DataMember(Order=7)
    public region?: string;

    // @DataMember(Order=8)
    public state?: string;

    // @DataMember(Order=9)
    public notes?: string;

    public constructor(init?: Partial<CommunityGroupExport>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CommunityGroupMemberExport
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id: number;

    // @DataMember(Order=2)
    public communityGroupId: number;

    // @DataMember(Order=3)
    public communityGroupName: string;

    // @DataMember(Order=4)
    public userId: number;

    // @DataMember(Order=5)
    public statusId: number;

    // @DataMember(Order=6)
    public status: string;

    // @DataMember(Order=7)
    public dateEntered: string;

    // @DataMember(Order=8)
    public dateModified: string;

    // @DataMember(Order=9)
    public downloadRights: boolean;

    // @DataMember(Order=10)
    public viewRights: boolean;

    public constructor(init?: Partial<CommunityGroupMemberExport>) { (Object as any).assign(this, init); }
}

// @DataContract
export class DataAccessRestrictedPolygon
{
    [immerable] = true;

    // @DataMember(Order=1)
    public name: string;

    // @DataMember(Order=2)
    public polygonStringLists: string[];

    public constructor(init?: Partial<DataAccessRestrictedPolygon>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ExternalRecordSyncSchedule
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id: number;

    // @DataMember(Order=2)
    public species: Species;

    // @DataMember(Order=3)
    public syncIntervalDays: number;

    // @DataMember(Order=4)
    public lastSyncDate?: string;

    public constructor(init?: Partial<ExternalRecordSyncSchedule>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CommunityGroupKmlFiles
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id: number;

    // @DataMember(Order=2)
    public communityGroupId?: number;

    // @DataMember(Order=3)
    public autoDisplay?: boolean;

    // @DataMember(Order=4)
    public clickable?: boolean;

    // @DataMember(Order=5)
    public name?: string;

    // @DataMember(Order=6)
    public kmlFileName?: string;

    // @DataMember(Order=7)
    public state?: string;

    // @DataMember(Order=8)
    public rank?: number;

    // @DataMember(Order=9)
    public dateEntered?: string;

    // @DataMember(Order=10)
    public dateModified?: string;

    // @DataMember(Order=11)
    public obsolete?: boolean;

    // @DataMember(Order=12)
    public parentId?: number;

    // @DataMember(Order=13)
    public includeInDropdown: boolean;

    // @DataMember(Order=14)
    public polygons?: string[];

    public constructor(init?: Partial<CommunityGroupKmlFiles>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CommunityGroupSpecies
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id: number;

    // @DataMember(Order=2)
    public communityGroupId?: number;

    // @DataMember(Order=3)
    public speciesId?: number;

    // @DataMember(Order=4)
    public linkGroupToSpecies?: number;

    public constructor(init?: Partial<CommunityGroupSpecies>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CommunityGroup
{
    [immerable] = true;

    // @DataMember(Order=1)
    public communityGroupId: number;

    // @DataMember(Order=2)
    public adminUserId: number;

    // @DataMember(Order=3)
    public adminUserEmail?: string;

    // @DataMember(Order=4)
    public createdByUserId: number;

    // @DataMember(Order=5)
    public name?: string;

    // @DataMember(Order=6)
    public dateEntered: string;

    // @DataMember(Order=7)
    public dateModified: string;

    // @DataMember(Order=8)
    public kmlFileName?: string;

    // @DataMember(Order=9)
    public regionId?: number;

    // @DataMember(Order=10)
    public stateId?: number;

    // @DataMember(Order=11)
    public communityGroupMembers?: CommunityGroupMember[];

    // @DataMember(Order=12)
    public additionalKmls?: CommunityGroupKmlFiles[];

    // @DataMember(Order=13)
    public groupRegionKml?: boolean;

    // @DataMember(Order=14)
    public communityGroupSpecies?: CommunityGroupSpecies[];

    // @DataMember(Order=15)
    public groupRegionPolygons?: string[];

    // @DataMember(Order=16)
    public alternativeDisplayPolygons?: string[];

    public constructor(init?: Partial<CommunityGroup>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CommunityGroupMember
{
    [immerable] = true;

    // @DataMember(Order=1)
    public communityGroupMemberId: number;

    // @DataMember(Order=2)
    public communityGroupId: number;

    // @DataMember(Order=3)
    public email: string;

    // @DataMember(Order=4)
    public userId?: number;

    // @DataMember(Order=5)
    public communityGroupStatusId: CommunityGroupMemberStatus;

    // @DataMember(Order=6)
    public dateResponse?: string;

    // @DataMember(Order=7)
    public dateLeftGroup?: string;

    // @DataMember(Order=8)
    public dateEntered: string;

    // @DataMember(Order=9)
    public dateModified: string;

    // @DataMember(Order=10)
    public downloadRights: boolean;

    // @DataMember(Order=11)
    public viewRights: boolean;

    // @DataMember(Order=12)
    public user: User;

    // @DataMember(Order=13)
    public communityGroup: CommunityGroup;

    public constructor(init?: Partial<CommunityGroupMember>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EmailNotificationOptOut
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id: number;

    // @DataMember(Order=2)
    public emailNotificationConfigId: number;

    // @DataMember(Order=3)
    public userId: number;

    public constructor(init?: Partial<EmailNotificationOptOut>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SightingType
{
    [immerable] = true;

    // @DataMember(Order=1)
    public sightingTypeId: SpeciesSiteEventType;

    // @DataMember(Order=2)
    public species: number;

    // @DataMember(Order=3)
    public sightingTypeName?: string;

    public constructor(init?: Partial<SightingType>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CommunityGroupStatus
{
    [immerable] = true;

    // @DataMember(Order=1)
    public communityGroupStatusId: number;

    // @DataMember(Order=2)
    public description: string;

    public constructor(init?: Partial<CommunityGroupStatus>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SpeciesContent
{
    [immerable] = true;

    // @DataMember(Order=1)
    public pageLeadingImageSrc?: string;

    // @DataMember(Order=2)
    public pageLeadingTitle?: string;

    // @DataMember(Order=3)
    public pageContent?: string;

    // @DataMember(Order=4)
    public speciesName?: string;

    // @DataMember(Order=5)
    public contentBannerText?: string;

    // @DataMember(Order=6)
    public speciesBannerText?: string;

    // @DataMember(Order=7)
    public speciesBannerTextSmall?: string;

    // @DataMember(Order=8)
    public totalRecords: number;

    // @DataMember(Order=9)
    public recentRecords: number;

    // @DataMember(Order=10)
    public totalGroups: number;

    // @DataMember(Order=11)
    public rightHandContentBottom?: string;

    public constructor(init?: Partial<SpeciesContent>) { (Object as any).assign(this, init); }
}

// @DataContract
export class NavMenuItem
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id: number;

    // @DataMember(Order=2)
    public name: string;

    // @DataMember(Order=3)
    public parentId?: number;

    // @DataMember(Order=4)
    public link: string;

    // @DataMember(Order=5)
    public rank: number;

    // @DataMember(Order=6)
    public species: Species;

    // @DataMember(Order=7)
    public items: NavMenuItem[];

    public constructor(init?: Partial<NavMenuItem>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CommunityGroupDocument
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id: number;

    // @DataMember(Order=2)
    public communityGroupId: number;

    // @DataMember(Order=3)
    public name: string;

    // @DataMember(Order=4)
    public fileName: string;

    // @DataMember(Order=5)
    public fileSize: number;

    // @DataMember(Order=6)
    public dateEntered: string;

    // @DataMember(Order=7)
    public obsolete: boolean;

    public constructor(init?: Partial<CommunityGroupDocument>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SpeciesFormQuestion
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public speciesFormId?: number;

    // @DataMember(Order=3)
    public label?: string;

    // @DataMember(Order=4)
    public order?: number;

    // @DataMember(Order=5)
    public speciesFormFields?: IFormField[];

    public constructor(init?: Partial<SpeciesFormQuestion>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SpeciesForm
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public name: string;

    // @DataMember(Order=3)
    public title: string;

    // @DataMember(Order=4)
    public version: string;

    // @DataMember(Order=5)
    public order: number;

    // @DataMember(Order=6)
    public speciesType: Species;

    // @DataMember(Order=7)
    public siteEventType: SiteEventType;

    // @DataMember(Order=8)
    public speciesFormQuestions?: SpeciesFormQuestion[];

    public constructor(init?: Partial<SpeciesForm>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ContentVersion
{
    [immerable] = true;

    // @DataMember(Order=1)
    public name: string;

    // @DataMember(Order=2)
    public species: Species;

    // @DataMember(Order=3)
    public version: number;

    // @DataMember(Order=4)
    public editable: boolean;

    // @DataMember(Order=5)
    public text: string;

    // @DataMember(Order=6)
    public dateEntered: string;

    // @DataMember(Order=7)
    public dateModified: string;

    // @DataMember(Order=8)
    public id: number;

    public constructor(init?: Partial<ContentVersion>) { (Object as any).assign(this, init); }
}

export class LookupItem
{
    [immerable] = true;

    public id: number;
    public value: string;
    public rank: number;

    public constructor(init?: Partial<LookupItem>) { (Object as any).assign(this, init); }
}

export class Lookup
{
    [immerable] = true;

    public name: string;
    public items: LookupItem[];

    public constructor(init?: Partial<Lookup>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GroupChartDataSet
{
    [immerable] = true;

    // @DataMember(Order=1)
    public dataSetLabel: string;

    // @DataMember(Order=2)
    public chartData: number[];

    // @DataMember(Order=3)
    public backgroudColour: string;

    // @DataMember(Order=4)
    public borderColour: string;

    public constructor(init?: Partial<GroupChartDataSet>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ChartGroupByMonthYear
{
    [immerable] = true;

    // @DataMember(Order=1)
    public date: string;

    // @DataMember(Order=2)
    public count: number;

    public constructor(init?: Partial<ChartGroupByMonthYear>) { (Object as any).assign(this, init); }
}

export interface ISiteEventCollectionResponse<TSiteEventType> extends ISearchResponse
{
    siteEvents: TSiteEventType[];
    lookups: Lookup[];
    chartData: TSiteEventType[];
    tableData: string[];
    groupChartMemberNames: string[];
    groupChartDataSets: GroupChartDataSet[];
    groupName: string;
    activeGroupMembers: number[];
    groupChartLabels: string[];
    chartDataByDate: ChartGroupByMonthYear[];
}

// @DataContract
export class EmailTemplate
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id: number;

    // @DataMember(Order=2)
    public emailTemplateTypeId: number;

    // @DataMember(Order=3)
    public name: string;

    // @DataMember(Order=4)
    public title: string;

    // @DataMember(Order=5)
    public htmlText: string;

    // @DataMember(Order=6)
    public plainText: string;

    // @DataMember(Order=7)
    public dateEntered?: string;

    // @DataMember(Order=8)
    public dateModified?: string;

    public constructor(init?: Partial<EmailTemplate>) { (Object as any).assign(this, init); }
}

export class SubSpecies
{
    [immerable] = true;

    public id?: number;
    public value?: string;
    public rank?: number;
    public obsolete?: boolean;

    public constructor(init?: Partial<SubSpecies>) { (Object as any).assign(this, init); }
}

export class SpeciesDto
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id: number;

    // @DataMember(Order=2)
    public value: string;

    // @DataMember(Order=3)
    public folder: string;

    // @DataMember(Order=4)
    public live: boolean;

    // @DataMember(Order=5)
    public displayName: string;

    // @DataMember(Order=6)
    public rank: number;

    // @DataMember(Order=7)
    public sensitive?: boolean;

    // @DataMember(Order=8)
    public siteEventTypes: SiteEventType[];

    public constructor(init?: Partial<SpeciesDto>) { (Object as any).assign(this, init); }
}

export interface ISiteEvent extends IHasComments, IHasDateEntered, IHasEmail, IHasId, IHasLocation, IHasObsolete, IHasParentId, IHasPlatformType, IHasPrivateData, IHasSightingType, IHasState, IHasUserId, IHasModifiedByUserId, IHasStartDateTime, IHasUuid, IHasLLSRegion, IHasLGARegion, IHasGuid
{
}

// @DataContract
export class TableRow
{
    [immerable] = true;

    // @DataMember(Order=1)
    public name: string;

    // @DataMember(Order=2)
    public period: number;

    // @DataMember(Order=3)
    public ytd: number;

    // @DataMember(Order=4)
    public bold: boolean;

    // @DataMember(Order=4)
    public indent: boolean;

    public constructor(init?: Partial<TableRow>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UserGroupGalleryItem
{
    [immerable] = true;

    // @DataMember(Order=1)
    public siteEventId: number;

    // @DataMember(Order=2)
    public siteEventType: SiteEventType;

    // @DataMember(Order=3)
    public galleryPhotosId: number;

    // @DataMember(Order=4)
    public latitude: string;

    // @DataMember(Order=5)
    public longitude: string;

    // @DataMember(Order=6)
    public galleryId: number;

    public constructor(init?: Partial<UserGroupGalleryItem>) { (Object as any).assign(this, init); }
}

// @DataContract
export class HistoryItem
{
    [immerable] = true;

    // @DataMember(Order=1)
    public siteEventId: number;

    // @DataMember(Order=2)
    public siteEventType: SiteEventType;

    // @DataMember(Order=3)
    public latitude: string;

    // @DataMember(Order=4)
    public longitude: string;

    // @DataMember(Order=5)
    public userName: string;

    // @DataMember(Order=6)
    public dateEntered: string;

    // @DataMember(Order=7)
    public summary: string;

    // @DataMember(Order=8)
    public comments: string;

    public constructor(init?: Partial<HistoryItem>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UserNotification
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id: number;

    // @DataMember(Order=2)
    public isPriority: boolean;

    // @DataMember(Order=3)
    public isRead: boolean;

    // @DataMember(Order=4)
    public userId: number;

    // @DataMember(Order=5)
    public title?: string;

    // @DataMember(Order=6)
    public message?: string;

    // @DataMember(Order=7)
    public sightingViewId?: string;

    // @DataMember(Order=8)
    public species?: string;

    // @DataMember(Order=9)
    public sightingType?: string;

    // @DataMember(Order=10)
    public sightingDateEntered?: string;

    // @DataMember(Order=11)
    public sightingFullName?: string;

    // @DataMember(Order=12)
    public sightingEmail?: string;

    // @DataMember(Order=13)
    public notificationUrl?: string;

    // @DataMember(Order=14)
    public notificationConfigId: number;

    public constructor(init?: Partial<UserNotification>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FlutterUserNotification
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id: number;

    // @DataMember(Order=2)
    public isPriority: boolean;

    // @DataMember(Order=3)
    public isRead: boolean;

    // @DataMember(Order=4)
    public userId: number;

    // @DataMember(Order=5)
    public title?: string;

    // @DataMember(Order=6)
    public message?: string;

    // @DataMember(Order=7)
    public sightingViewId?: string;

    // @DataMember(Order=8)
    public species: Species;

    // @DataMember(Order=9)
    public sightingType?: string;

    // @DataMember(Order=10)
    public sightingDateEntered?: string;

    // @DataMember(Order=11)
    public sightingFullName?: string;

    // @DataMember(Order=12)
    public sightingEmail?: string;

    // @DataMember(Order=13)
    public notificationUrl?: string;

    // @DataMember(Order=14)
    public notificationConfigId: number;

    // @DataMember(Order=15)
    public latitude?: string;

    // @DataMember(Order=16)
    public longitude?: string;

    public constructor(init?: Partial<FlutterUserNotification>) { (Object as any).assign(this, init); }
}

// @DataContract
export class WebsiteUserNotification
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id: number;

    // @DataMember(Order=2)
    public isPriority: boolean;

    // @DataMember(Order=3)
    public isRead: boolean;

    // @DataMember(Order=4)
    public userId: number;

    // @DataMember(Order=5)
    public title?: string;

    // @DataMember(Order=6)
    public message?: string;

    // @DataMember(Order=7)
    public sightingViewId?: string;

    // @DataMember(Order=8)
    public species: Species;

    // @DataMember(Order=9)
    public siteEventType?: SiteEventType;

    // @DataMember(Order=10)
    public sightingDateEntered?: string;

    // @DataMember(Order=11)
    public sightingFullName?: string;

    // @DataMember(Order=12)
    public sightingEmail?: string;

    // @DataMember(Order=13)
    public notificationUrl?: string;

    // @DataMember(Order=14)
    public notificationConfigId: number;

    public constructor(init?: Partial<WebsiteUserNotification>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ClientSpeciesFormsSettings
{
    [immerable] = true;

    // @DataMember(Order=1)
    public debugMode?: boolean;

    public constructor(init?: Partial<ClientSpeciesFormsSettings>) { (Object as any).assign(this, init); }
}

export class SentrySettings
{
    [immerable] = true;

    public dsn?: string;
    public environment?: string;
    public customer?: string;
    public sendDefaultPii?: boolean;
    public enableMetrics?: boolean;
    public attachStacktrace?: boolean;
    public debug?: boolean;
    public enableLogs?: boolean;
    public enableReportABug?: boolean;
    public replaysOnErrorSampleRate?: number;
    public replaysSessionSampleRate?: number;
    public tracesSampleRate?: number;

    public constructor(init?: Partial<SentrySettings>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ClientAppSettings
{
    [immerable] = true;

    // @DataMember(Order=1)
    public speciesForms?: ClientSpeciesFormsSettings;

    // @DataMember(Order=2)
    public sentry?: SentrySettings;

    public constructor(init?: Partial<ClientAppSettings>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SiteEventMetadata
{
    [immerable] = true;

    // @DataMember(Order=1)
    public speciesId: number;

    // @DataMember(Order=2)
    public species: Species;

    // @DataMember(Order=3)
    public siteEventTypeId: number;

    // @DataMember(Order=4)
    public siteEventType: SiteEventType;

    // @DataMember(Order=5)
    public speciesSiteEventTypeId: number;

    // @DataMember(Order=6)
    public speciesSiteEventType: SpeciesSiteEventType;

    // @DataMember(Order=7)
    public identityCode: string;

    public constructor(init?: Partial<SiteEventMetadata>) { (Object as any).assign(this, init); }
}

// @DataContract
export class Gallery
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id: number;

    // @DataMember(Order=2)
    public species: Species;

    // @DataMember(Order=3)
    public category: string;

    // @DataMember(Order=4)
    public rank: number;

    // @DataMember(Order=5)
    public submitFolder: boolean;

    // @DataMember(Order=6)
    public privateFolder: boolean;

    public constructor(init?: Partial<Gallery>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GalleryPhoto
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id: number;

    // @DataMember(Order=2)
    public dateAdded: string;

    // @DataMember(Order=3)
    public imageUrl: string;

    // @DataMember(Order=4)
    public imageThumbnailUrl: string;

    // @DataMember(Order=5)
    public approved: boolean;

    // @DataMember(Order=6)
    public currentUserCanView: boolean;

    // @DataMember(Order=7)
    public caption: string;

    // @DataMember(Order=8)
    public author: string;

    // @DataMember(Order=9)
    public createdByUserId?: number;

    // @DataMember(Order=10)
    public gallery: Gallery;

    public constructor(init?: Partial<GalleryPhoto>) { (Object as any).assign(this, init); }
}

export class Marker
{
    [immerable] = true;

    public id?: number;
    public latitude?: number;
    public longitude?: number;
    public icon?: string;
    public normalIcon?: string;
    public statusIcon?: string;
    public width?: number;
    public height?: number;
    public xOffset?: number;
    public yOffset?: number;
    public tooltip?: string;
    public content?: string;
    public siteEventType?: SiteEventType;
    public userId?: number;
    public layerOrdering?: number;
    public parentId?: number;
    public hoverContent?: string;
    public canSeeProtectedFields: boolean;
    public viewNotifications: boolean;
    public species?: Species;
    public speciesSiteEventType?: SpeciesSiteEventType;
    public galleryId?: number;
    public galleryPhotoId?: number;
    public dateEntered?: string;
    public privateData?: boolean;
    public canEditRecord?: boolean;
    public canViewPhoto?: boolean;
    public shareLink?: string;

    public constructor(init?: Partial<Marker>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SiteEventMarker
{
    [immerable] = true;

    // @DataMember(Order=1)
    public siteEvent: ISiteEvent;

    // @DataMember(Order=2)
    public marker: Marker;

    public constructor(init?: Partial<SiteEventMarker>) { (Object as any).assign(this, init); }
}

// @DataContract
export class WeightedHeatmapLocation
{
    [immerable] = true;

    // @DataMember(Order=1)
    public latitude: number;

    // @DataMember(Order=2)
    public longitude: number;

    // @DataMember(Order=3)
    public weight: number;

    public constructor(init?: Partial<WeightedHeatmapLocation>) { (Object as any).assign(this, init); }
}

export class LegendItem
{
    [immerable] = true;

    public imageUrl?: string;
    public title?: string;

    public constructor(init?: Partial<LegendItem>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UserExport
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public fullName?: string;

    // @DataMember(Order=3)
    public userName?: string;

    // @DataMember(Order=4)
    public email?: string;

    // @DataMember(Order=5)
    public state?: string;

    // @DataMember(Order=6)
    public postcode?: string;

    // @DataMember(Order=7)
    public dateCreated?: string;

    public constructor(init?: Partial<UserExport>) { (Object as any).assign(this, init); }
}

export enum ContentValueType
{
    ImageUrl = 0,
    Text = 1,
}

export class ContentValueDo
{
    [immerable] = true;

    public id: number;
    public contentName?: string;
    public species?: Species;
    public codeType: ContentCodeType;
    public valueType: ContentValueType;
    public code?: string;
    public value?: string;

    public constructor(init?: Partial<ContentValueDo>) { (Object as any).assign(this, init); }
}

export class ContentDo
{
    [immerable] = true;

    public id: number;
    public name?: string;
    public species?: Species;
    public searchRank?: string;
    public searchText?: string;
    public dateEntered: string;
    public dateModified: string;
    public title?: string;
    public hideFromSearch: boolean;
    public liveVersion: number;
    // @Ignore()
    public values: ContentValueDo[];

    public constructor(init?: Partial<ContentDo>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UserApiKey
{
    [immerable] = true;

    // @DataMember(Order=1)
    public key: string;

    // @DataMember(Order=2)
    public keyType: string;

    // @DataMember(Order=3)
    public expiryDate?: string;

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<UserApiKey>) { (Object as any).assign(this, init); }
}

export interface ISearchResponse
{
    totalCount: number;
}

export class SiteEventControlCamelExport implements ISiteEventExport, IHasEndDateTime
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public endDateTime?: string;
    public techniqueMustering?: boolean;
    public techniqueGroundShootingToLeave?: boolean;
    public techniqueGroundShootingForCommercialPetMeat?: boolean;
    public techniqueGroundShootingForNonCommercialPetMeat?: boolean;
    public techniqueAerialShooting?: boolean;
    public techniqueOther?: boolean;
    public techniqueOtherSpec: string;
    public controlCoordinated: string;
    public controlCoordinatedSpec: string;
    public camelsRemoved: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventControlCamelExport>) { (Object as any).assign(this, init); }
}

export interface ISiteEventSingleDeleteResponse
{
    deleted: boolean;
}

export class SiteEventControlDeerExport implements ISiteEventExport, IHasEndDateTime
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public endDateTime?: string;
    public techniqueGroundShooting: string;
    public techniqueGroundShootingScore?: number;
    public techniqueNoiseDisturbance?: boolean;
    public techniqueFencing?: boolean;
    public techniqueOther?: boolean;
    public techniqueOtherSpec: string;
    public techniqueOtherSpecScore?: number;
    public techniqueAerialShooting?: boolean;
    public techniqueAerialShootingScore?: number;
    public techniqueGuardian?: boolean;
    public techniqueRepellents?: boolean;
    public cameraInstalled: string;
    public techniqueGroundShootingThermal?: boolean;
    public techniqueGroundShootingThermalScore?: number;
    public techniqueTrapping?: boolean;
    public techniqueTrappingScore: string;
    public techniqueTrappingPigsTrappedScore?: number;
    public techniqueCommercialShooting?: boolean;
    public techniqueCommercialShootingScore?: number;
    public propertyName: string;
    public siteNumber: string;
    public deerSpecies: string;
    public sampleNumber: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventControlDeerExport>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralCatExport implements ISiteEventExport, IHasEndDateTime
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public endDateTime?: string;
    public testData?: boolean;
    public siteNumber: string;
    public propertyName: string;
    public techniqueJawTraps: string;
    public techniqueCageTraps: string;
    public techniqueGroundShooting: string;
    public techniqueGuardAnimals?: boolean;
    public techniqueExclusion?: boolean;
    public techniqueOther?: boolean;
    public techniqueOtherSpec: string;
    public techniqueGroundShootingNight: string;
    public age: string;
    public sex?: string;
    public colour?: string;
    public lureType?: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventControlFeralCatExport>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralFishExport implements ISiteEventExport, IHasEndDateTime
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public endDateTime?: string;
    public techniqueFishingNoRelease?: boolean;
    public techniqueChemical?: boolean;
    public techniqueElectro?: boolean;
    public techniqueTrapping?: boolean;
    public techniqueFishwayTraps?: boolean;
    public techniqueOther?: boolean;
    public techniqueOtherSpec: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventControlFeralFishExport>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralGoatExport implements ISiteEventExport, IHasEndDateTime
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public endDateTime?: string;
    public techniqueGroundShooting?: boolean;
    public techniqueGroundShootingScore?: number;
    public techniqueAerialShooting?: boolean;
    public techniqueAerialShootingScore?: number;
    public techniqueCommercialShooting?: boolean;
    public techniqueCommercialShootingScore?: number;
    public techniqueMustering?: boolean;
    public techniqueMusteringScore?: number;
    public techniqueMusteringWithWorkingDogs?: boolean;
    public techniqueMusteringWithWorkingDogsScore?: number;
    public techniqueMusteringAerialAssisted?: boolean;
    public techniqueMusteringAerialAssistedScore?: number;
    public techniqueTrapping?: boolean;
    public techniqueTrappingScore?: number;
    public techniqueJudasGoat?: boolean;
    public techniqueFencing?: boolean;
    public techniqueOther?: boolean;
    public techniqueOtherSpec: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;
    public propertyName?: string;
    public siteNumber?: string;
    public herdComposition?: string;
    public managementFieldProcessed?: boolean;
    public managementFieldProcessedScore?: number;
    public managementTransportElsewhere?: boolean;
    public managementTransportElsewhereScore?: number;
    public managementHumaneEuthanasia?: boolean;
    public managementHumaneEuthanasiaScore?: number;
    public managementOther?: boolean;
    public managementOtherSpec?: string;
    public managementOtherScore?: number;

    public constructor(init?: Partial<SiteEventControlFeralGoatExport>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralPigExport implements ISiteEventExport, IHasEndDateTime
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public endDateTime?: string;
    public techniqueWarningSigns?: boolean;
    public techniqueCamera?: boolean;
    public techniquePoisonGrain?: boolean;
    public techniquePoisonMeat?: boolean;
    public techniquePoisonManufactured?: boolean;
    public techniqueTrapping?: boolean;
    public techniqueTrappingScore?: string;
    public techniqueTrappingPigsTrappedScore?: number;
    public techniqueGroundShooting?: boolean;
    public techniqueGroundShootingScore?: number;
    public techniqueGroundShootingThermal?: boolean;
    public techniqueGroundShootingThermalScore?: number;
    public techniqueAerialShooting?: boolean;
    public techniqueAerialShootingScore?: number;
    public techniqueCommercialShooting?: boolean;
    public techniqueCommercialShootingScore?: number;
    public techniqueFencing?: boolean;
    public techniqueJudasPig?: boolean;
    public techniqueOther?: boolean;
    public techniqueOtherSpec: string;
    public techniqueGroundBaiting?: boolean;
    public techniqueGroundBaitingScore?: string;
    public techniqueGroundBaitingBaitTakenScore?: number;
    public techniqueAerialBaiting?: boolean;
    public techniqueGroundBaitingHoggone?: boolean;
    public techniqueGroundBaitingHoggoneScore?: string;
    public techniqueGroundBaitingHoggonePoisonBaitTakenScore?: number;
    public propertyName: string;
    public siteNumber: string;
    public preFeedType: string;
    public sampleNumber: string;
    public removedPigs: string;
    public cameraInstalledScore: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventControlFeralPigExport>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFoxExport implements ISiteEventExport, IHasEndDateTime
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public endDateTime?: string;
    public techniqueWarningSigns?: boolean;
    public techniqueGroundBaiting: string;
    public techniqueAerialBaiting?: boolean;
    public techniqueJawTraps: string;
    public techniqueCageTraps: string;
    public techniqueTrapping?: boolean;
    public techniqueGroundShooting: string;
    public techniqueGroundShootingThermal: string;
    public techniqueGuard?: boolean;
    public techniqueExclusion?: boolean;
    public techniqueFumigation?: boolean;
    public techniqueFoxDrives?: boolean;
    public techniqueOther?: boolean;
    public techniqueOtherSpec: string;
    public techniqueGroundBaitingPAPP: string;
    public techniqueCanidPestEjector: string;
    public siteNumber: string;
    public lureType: string;
    public propertyName: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventControlFoxExport>) { (Object as any).assign(this, init); }
}

export class SiteEventControlMouseExport implements ISiteEventExport, IHasEndDateTime
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public endDateTime?: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventControlMouseExport>) { (Object as any).assign(this, init); }
}

export class SiteEventControlMynaExport implements ISiteEventExport, IHasEndDateTime
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public endDateTime?: string;
    public propertyName: string;
    public siteNumber: string;
    public techniqueTrapping?: boolean;
    public techniqueTrappingScore?: number;
    public techniqueShooting?: boolean;
    public techniqueShootingScore?: number;
    public techniqueExclusion?: boolean;
    public techniqueOther?: boolean;
    public techniqueOtherSpec: string;
    public mynasRemoved?: number;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventControlMynaExport>) { (Object as any).assign(this, init); }
}

export class SiteEventControlOtherPestsExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public propertyName: string;
    public siteNumber: string;
    public subSpecies?: string;
    public techniqueMustering: boolean;
    public techniqueMusteringScore?: number;
    public techniqueGroundShootingToLeave: boolean;
    public techniqueGroundShootingToLeaveScore?: number;
    public techniqueGroundShootingToUse: boolean;
    public techniqueGroundShootingToUseScore?: number;
    public techniqueAerialShooting: boolean;
    public techniqueAerialShootingScore?: number;
    public techniqueExclusionFencing: boolean;
    public techniqueTrapping?: boolean;
    public techniqueTrappingScore?: number;
    public techniqueOther: boolean;
    public techniqueOtherSpec: string;
    public animalsRemoved: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventControlOtherPestsExport>) { (Object as any).assign(this, init); }
}

export class SiteEventControlRabbitExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public siteNumber: string;
    public propertyName: string;
    public techniqueWarningSigns?: boolean;
    public techniqueRipping?: boolean;
    public techniqueRippingNumberDestroyed: string;
    public techniqueFumigation?: boolean;
    public techniqueFumigationNumberFumigated: string;
    public techniqueBioNatMyxo?: boolean;
    public techniqueBioNatRHDV?: boolean;
    public techniqueBioIntroRHDV?: boolean;
    public techniqueTrapping: string;
    public techniqueShooting?: boolean;
    public techniqueShootingNumberShot: string;
    public techniquePoison?: boolean;
    public techniquePoison1080: string;
    public techniquePoisonPindone: string;
    public techniqueExclusion?: boolean;
    public techniqueHarbourRemoval?: boolean;
    public techniqueOther?: boolean;
    public techniqueOtherSpec: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventControlRabbitExport>) { (Object as any).assign(this, init); }
}

export class SiteEventControlStarlingExport implements ISiteEventExport, IHasEndDateTime
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public endDateTime?: string;
    public techniqueTrapping?: boolean;
    public techniqueShooting?: boolean;
    public techniqueExclusion?: boolean;
    public techniqueOther?: boolean;
    public techniqueOtherSpec: string;
    public starlingsRemoved?: number;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventControlStarlingExport>) { (Object as any).assign(this, init); }
}

export class SiteEventControlToadExport implements ISiteEventExport, IHasEndDateTime
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public endDateTime?: string;
    public propertyName?: string;
    public siteNumber?: string;
    public techniqueMuster?: boolean;
    public techniqueIncidential?: boolean;
    public techniqueCollection?: boolean;
    public techniqueTrapping?: boolean;
    public techniqueTrappingScore?: number;
    public techniqueExclusion?: boolean;
    public techniqueSpray?: boolean;
    public techniqueDetection?: boolean;
    public techniqueOther?: boolean;
    public techniqueOtherSpec: string;
    public toadsRemoved?: number;
    public techniqueCollectionAdults?: boolean;
    public techniqueCollectionAdultsScore?: number;
    public techniqueCollectionJuveniles?: boolean;
    public techniqueCollectionJuvenilesScore?: number;
    public techniqueCollectionTadpoles?: boolean;
    public techniqueCollectionTadpolesScore?: number;
    public techniqueCollectionEggs?: boolean;
    public techniqueCollectionEggsScore?: number;
    public techniqueCollectionMetamorphs?: boolean;
    public techniqueCollectionMetamorphsScore?: number;
    public sexMale?: boolean;
    public sexFemale?: boolean;
    public sexUnknown?: boolean;
    public evidenceOfBreeding?: string;
    public streetAddress?: string;
    public possession?: string;
    public sightingType?: string;
    public fullName?: string;
    public phoneNumber?: string;
    public adminAssessment?: string;
    public adminEnvironment?: string;
    public adminNotes?: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventControlToadExport>) { (Object as any).assign(this, init); }
}

export class SiteEventControlWildDogExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public techniqueWarningSigns?: boolean;
    public techniqueGroundBaiting: string;
    public techniqueAerialBaiting?: boolean;
    public techniqueJawTraps: string;
    public techniqueCageTraps: string;
    public techniqueGroundShooting?: boolean;
    public techniqueGroundShootingScore?: number;
    public techniqueAerialShooting?: boolean;
    public techniqueAerialShootingScore?: number;
    public techniqueLivestock?: boolean;
    public techniqueExclusion?: boolean;
    public techniqueOther?: boolean;
    public techniqueOtherSpec: string;
    public techniqueGroundBaitingPAPP: string;
    public techniqueCanidPestEjector: string;
    public siteNumber: string;
    public techniqueStrychnineTraps: string;
    public propertyName: string;
    public sex: string;
    public age: string;
    public colour: string;
    public lureType: string;
    public sampleNumber: string;
    public cameraInstalled: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventControlWildDogExport>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageCamelExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public damageWetland?: boolean;
    public damageWater?: boolean;
    public damageBuildings?: boolean;
    public damageFences?: boolean;
    public damageCultural?: boolean;
    public damageBiodiversity?: boolean;
    public damageNative?: boolean;
    public damageCompetition?: boolean;
    public damageAgricultural?: boolean;
    public damageTucker?: boolean;
    public damageSafety?: boolean;
    public damageRoad?: boolean;
    public damageEnjoyment?: boolean;
    public damageOther?: boolean;
    public damageOtherSpec: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventDamageCamelExport>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageDeerExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public damageLivestock?: boolean;
    public damageCrops?: boolean;
    public damageNativeVegetation?: boolean;
    public damageTreePlanting?: boolean;
    public damageWeeds?: boolean;
    public damageSoil?: boolean;
    public damageFences?: boolean;
    public damageBrowsingSensitive?: boolean;
    public damageWater?: boolean;
    public damageDisease?: boolean;
    public damageDiseaseSpread?: boolean;
    public damageSacred?: boolean;
    public damageTucker?: boolean;
    public damageEcoTourism?: boolean;
    public damageNearCollisionVehicle?: boolean;
    public damageVehicle?: boolean;
    public damageOther?: boolean;
    public damageOtherSpec: string;
    public damageNativeHerbivores?: boolean;
    public damagePlantation?: boolean;
    public damageFruitTree?: boolean;
    public damageVineyard?: boolean;
    public damageTrampleCrops?: boolean;
    public damageNutCereal?: boolean;
    public damageVegeCrop?: boolean;
    public damageMarketGarden?: boolean;
    public damageAggressive?: boolean;
    public damageFlowers?: boolean;
    public propertyName: string;
    public siteNumber: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventDamageDeerExport>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralCatExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public siteNumber: string;
    public propertyName: string;
    public state: string;
    public startDateTime?: string;
    public damageNativeReptiles?: boolean;
    public damageDomesticGoats?: boolean;
    public damageNativeBirds?: boolean;
    public damageNativeFrogs?: boolean;
    public damageDomesticPoultry?: boolean;
    public damageDomestic?: boolean;
    public damageDomesticLambs?: boolean;
    public damageNative?: boolean;
    public damageNativeMammals?: boolean;
    public damageDomesticOther?: boolean;
    public damageDomesticBirds?: boolean;
    public damageOther?: boolean;
    public damageOtherSpec: string;
    public damageDomesticOtherSpec: string;
    public testData?: boolean;
    public damageAnnoyance?: boolean;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventDamageFeralCatExport>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralFishExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public damageCompetition?: boolean;
    public damageRiverErosion?: boolean;
    public damageRiverSedimentation?: boolean;
    public damageMacrophyte?: boolean;
    public damageInvertebrates?: boolean;
    public damageNativeAnimals?: boolean;
    public damageCreationalFishing?: boolean;
    public damageEcoTourism?: boolean;
    public damageOther?: boolean;
    public damageOtherSpec: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventDamageFeralFishExport>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralGoatExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public damageLivestock?: boolean;
    public damageCrops?: boolean;
    public damageNativeVegetation?: boolean;
    public damageTreePlanting?: boolean;
    public damageWeeds?: boolean;
    public damageSoil?: boolean;
    public damageFences?: boolean;
    public damageBrowsingSensitive?: boolean;
    public damageWater?: boolean;
    public damageDisease?: boolean;
    public damageDiseaseSpread?: boolean;
    public damageSacred?: boolean;
    public damageTucker?: boolean;
    public damageEcoTourism?: boolean;
    public damageOther?: boolean;
    public damageOtherSpec: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventDamageFeralGoatExport>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralPigExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public damagePredationLambs?: boolean;
    public damageLivestock?: boolean;
    public damageCrops?: boolean;
    public damageFruit?: boolean;
    public damageNative?: boolean;
    public damageWeeds?: boolean;
    public damageSoil?: boolean;
    public damageDisease?: boolean;
    public damageDiseaseSpread?: boolean;
    public damageWetlands?: boolean;
    public damageWater?: boolean;
    public damageSacred?: boolean;
    public damageTucker?: boolean;
    public damageFences?: boolean;
    public damageHuman?: boolean;
    public damageEcoTourism?: boolean;
    public damageOther?: boolean;
    public damageOtherSpec: string;
    public propertyName: string;
    public siteNumber: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventDamageFeralPigExport>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFoxExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public damageLambsOrGoatKids?: boolean;
    public damageNative?: boolean;
    public damagePoultry?: boolean;
    public damagePets?: boolean;
    public damageWeeds?: boolean;
    public damageDisease?: boolean;
    public damageOther?: boolean;
    public damageOtherSpec: string;
    public damageSheep?: boolean;
    public damageSheepNumberKilled: string;
    public damageSheepNumberMauled: string;
    public damageLambs?: boolean;
    public damageLambsNumberKilled: string;
    public damageLambsNumberMauled: string;
    public damageGoats?: boolean;
    public damageGoatsNumberKilled: string;
    public damageGoatsNumberMauled: string;
    public damageGoatKids?: boolean;
    public damageGoatKidsNumberKilled: string;
    public damageGoatKidsNumberMauled: string;
    public damagePoultryNumberKilled: string;
    public damagePoultryNumberMauled: string;
    public damagePetsNumberKilled: string;
    public damagePetsNumberMauled: string;
    public siteNumber: string;
    public propertyName: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventDamageFoxExport>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageMouseExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventDamageMouseExport>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageMynaExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public propertyName: string;
    public siteNumber: string;
    public damageRoof?: boolean;
    public damageNative?: boolean;
    public damageCrops?: boolean;
    public damageScavenging?: boolean;
    public damageSocialGrounds?: boolean;
    public damagePets?: boolean;
    public damagePetFood?: boolean;
    public damageRoosting?: boolean;
    public damageHumans?: boolean;
    public damageFoodStock?: boolean;
    public damageHome?: boolean;
    public damageBirdDroppings?: boolean;
    public damageOther?: boolean;
    public damageOtherSpec: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventDamageMynaExport>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageOtherPestsExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public propertyName: string;
    public siteNumber: string;
    public damageRoad: boolean;
    public damageSafety: boolean;
    public damageCompetition: boolean;
    public damageLivestockCompetition: boolean;
    public damageNativeVegetation: boolean;
    public damageSensitiveVegetation: boolean;
    public damageWeeds: boolean;
    public damageWetland: boolean;
    public damageBiodiversity: boolean;
    public damageWater: boolean;
    public damageBuildings: boolean;
    public damageFences: boolean;
    public damageCultural: boolean;
    public damageTucker: boolean;
    public damageLivestockDisease: boolean;
    public damageNuisance: boolean;
    public damageOther: boolean;
    public damageOtherSpec: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventDamageOtherPestsExport>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageRabbitExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public siteNumber: string;
    public propertyName: string;
    public damageCompetitionPasture?: boolean;
    public damageSoil?: boolean;
    public damageProductivity?: boolean;
    public damageBuildings?: boolean;
    public damageNativeVeg?: boolean;
    public damageWeeds?: boolean;
    public damageCompetitionAnimals?: boolean;
    public damageSites?: boolean;
    public damageGarden?: boolean;
    public damageBiodiversity?: boolean;
    public damageCrops?: boolean;
    public damagePrograms?: boolean;
    public damageVehicles?: boolean;
    public damageSport?: boolean;
    public damageDigging?: boolean;
    public damageOther?: boolean;
    public damageOtherSpec: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventDamageRabbitExport>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageStarlingExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public damageRoof?: boolean;
    public damageNative?: boolean;
    public damageCrops?: boolean;
    public damageScavenging?: boolean;
    public damageSocialGrounds?: boolean;
    public damagePets?: boolean;
    public damagePetFood?: boolean;
    public damageRoosting?: boolean;
    public damageHumans?: boolean;
    public damageFoodStock?: boolean;
    public damageHome?: boolean;
    public damageBirdDroppings?: boolean;
    public damageOther?: boolean;
    public damageOtherSpec: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventDamageStarlingExport>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageToadExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public propertyName?: string;
    public siteNumber?: string;
    public phoneNumber?: string;
    public fullName?: string;
    public streetAddress?: string;
    public damagePoison?: boolean;
    public damagePets?: boolean;
    public damageHome?: boolean;
    public damageWater?: boolean;
    public damageNative?: boolean;
    public damageBees?: boolean;
    public damagePublic?: boolean;
    public damageHumans?: boolean;
    public damageSwimmingPools?: boolean;
    public damageCompetition?: boolean;
    public damageDungBeetles?: boolean;
    public damageFinacial?: boolean;
    public damageTucker?: boolean;
    public damageSacred?: boolean;
    public damageEcoTourism?: boolean;
    public damageOther?: boolean;
    public damageOtherSpec: string;
    public adminAssessment?: string;
    public adminNotes?: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventDamageToadExport>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageWildDogExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public damageSheep?: boolean;
    public damageSheepNumberKilled: string;
    public damageSheepNumberMauled: string;
    public damageGoats?: boolean;
    public damageGoatsNumberKilled: string;
    public damageGoatsNumberMauled: string;
    public damageCalves?: boolean;
    public damageCalvesNumberKilled: string;
    public damageCalvesNumberMauled: string;
    public damageCattle?: boolean;
    public damageCattleNumberKilled: string;
    public damageCattleNumberMauled: string;
    public damagePoultry?: boolean;
    public damagePoultryNumberKilled: string;
    public damagePoultryNumberMauled: string;
    public damageDomestic?: boolean;
    public damageDomesticNumberKilled: string;
    public damageDomesticNumberMauled: string;
    public damageDogs?: boolean;
    public damageNative?: boolean;
    public damageHuman?: boolean;
    public damageAttackHuman?: boolean;
    public damageRubbish?: boolean;
    public damageHorses?: boolean;
    public damageOther?: boolean;
    public damageOtherSpec: string;
    public damageLambs?: boolean;
    public damageLambsNumberKilled: string;
    public damageLambsNumberMauled: string;
    public damageGoatKids?: boolean;
    public damageGoatKidsNumberKilled: string;
    public damageGoatKidsNumberMauled: string;
    public damageDogsNumberKilled: string;
    public damageDogsNumberMauled: string;
    public siteNumber: string;
    public propertyName: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventDamageWildDogExport>) { (Object as any).assign(this, init); }
}

export class SiteEventDiseaseRabbitExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public diseaseType: string;
    public samplingKit: string;
    public postalAddress: string;
    public diseaseStatus: string;
    public broadscaleSite?: boolean;
    public uniqueLabel: string;
    public vialNumber: string;
    public siteNumber: string;
    public k5ReleasedRecently: string;
    public rabbitType: string;
    public petBreed: string;
    public petNumberAtRisk: string;
    public petNumberSick: string;
    public petNumberDead: string;
    public vaccinated: string;
    public juvenile: string;
    public sex: string;
    public k5ReleasedRecentlyDate?: string;
    public vaccinatedDate?: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventDiseaseRabbitExport>) { (Object as any).assign(this, init); }
}

export class SiteEventManagementDeerExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public title: string;
    public regionId?: number;
    public displaySighting?: boolean;
    public displayDamage?: boolean;
    public displayControl?: boolean;
    public displayDiseased?: boolean;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public recordType: string;
    public startDateTime?: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventManagementDeerExport>) { (Object as any).assign(this, init); }
}

export class SiteEventManagementWildDogExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public title: string;
    public regionId?: number;
    public displaySighting?: boolean;
    public displayDamage?: boolean;
    public displayControl?: boolean;
    public displayDiseased?: boolean;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public recordType: string;
    public startDateTime?: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventManagementWildDogExport>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingCamelExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public camelAbundance: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventSightingCamelExport>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingDeerExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public deerAbundance: string;
    public deerSpecies: string;
    public deerAge: string;
    public deerSex: string;
    public propertyName: string;
    public siteNumber: string;
    public deerSightingType: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventSightingDeerExport>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingDeerAla implements ISiteEventAla
{
    [immerable] = true;

    public occurrenceID: string;
    public dateEntered: string;
    public decimalLatitude: string;
    public decimalLongitude: string;
    public stateProvince: string;
    public eventDate?: string;
    public recordedByID?: number;
    public scientificName: string;
    public abundance: string;
    public age: string;
    public sex: string;
    public type: string;

    public constructor(init?: Partial<SiteEventSightingDeerAla>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralCatExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public siteNumber: string;
    public propertyName: string;
    public state: string;
    public startDateTime?: string;
    public feralCatAbundanceScore?: number;
    public feralCatSightingType: string;
    public feralCatSightingAge: string;
    public feralCatSex: string;
    public feralCatSightingTypeScat?: boolean;
    public feralCatSightingTypeTrack?: boolean;
    public feralCatSightingTypeOdour?: boolean;
    public feralCatColour: string;
    public feralCatColourOtherSpec: string;
    public feralCatHabitatRoadside?: boolean;
    public feralCatHabitatVegetation?: boolean;
    public feralCatHabitatFarmland?: boolean;
    public feralCatHabitatOther?: boolean;
    public feralCatHabitatOtherSpec: string;
    public testData?: boolean;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventSightingFeralCatExport>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralCatAla implements ISiteEventAla
{
    [immerable] = true;

    public occurrenceID: string;
    public dateEntered: string;
    public decimalLatitude: string;
    public decimalLongitude: string;
    public stateProvince: string;
    public eventDate?: string;
    public recordedByID?: number;
    public scientificName: string;
    public abundance?: number;
    public type: string;
    public age: string;
    public sex: string;
    public typeScat?: boolean;
    public typeTrack?: boolean;
    public typeOdour?: boolean;
    public typeCalling?: boolean;
    public colour: string;
    public colourOtherSpec: string;
    public habitatRoadside?: boolean;
    public habitatVegetation?: boolean;
    public habitatFarmland?: boolean;
    public habitatOther?: boolean;
    public habitatOtherSpec: string;

    public constructor(init?: Partial<SiteEventSightingFeralCatAla>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralFishExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public testData?: boolean;
    public feralFishSpecies: string;
    public feralFishSightingType: string;
    public feralFishSize: string;
    public behaviourSpawning?: boolean;
    public behaviourSchooling?: boolean;
    public behaviourFeeding?: boolean;
    public behaviourSwimming?: boolean;
    public behaviourNotApplicable?: boolean;
    public behaviourOther?: boolean;
    public behaviourOtherSpec: string;
    public feralFishAbundance: string;
    public feralFishHabitat: string;
    public feralFishHabitatOtherSpec: string;
    public microHabitatLogsSnags?: boolean;
    public microHabitatAmongRocks?: boolean;
    public microHabitatOpenWaterAtSurface?: boolean;
    public microHabitatAmongWaterPlants?: boolean;
    public microHabitatAtWatersEdge?: boolean;
    public microHabitatOther?: boolean;
    public microHabitatOtherSpec: string;
    public habitatDegradationTurbidMuddyWater?: boolean;
    public habitatDegradationInstreamBankErosion?: boolean;
    public habitatDegradationErosionInRiparianZone?: boolean;
    public habitatDegradationWillowsPresent?: boolean;
    public habitatDegradationLivestockPresent?: boolean;
    public habitatDegradationSiltSandBuildUp?: boolean;
    public habitatDegradationNoDegradation?: boolean;
    public habitatDegradationOther?: boolean;
    public habitatDegradationOtherSpec: string;
    public feralFishSpeciesOther: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventSightingFeralFishExport>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralFishAla implements ISiteEventAla
{
    [immerable] = true;

    public occurrenceID: string;
    public dateEntered: string;
    public decimalLatitude: string;
    public decimalLongitude: string;
    public stateProvince: string;
    public eventDate?: string;
    public recordedByID?: number;
    public scientificName: string;
    public type: string;
    public size: string;
    public behaviourSpawning?: boolean;
    public behaviourSchooling?: boolean;
    public behaviourFeeding?: boolean;
    public behaviourSwimming?: boolean;
    public behaviourNotApplicable?: boolean;
    public behaviourOther?: boolean;
    public behaviourOtherSpec: string;
    public abundance: string;
    public habitat: string;
    public habitatOtherSpec: string;
    public microHabitatLogsSnags?: boolean;
    public microHabitatAmongRocks?: boolean;
    public microHabitatOpenWaterAtSurface?: boolean;
    public microHabitatAmongWaterPlants?: boolean;
    public microHabitatAtWatersEdge?: boolean;
    public microHabitatOther?: boolean;
    public microHabitatOtherSpec: string;
    public habitatDegradationTurbidMuddyWater?: boolean;
    public habitatDegradationInstreamBankErosion?: boolean;
    public habitatDegradationErosionInRiparianZone?: boolean;
    public habitatDegradationWillowsPresent?: boolean;
    public habitatDegradationLivestockPresent?: boolean;
    public habitatDegradationSiltSandBuildUp?: boolean;
    public habitatDegradationNoDegradation?: boolean;
    public habitatDegradationOther?: boolean;
    public habitatDegradationOtherSpec: string;

    public constructor(init?: Partial<SiteEventSightingFeralFishAla>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralGoatExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public feralGoatAbundance: string;
    public feralGoatSightingType?: string;
    public gender?: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;
    public propertyName?: string;
    public siteNumber?: string;

    public constructor(init?: Partial<SiteEventSightingFeralGoatExport>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralGoatAla implements ISiteEventAla
{
    [immerable] = true;

    public occurrenceID: string;
    public dateEntered: string;
    public decimalLatitude: string;
    public decimalLongitude: string;
    public stateProvince: string;
    public eventDate?: string;
    public recordedByID?: number;
    public scientificName: string;
    public abundance: string;

    public constructor(init?: Partial<SiteEventSightingFeralGoatAla>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralPigExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public feralPigAbundanceScore?: number;
    public feralPigSightingType: string;
    public propertyName: string;
    public siteNumber: string;
    public age: string;
    public sex: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventSightingFeralPigExport>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralPigAla implements ISiteEventAla
{
    [immerable] = true;

    public occurrenceID: string;
    public dateEntered: string;
    public decimalLatitude: string;
    public decimalLongitude: string;
    public stateProvince: string;
    public eventDate?: string;
    public recordedByID?: number;
    public scientificName: string;
    public abundance: string;
    public type: string;

    public constructor(init?: Partial<SiteEventSightingFeralPigAla>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFoxExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public foxSightingType: string;
    public foxAbundance: string;
    public foxNight: string;
    public foxSightingAge: string;
    public siteNumber: string;
    public propertyName: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventSightingFoxExport>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFoxAla implements ISiteEventAla
{
    [immerable] = true;

    public occurrenceID: string;
    public dateEntered: string;
    public decimalLatitude: string;
    public decimalLongitude: string;
    public stateProvince: string;
    public eventDate?: string;
    public recordedByID?: number;
    public scientificName: string;
    public type: string;
    public abundance: string;
    public night: string;
    public age: string;

    public constructor(init?: Partial<SiteEventSightingFoxAla>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingMouseExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public testData?: boolean;
    public mouseCroppingStage: string;
    public mouseAbundanceNotAssessed?: boolean;
    public mouseAbundance: string;
    public mouseAbundanceEstimate: string;
    public mouseAbundanceEstimateSpec: string;
    public damageSeenPasture: string;
    public damageSeenFarmBuildings: string;
    public damageSeenStubble: string;
    public damageSeenStubbleWheat: string;
    public damageSeenStubbleCanola: string;
    public damageSeenStubbleSorghum: string;
    public damageSeenStubbleBarley: string;
    public damageSeenStubbleOther: string;
    public damageSeenStubbleOtherSpec: string;
    public damageSeenCrop: string;
    public damageSeenCropWheat: string;
    public damageSeenCropCanola: string;
    public damageSeenCropSorghum: string;
    public damageSeenCropBarley: string;
    public damageSeenCropOther: string;
    public damageSeenCropOtherSpec: string;
    public damageNone?: boolean;
    public damage: string;
    public damageWheat?: boolean;
    public damageStoredGrain?: boolean;
    public damageElecOrMachinery?: boolean;
    public damageNuisance?: boolean;
    public damageCanola?: boolean;
    public damageSorghum?: boolean;
    public damageBarley?: boolean;
    public damageOther?: boolean;
    public damageOtherSpec: string;
    public damageTotalArea: string;
    public damageOccurredSowing?: boolean;
    public damageOccurredSeedling?: boolean;
    public damageOccurredTillering?: boolean;
    public damageOccurredFlowering?: boolean;
    public damageOccurredPriorToHarvest?: boolean;
    public damageOccurredOther?: boolean;
    public damageOccurredOtherSpec: string;
    public techniqueNone?: boolean;
    public techniqueBurnStubble?: boolean;
    public techniqueSprayWeeds?: boolean;
    public techniqueCultivate?: boolean;
    public techniqueBaitWithPoison?: boolean;
    public techniqueSetMouseTraps?: boolean;
    public techniqueCoverFood?: boolean;
    public techniqueOther?: boolean;
    public techniqueOtherSpec: string;
    public poisonBaitApplication: string;
    public poisonBaitApplicationOtherSpec: string;
    public farmingCroppingOnly?: boolean;
    public farmingCropping80Grazing20?: boolean;
    public farmingCropping50Grazing50?: boolean;
    public farmingConservationDirectDrill?: boolean;
    public farmingIrrigation?: boolean;
    public farmingOther?: boolean;
    public farmingOtherSpec: string;
    public mobile: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventSightingMouseExport>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingMouseAla implements ISiteEventAla
{
    [immerable] = true;

    public occurrenceID: string;
    public dateEntered: string;
    public decimalLatitude: string;
    public decimalLongitude: string;
    public stateProvince: string;
    public eventDate?: string;
    public recordedByID?: number;
    public scientificName: string;
    public abundanceNotAssessed?: boolean;
    public abundance: string;
    public techniqueOther?: boolean;
    public farmingCroppingOnly?: boolean;
    public farmingCropping80Grazing20?: boolean;
    public farmingCropping50Grazing50?: boolean;
    public farmingConservationDirectDrill?: boolean;
    public farmingIrrigation?: boolean;
    public farmingOther?: boolean;
    public damageSeenCropOtherSpec: string;
    public damageSeenStubbleOtherSpec: string;
    public damageOtherSpec: string;
    public damageTotalArea: string;
    public farmingOtherSpec: string;
    public damageOccurredOtherSpec: string;

    public constructor(init?: Partial<SiteEventSightingMouseAla>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingMynaExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public propertyName: string;
    public siteNumber: string;
    public mynaAbundance: string;
    public mynaNesting: string;
    public mynaRoosting: string;
    public mynaSightingType: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventSightingMynaExport>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingMynaAla implements ISiteEventAla
{
    [immerable] = true;

    public occurrenceID: string;
    public dateEntered: string;
    public decimalLatitude: string;
    public decimalLongitude: string;
    public stateProvince: string;
    public eventDate?: string;
    public recordedByID?: number;
    public scientificName: string;
    public abundance: string;
    public nesting: string;
    public roosting: string;
    public sightingType: string;

    public constructor(init?: Partial<SiteEventSightingMynaAla>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingNewPestsExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public siteNumber: string;
    public phoneNumber: string;
    public fullName: string;
    public streetAddress: string;
    public species: string;
    public sightingDescription: string;
    public abundance: string;
    public describeWhere: string;
    public possession: string;
    public type: string;
    public agreeShareReport?: boolean;
    public adminAssessment: string;
    public adminEnvironment: string;
    public adminNotes: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventSightingNewPestsExport>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingOtherPestsExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public propertyName: string;
    public siteNumber: string;
    public otherPestsAbundanceScore: string;
    public sightingType?: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public subSpecies: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventSightingOtherPestsExport>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingOtherPestsAla implements ISiteEventAla
{
    [immerable] = true;

    public occurrenceID: string;
    public dateEntered: string;
    public decimalLatitude: string;
    public decimalLongitude: string;
    public stateProvince: string;
    public eventDate?: string;
    public recordedByID?: number;
    public scientificName: string;
    public abundance: string;

    public constructor(init?: Partial<SiteEventSightingOtherPestsAla>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingRabbitExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public inspectionArea?: number;
    public rabbitAbundance: string;
    public rabbitDungSightings: string;
    public rabbitWarrensBurrows: string;
    public rabbitSpotlightAbundance: string;
    public rabbitActiveEntrancesScore?: number;
    public k5Released: boolean;
    public broadscaleSite: boolean;
    public siteNumber: string;
    public propertyName: string;
    public spotlightTransectLength?: number;
    public spotlightCount1: string;
    public spotlightCount2: string;
    public spotlightCount3: string;
    public platformVersion: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventSightingRabbitExport>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingRabbitAla implements ISiteEventAla
{
    [immerable] = true;

    public occurrenceID: string;
    public dateEntered: string;
    public decimalLatitude: string;
    public decimalLongitude: string;
    public stateProvince: string;
    public eventDate?: string;
    public recordedByID?: number;
    public scientificName: string;
    public abundance: string;
    public dungSightings: string;
    public warrensBurrows: string;
    public spotlightAbundance: string;
    public activeEntrances: string;

    public constructor(init?: Partial<SiteEventSightingRabbitAla>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingStarlingExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public starlingAbundance: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventSightingStarlingExport>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingStarlingAla implements ISiteEventAla
{
    [immerable] = true;

    public occurrenceID: string;
    public dateEntered: string;
    public decimalLatitude: string;
    public decimalLongitude: string;
    public stateProvince: string;
    public eventDate?: string;
    public recordedByID?: number;
    public scientificName: string;
    public abundance: string;

    public constructor(init?: Partial<SiteEventSightingStarlingAla>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingToadExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public propertyName?: string;
    public siteNumber?: string;
    public phoneNumber: string;
    public fullName: string;
    public streetAddress: string;
    public describeWhere: string;
    public toadAbundanceScore?: number;
    public age: string;
    public possession: string;
    public type: string;
    public removedFromEnvironment: string;
    public audioRecording?: string;
    public administratorAssessment: string;
    public administratorNotes: string;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventSightingToadExport>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingToadAla implements ISiteEventAla
{
    [immerable] = true;

    public occurrenceID: string;
    public dateEntered: string;
    public decimalLatitude: string;
    public decimalLongitude: string;
    public stateProvince: string;
    public eventDate?: string;
    public recordedByID?: number;
    public scientificName: string;
    public abundance: string;
    public age: string;
    public type: string;
    public removedFromEnvironment: string;

    public constructor(init?: Partial<SiteEventSightingToadAla>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingWildDogExport implements ISiteEventExport
{
    [immerable] = true;

    public id: string;
    public parentId?: number;
    public modifiedByUserId?: number;
    public dateEntered: string;
    public obsolete: boolean;
    public latitude: string;
    public longitude: string;
    public state: string;
    public startDateTime?: string;
    public wildDogAbundance: string;
    public wildDogSightingType: string;
    public wildDogSightingAge: string;
    public siteNumber: string;
    public propertyName: string;
    public sex: string;
    public colour: string;
    public recommendationMonitor: string;
    public recommendationConsider: string;
    public recommendationNone?: boolean;
    public recommendationOther?: boolean;
    public comments: string;
    public userId?: number;
    public userEmail: string;
    public userFullName: string;
    public userMobile: string;
    public userIsMemberOfCommunityGroup: boolean;
    public platformType: string;
    public imageUrl: string[];
    public markerURL: string;
    public privateData?: boolean;
    public llsRegionId?: number;
    public llsRegionName?: string;
    public lgaRegionId?: number;
    public lgaRegionName?: string;

    public constructor(init?: Partial<SiteEventSightingWildDogExport>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingWildDogAla implements ISiteEventAla
{
    [immerable] = true;

    public occurrenceID: string;
    public dateEntered: string;
    public decimalLatitude: string;
    public decimalLongitude: string;
    public stateProvince: string;
    public eventDate?: string;
    public recordedByID?: number;
    public scientificName: string;
    public abundance: string;
    public type: string;
    public age: string;
    public sex: string;
    public colour: string;

    public constructor(init?: Partial<SiteEventSightingWildDogAla>) { (Object as any).assign(this, init); }
}

export interface IUserRole
{
    id: number;
    userId: number;
    createdDate: string;
    createdByUserId?: number;
}

export interface ISiteEventControlCamel extends ISiteEvent, IHasEndDateTime
{
    techniqueMustering?: boolean;
    techniqueGroundShootingToLeave?: boolean;
    techniqueGroundShootingForCommercialPetMeat?: boolean;
    techniqueGroundShootingForNonCommercialPetMeat?: boolean;
    techniqueAerialShooting?: boolean;
    techniqueOther?: boolean;
    techniqueOtherSpec: string;
    controlCoordinatedScore?: number;
    controlCoordinatedSpec: string;
    camelsRemoved: string;
}

export interface IHasComments
{
    comments: string;
}

export interface IHasDateEntered
{
    dateEntered: string;
}

export interface IHasEmail
{
    email: string;
}

export interface IHasLocation
{
    geoPoint: MyGeographyDto;
    latitude: string;
    longitude: string;
}

export interface IHasObsolete
{
    obsolete?: boolean;
}

export interface IHasParentId
{
    parentId?: number;
}

export interface IHasPlatformType
{
    platformType?: number;
}

export interface IHasPrivateData
{
    privateData?: boolean;
}

export interface IHasSightingType
{
    sightingTypeId: SiteEventType;
}

export interface IHasState
{
    state: string;
}

export interface IHasUserId
{
    userId?: number;
}

export interface IHasModifiedByUserId
{
    modifiedByUserId?: number;
}

export interface IHasStartDateTime
{
    startDateTime?: string;
}

export interface IHasUuid
{
    uuid?: string;
}

export interface IHasLLSRegion
{
    llsRegionId?: number;
}

export interface IHasLGARegion
{
    lgaRegionId?: number;
}

export interface IHasGuid
{
    guid?: string;
}

export interface IHasEndDateTime
{
    endDateTime?: string;
}

export interface ISiteEventControlDeer extends ISiteEvent, IHasEndDateTime, IHasSubSpeciesId, IHasSiteNumber, IHasPropertyName
{
    techniqueGroundShooting?: boolean;
    techniqueNoiseDisturbance?: boolean;
    techniqueFencing?: boolean;
    techniqueOther?: boolean;
    techniqueOtherSpec: string;
    techniqueOtherSpecScore?: number;
    techniqueAerialShooting?: boolean;
    techniqueGuardian?: boolean;
    techniqueRepellents?: boolean;
    techniqueGroundShootingScore?: number;
    techniqueAerialShootingScore?: number;
}

export interface IHasSubSpeciesId
{
    subSpeciesId?: number;
}

export interface IHasSiteNumber
{
    siteNumber: string;
}

export interface IHasPropertyName
{
    propertyName: string;
}

export interface ISiteEventControlFeralCat extends ISiteEvent, IHasEndDateTime, IHasSiteNumber, IHasPropertyName
{
    testData?: boolean;
    techniqueJawTraps?: boolean;
    techniqueJawTrapsScore?: number;
    techniqueCageTraps?: boolean;
    techniqueCageTrapsScore?: number;
    techniqueGroundShooting?: boolean;
    techniqueGroundShootingScore?: number;
    techniqueGuardAnimals?: boolean;
    techniqueExclusion?: boolean;
    techniqueOther?: boolean;
    techniqueOtherSpec: string;
    techniqueGroundShootingNight?: boolean;
    techniqueGroundShootingNightScore?: number;
    ageScore?: number;
    sexScore?: number;
    colourScore?: number;
    lureType?: string;
}

export interface ISiteEventControlFeralFish extends ISiteEvent, IHasEndDateTime
{
    techniqueFishingNoRelease?: boolean;
    techniqueChemical?: boolean;
    techniqueElectro?: boolean;
    techniqueTrapping?: boolean;
    techniqueFishwayTraps?: boolean;
    techniqueOther?: boolean;
    techniqueOtherSpec: string;
}

export interface ISiteEventControlFeralGoat extends ISiteEvent, IHasEndDateTime, IHasPropertyName
{
    techniqueGroundShooting?: boolean;
    techniqueAerialShooting?: boolean;
    techniqueCommercialShooting?: boolean;
    techniqueMustering?: boolean;
    techniqueTrapping?: boolean;
    techniqueJudasGoat?: boolean;
    techniqueFencing?: boolean;
    techniqueOther?: boolean;
    techniqueOtherSpec: string;
    techniqueGroundShootingScore?: number;
    techniqueAerialShootingScore?: number;
    techniqueCommercialShootingScore?: number;
    techniqueMusteringScore?: number;
    techniqueMusteringWithWorkingDogsScore?: number;
    techniqueMusteringAerialAssistedScore?: number;
    herdCompositionBillies?: boolean;
    herdCompositionNannies?: boolean;
    herdCompositionKids?: boolean;
    herdCompositionCombination?: boolean;
    managementFieldProcessed?: boolean;
    managementFieldProcessedScore?: number;
    managementTransportElsewhere?: boolean;
    managementTransportElsewhereScore?: number;
    managementHumaneEuthanasia?: boolean;
    managementHumaneEuthanasiaScore?: number;
    managementOther?: boolean;
    managementOtherSpec?: string;
    managementOtherScore?: number;
    techniqueMusteringWithWorkingDogs?: boolean;
    techniqueMusteringAerialAssisted?: boolean;
}

export interface ISiteEventControlFeralPig extends ISiteEvent, IHasEndDateTime, IHasPropertyName, IHasSiteNumber
{
    techniquePoisonGrain?: boolean;
    techniquePoisonMeat?: boolean;
    techniquePoisonManufactured?: boolean;
    techniqueTrapping?: boolean;
    techniqueGroundShooting?: boolean;
    techniqueAerialShooting?: boolean;
    techniqueCommercialShooting?: boolean;
    techniqueFencing?: boolean;
    techniqueJudasPig?: boolean;
    techniqueOther?: boolean;
    techniqueOtherSpec: string;
    techniqueGroundBaiting?: boolean;
    techniqueGroundBaitingScore?: number;
    techniqueAerialBaiting?: boolean;
    techniqueTrappingScore?: number;
    techniqueGroundShootingScore?: number;
}

export interface ISiteEventControlFox extends ISiteEvent, IHasEndDateTime, IHasSiteNumber, IHasPropertyName
{
    techniqueGroundBaiting?: boolean;
    techniqueGroundBaitingScore?: number;
    techniqueAerialBaiting?: boolean;
    techniqueJawTraps?: boolean;
    techniqueJawTrapsScore?: number;
    techniqueCageTraps?: boolean;
    techniqueCageTrapsScore?: number;
    techniqueTrapping?: boolean;
    techniqueGroundShooting?: boolean;
    techniqueGroundShootingScore?: number;
    techniqueGuard?: boolean;
    techniqueExclusion?: boolean;
    techniqueFumigation?: boolean;
    techniqueFoxDrives?: boolean;
    techniqueOther?: boolean;
    techniqueOtherSpec: string;
    techniqueGroundBaitingPAPP?: boolean;
    techniqueGroundBaitingPAPPScore?: number;
    techniqueCanidPestEjector?: boolean;
    techniqueCanidPestEjectorScore?: number;
    lureType: string;
}

export interface ISiteEventControlMouse extends ISiteEvent, IHasEndDateTime
{
}

export interface ISiteEventControlMyna extends ISiteEvent, IHasEndDateTime, IHasSiteNumber, IHasPropertyName
{
    techniqueTrapping?: boolean;
    techniqueTrappingScore?: number;
    techniqueShooting?: boolean;
    techniqueShootingScore?: number;
    techniqueExclusion?: boolean;
    techniqueOther?: boolean;
    techniqueOtherSpec: string;
    mynasRemoved?: number;
}

export interface ISiteEventControlOtherPests extends ISiteEvent, IHasSubSpeciesId, IHasSiteNumber, IHasPropertyName
{
    techniqueMustering: boolean;
    techniqueGroundShootingToLeave: boolean;
    techniqueGroundShootingToUse: boolean;
    techniqueAerialShooting: boolean;
    techniqueExclusionFencing: boolean;
    techniqueOther: boolean;
    techniqueOtherSpec: string;
    animalsRemoved: string;
}

export interface ISiteEventControlRabbit extends ISiteEvent, IHasSiteNumber, IHasPropertyName
{
    techniqueRipping?: boolean;
    techniqueRippingNumberDestroyed?: number;
    techniqueFumigation?: boolean;
    techniqueFumigationNumberFumigated?: number;
    techniqueBioNatMyxo?: boolean;
    techniqueBioNatRHDV?: boolean;
    techniqueBioIntroRHDV?: boolean;
    techniqueTrapping?: boolean;
    techniqueTrappingScore?: number;
    techniqueShooting?: boolean;
    techniqueShootingNumberShot?: number;
    techniquePoison?: boolean;
    techniquePoison1080?: boolean;
    techniquePoison1080Score?: number;
    techniquePoisonPindone?: boolean;
    techniquePoisonPindoneScore?: number;
    techniqueExclusion?: boolean;
    techniqueHarbourRemoval?: boolean;
    techniqueOther?: boolean;
    techniqueOtherSpec: string;
}

export interface ISiteEventControlStarling extends ISiteEvent, IHasEndDateTime
{
    techniqueTrapping?: boolean;
    techniqueShooting?: boolean;
    techniqueExclusion?: boolean;
    techniqueOther?: boolean;
    techniqueOtherSpec: string;
    starlingsRemoved?: number;
}

export interface ISiteEventControlToad extends ISiteEvent, IHasEndDateTime, IHasPropertyName
{
    techniqueMuster?: boolean;
    techniqueIncidential?: boolean;
    techniqueCollection?: boolean;
    techniqueTrapping?: boolean;
    techniqueExclusion?: boolean;
    techniqueSpray?: boolean;
    techniqueDetection?: boolean;
    techniqueOther?: boolean;
    techniqueOtherSpec: string;
    toadsRemoved?: number;
    emailNsw: string;
}

export interface ISiteEventControlWildDog extends ISiteEvent, IHasSiteNumber, IHasPropertyName
{
    techniqueGroundBaiting?: boolean;
    techniqueGroundBaitingScore?: number;
    techniqueAerialBaiting?: boolean;
    techniqueJawTraps?: boolean;
    techniqueJawTrapsScore?: number;
    techniqueCageTraps?: boolean;
    techniqueCageTrapsScore?: number;
    techniqueGroundShooting?: boolean;
    techniqueGroundShootingScore?: number;
    techniqueLivestock?: boolean;
    techniqueExclusion?: boolean;
    techniqueOther?: boolean;
    techniqueOtherSpec: string;
    techniqueGroundBaitingPAPP?: boolean;
    techniqueGroundBaitingPAPPScore?: number;
    techniqueCanidPestEjector?: boolean;
    techniqueCanidPestEjectorScore?: number;
    techniqueStrychnineTraps?: boolean;
    techniqueStrychnineTrapsScore?: number;
    sex?: number;
    age?: number;
    colour?: number;
    lureType: string;
}

export interface ISiteEventDamageCamel extends ISiteEvent
{
    damageWetland?: boolean;
    damageWater?: boolean;
    damageBuildings?: boolean;
    damageFences?: boolean;
    damageCultural?: boolean;
    damageBiodiversity?: boolean;
    damageNative?: boolean;
    damageCompetition?: boolean;
    damageAgricultural?: boolean;
    damageTucker?: boolean;
    damageSafety?: boolean;
    damageRoad?: boolean;
    damageEnjoyment?: boolean;
    damageOther?: boolean;
    damageOtherSpec: string;
}

export interface ISiteEventDamageDeer extends ISiteEvent, IHasSiteNumber, IHasPropertyName
{
    damageLivestock?: boolean;
    damageCrops?: boolean;
    damageNativeVegetation?: boolean;
    damageTreePlanting?: boolean;
    damageWeeds?: boolean;
    damageSoil?: boolean;
    damageFences?: boolean;
    damageBrowsingSensitive?: boolean;
    damageWater?: boolean;
    damageDisease?: boolean;
    damageDiseaseSpread?: boolean;
    damageSacred?: boolean;
    damageTucker?: boolean;
    damageEcoTourism?: boolean;
    damageVehicle?: boolean;
    damageOther?: boolean;
    damageOtherSpec: string;
    damageNativeHerbivores?: boolean;
    damagePlantation?: boolean;
    damageFruitTree?: boolean;
    damageVineyard?: boolean;
    damageTrampleCrops?: boolean;
    damageNutCereal?: boolean;
    damageVegeCrop?: boolean;
    damageMarketGarden?: boolean;
    damageAggressive?: boolean;
    damageFlowers?: boolean;
}

export interface ISiteEventDamageFeralCat extends ISiteEvent, IHasSiteNumber, IHasPropertyName
{
    damageNativeReptiles?: boolean;
    damageDomesticGoats?: boolean;
    damageNativeBirds?: boolean;
    damageNativeFrogs?: boolean;
    damageDomesticPoultry?: boolean;
    damageDomestic?: boolean;
    damageDomesticLambs?: boolean;
    damageNative?: boolean;
    damageNativeMammals?: boolean;
    damageDomesticOther?: boolean;
    damageDomesticBirds?: boolean;
    damageOther?: boolean;
    damageOtherSpec: string;
    damageDomesticOtherSpec: string;
    testData?: boolean;
    damageAnnoyance?: boolean;
}

export interface ISiteEventDamageFeralFish extends ISiteEvent
{
    damageCompetition?: boolean;
    damageRiverErosion?: boolean;
    damageRiverSedimentation?: boolean;
    damageMacrophyte?: boolean;
    damageInvertebrates?: boolean;
    damageNativeAnimals?: boolean;
    damageCreationalFishing?: boolean;
    damageEcoTourism?: boolean;
    damageOther?: boolean;
    damageOtherSpec: string;
}

export interface ISiteEventDamageFeralGoat extends ISiteEvent
{
    damageLivestock?: boolean;
    damageCrops?: boolean;
    damageNativeVegetation?: boolean;
    damageTreePlanting?: boolean;
    damageWeeds?: boolean;
    damageSoil?: boolean;
    damageFences?: boolean;
    damageBrowsingSensitive?: boolean;
    damageWater?: boolean;
    damageDisease?: boolean;
    damageDiseaseSpread?: boolean;
    damageSacred?: boolean;
    damageTucker?: boolean;
    damageEcoTourism?: boolean;
    damageOther?: boolean;
    damageOtherSpec: string;
}

export interface ISiteEventDamageFeralPig extends ISiteEvent, IHasPropertyName, IHasSiteNumber
{
    damagePredationLambs?: boolean;
    damageLivestock?: boolean;
    damageCrops?: boolean;
    damageFruit?: boolean;
    damageNative?: boolean;
    damageWeeds?: boolean;
    damageSoil?: boolean;
    damageDisease?: boolean;
    damageDiseaseSpread?: boolean;
    damageWetlands?: boolean;
    damageWater?: boolean;
    damageSacred?: boolean;
    damageTucker?: boolean;
    damageFences?: boolean;
    damageHuman?: boolean;
    damageEcoTourism?: boolean;
    damageOther?: boolean;
    damageOtherSpec: string;
}

export interface ISiteEventDamageFox extends ISiteEvent, IHasSiteNumber, IHasPropertyName
{
    damageLambsOrGoatKids?: boolean;
    damageNative?: boolean;
    damagePoultry?: boolean;
    damagePets?: boolean;
    damageWeeds?: boolean;
    damageDisease?: boolean;
    damageOther?: boolean;
    damageOtherSpec: string;
    damageSheep?: boolean;
    damageSheepNumberKilled: string;
    damageSheepNumberMauled: string;
    damageLambs?: boolean;
    damageLambsNumberKilled: string;
    damageLambsNumberMauled: string;
    damageGoats?: boolean;
    damageGoatsNumberKilled: string;
    damageGoatsNumberMauled: string;
    damageGoatKids?: boolean;
    damageGoatKidsNumberKilled: string;
    damageGoatKidsNumberMauled: string;
    damagePoultryNumberKilled: string;
    damagePoultryNumberMauled: string;
    damagePetsNumberKilled: string;
    damagePetsNumberMauled: string;
}

export interface ISiteEventDamageMouse extends ISiteEvent
{
}

export interface ISiteEventDamageMyna extends ISiteEvent, IHasPropertyName, IHasSiteNumber
{
    damageRoof?: boolean;
    damageNative?: boolean;
    damageCrops?: boolean;
    damageScavenging?: boolean;
    damageSocialGrounds?: boolean;
    damagePets?: boolean;
    damagePetFood?: boolean;
    damageRoosting?: boolean;
    damageHumans?: boolean;
    damageFoodStock?: boolean;
    damageHome?: boolean;
    damageBirdDroppings?: boolean;
    damageOther?: boolean;
    damageOtherSpec: string;
}

export interface ISiteEventDamageOtherPests extends ISiteEvent, IHasSubSpeciesId, IHasSiteNumber, IHasPropertyName
{
    damageRoad: boolean;
    damageSafety: boolean;
    damageLivestockCompetition: boolean;
    damageNativeCompetition: boolean;
    damageNativeVegetation: boolean;
    damageSensitiveVegetation: boolean;
    damageWeeds: boolean;
    damageWetland: boolean;
    damageBiodiversity: boolean;
    damageWater: boolean;
    damageBuildings: boolean;
    damageFences: boolean;
    damageCultural: boolean;
    damageTucker: boolean;
    damageLivestockDisease: boolean;
    damageNuisance: boolean;
    damageOther: boolean;
    damageOtherSpec: string;
}

export interface ISiteEventDamageRabbit extends ISiteEvent, IHasSiteNumber, IHasPropertyName
{
    damageCompetitionPasture?: boolean;
    damageSoil?: boolean;
    damageProductivity?: boolean;
    damageBuildings?: boolean;
    damageNativeVeg?: boolean;
    damageWeeds?: boolean;
    damageCompetitionAnimals?: boolean;
    damageSites?: boolean;
    damageGarden?: boolean;
    damageBiodiversity?: boolean;
    damageCrops?: boolean;
    damagePrograms?: boolean;
    damageVehicles?: boolean;
    damageSport?: boolean;
    damageDigging?: boolean;
    damageOther?: boolean;
    damageOtherSpec: string;
}

export interface ISiteEventDamageStarling extends ISiteEvent
{
    damageRoof?: boolean;
    damageNative?: boolean;
    damageCrops?: boolean;
    damageScavenging?: boolean;
    damageSocialGrounds?: boolean;
    damagePets?: boolean;
    damagePetFood?: boolean;
    damageRoosting?: boolean;
    damageHumans?: boolean;
    damageFoodStock?: boolean;
    damageHome?: boolean;
    damageBirdDroppings?: boolean;
    damageOther?: boolean;
    damageOtherSpec: string;
}

export interface ISiteEventDamageToad extends ISiteEvent, IHasPropertyName
{
    damagePoison?: boolean;
    damagePets?: boolean;
    damageHome?: boolean;
    damageWater?: boolean;
    damageNative?: boolean;
    damageBees?: boolean;
    damagePublic?: boolean;
    damageHumans?: boolean;
    damageSwimmingPools?: boolean;
    damageCompetition?: boolean;
    damageDungBeetles?: boolean;
    damageFinacial?: boolean;
    damageTucker?: boolean;
    damageSacred?: boolean;
    damageEcoTourism?: boolean;
    damageOther?: boolean;
    damageOtherSpec: string;
    emailNsw: string;
}

export interface ISiteEventDamageWildDog extends ISiteEvent, IHasSiteNumber, IHasPropertyName
{
    damageSheep?: boolean;
    damageSheepNumberKilled: string;
    damageSheepNumberMauled: string;
    damageGoats?: boolean;
    damageGoatsNumberKilled: string;
    damageGoatsNumberMauled: string;
    damageCalves?: boolean;
    damageCalvesNumberKilled: string;
    damageCalvesNumberMauled: string;
    damageCattle?: boolean;
    damageCattleNumberKilled: string;
    damageCattleNumberMauled: string;
    damagePoultry?: boolean;
    damagePoultryNumberKilled: string;
    damagePoultryNumberMauled: string;
    damageDomestic?: boolean;
    damageDomesticNumberKilled: string;
    damageDomesticNumberMauled: string;
    damageDogs?: boolean;
    damageNative?: boolean;
    damageHuman?: boolean;
    damageAttackHuman?: boolean;
    damageRubbish?: boolean;
    damageHorses?: boolean;
    damageOther?: boolean;
    damageOtherSpec: string;
    damageLambs?: boolean;
    damageLambsNumberKilled: string;
    damageLambsNumberMauled: string;
    damageGoatKids?: boolean;
    damageGoatKidsNumberKilled: string;
    damageGoatKidsNumberMauled: string;
    damageDogsNumberKilled: string;
    damageDogsNumberMauled: string;
}

export interface ISiteEventDiseaseRabbit extends ISiteEvent, IHasSiteNumber
{
    diseaseTypeScore?: number;
    samplingKit?: number;
    postalAddress: string;
    diseaseStatusScore?: number;
    broadscaleSite?: boolean;
    uniqueLabel: string;
    vialNumber: string;
    k5ReleasedRecently?: number;
    rabbitTypeScore?: number;
    petBreed: string;
    petNumberAtRisk: string;
    petNumberSick: string;
    petNumberDead: string;
    vaccinatedScore?: number;
    juvenileScore?: number;
    sexScore?: number;
    k5ReleasedRecentlyDate?: string;
    vaccinatedDate?: string;
}

export interface ISiteEventManagementDeer extends ISiteEvent
{
}

export interface ISiteEventManagementWildDog extends ISiteEvent
{
}

export interface ISiteEventSightingCamel extends ISiteEvent
{
    camelAbundanceScore?: number;
}

export interface ISiteEventSightingDeer extends ISiteEvent, IHasSubSpeciesId, IHasSiteNumber, IHasPropertyName
{
    deerAbundanceScore?: number;
    deerAgeScore?: number;
    deerSexScore?: number;
    deerSightingType?: number;
}

export interface ISiteEventSightingFeralCat extends ISiteEvent, IHasSiteNumber, IHasPropertyName
{
    feralCatAbundanceScore?: number;
    feralCatSightingType?: number;
    feralCatSightingAgeScore?: number;
    feralCatSightingTypeScat?: boolean;
    feralCatSightingTypeTrack?: boolean;
    feralCatSightingTypeOdour?: boolean;
    feralCatColourScore?: number;
    feralCatColourOtherSpec: string;
    feralCatHabitatRoadside?: boolean;
    feralCatHabitatVegetation?: boolean;
    feralCatHabitatFarmland?: boolean;
    feralCatHabitatOther?: boolean;
    feralCatHabitatOtherSpec: string;
    testData?: boolean;
}

export interface ISiteEventSightingFeralFish extends ISiteEvent, IHasSubSpeciesId
{
    testData?: boolean;
    feralFishSightingType?: number;
    feralFishSize?: number;
    behaviourSpawning?: boolean;
    behaviourSchooling?: boolean;
    behaviourFeeding?: boolean;
    behaviourSwimming?: boolean;
    behaviourNotApplicable?: boolean;
    behaviourOther?: boolean;
    behaviourOtherSpec: string;
    feralFishAbundanceScore?: number;
    feralFishHabitat?: number;
    feralFishHabitatOtherSpec: string;
    microHabitatLogsSnags?: boolean;
    microHabitatAmongRocks?: boolean;
    microHabitatOpenWaterAtSurface?: boolean;
    microHabitatAmongWaterPlants?: boolean;
    microHabitatAtWatersEdge?: boolean;
    microHabitatOther?: boolean;
    microHabitatOtherSpec: string;
    habitatDegradationTurbidMuddyWater?: boolean;
    habitatDegradationInstreamBankErosion?: boolean;
    habitatDegradationErosionInRiparianZone?: boolean;
    habitatDegradationWillowsPresent?: boolean;
    habitatDegradationLivestockPresent?: boolean;
    habitatDegradationSiltSandBuildUp?: boolean;
    habitatDegradationNoDegradation?: boolean;
    habitatDegradationOther?: boolean;
    habitatDegradationOtherSpec: string;
    feralFishSpeciesOther: string;
}

export interface ISiteEventSightingFeralGoat extends ISiteEvent, IHasPropertyName
{
    feralGoatAbundanceScore?: number;
    feralGoatAbundanceScoreNew?: number;
}

export interface ISiteEventSightingFeralPig extends ISiteEvent, IHasPropertyName, IHasSiteNumber
{
    feralPigAbundanceScore?: number;
    feralPigSightingType?: number;
}

export interface ISiteEventSightingFox extends ISiteEvent, IHasSiteNumber, IHasPropertyName
{
    foxSightingType?: number;
    foxAbundanceScore?: number;
    foxNightScore?: number;
    foxAbundanceScoreNew?: number;
    foxSightingAgeScore?: number;
}

export interface ISiteEventSightingMouse extends ISiteEvent
{
    testData?: boolean;
    mouseCroppingStageScore?: number;
    mouseAbundanceNotAssessed?: boolean;
    mouseAbundanceScore?: number;
    mouseAbundanceEstimate?: number;
    mouseAbundanceEstimateSpec: string;
    damageSeenPasture?: number;
    damageSeenFarmBuildings?: number;
    damageSeenStubble?: number;
    damageSeenStubbleWheat?: number;
    damageSeenStubbleCanola?: number;
    damageSeenStubbleSorghum?: number;
    damageSeenStubbleBarley?: number;
    damageSeenStubbleOther?: number;
    damageSeenStubbleOtherSpec: string;
    damageSeenCrop?: number;
    damageSeenCropWheat?: number;
    damageSeenCropCanola?: number;
    damageSeenCropSorghum?: number;
    damageSeenCropBarley?: number;
    damageSeenCropOther?: number;
    damageSeenCropOtherSpec: string;
    damageNone?: boolean;
    damageScore?: number;
    damageWheat?: boolean;
    damageStoredGrain?: boolean;
    damageElecOrMachinery?: boolean;
    damageNuisance?: boolean;
    damageCanola?: boolean;
    damageSorghum?: boolean;
    damageBarley?: boolean;
    damageOther?: boolean;
    damageOtherSpec: string;
    damageTotalArea: string;
    damageOccurredSowing?: boolean;
    damageOccurredSeedling?: boolean;
    damageOccurredTillering?: boolean;
    damageOccurredFlowering?: boolean;
    damageOccurredPriorToHarvest?: boolean;
    damageOccurredOther?: boolean;
    damageOccurredOtherSpec: string;
    techniqueNone?: boolean;
    techniqueBurnStubble?: boolean;
    techniqueSprayWeeds?: boolean;
    techniqueCultivate?: boolean;
    techniqueBaitWithPoison?: boolean;
    techniqueSetMouseTraps?: boolean;
    techniqueCoverFood?: boolean;
    techniqueOther?: boolean;
    techniqueOtherSpec: string;
    poisonBaitApplication?: number;
    poisonBaitApplicationOtherSpec: string;
    farmingCroppingOnly?: boolean;
    farmingCropping80Grazing20?: boolean;
    farmingCropping50Grazing50?: boolean;
    farmingConservationDirectDrill?: boolean;
    farmingIrrigation?: boolean;
    farmingOther?: boolean;
    farmingOtherSpec: string;
    mobile: string;
}

export interface ISiteEventSightingMyna extends ISiteEvent, IHasSiteNumber, IHasPropertyName
{
    mynaAbundanceScore?: number;
    mynaNestingScore?: number;
    mynaRoostingScore?: number;
    mynaSightingType?: number;
}

export interface ISiteEventSightingNewPests extends ISiteEvent, IHasSiteNumber
{
    phoneNumber: string;
    fullName: string;
    streetAddress: string;
    species?: number;
    sightingDescription: string;
    abundance?: number;
    describeWhere: string;
    possession?: number;
    type?: number;
    agreeShareReport?: boolean;
    adminAssessment?: number;
    adminEnvironment?: number;
    adminNotes: string;
}

export interface ISiteEventSightingOtherPests extends ISiteEvent, IHasSubSpeciesId, IHasPropertyName, IHasSiteNumber
{
    otherPestsAbundanceScore?: number;
}

export interface ISiteEventSightingRabbit extends ISiteEvent, IHasSiteNumber, IHasPropertyName
{
    inspectionArea?: number;
    rabbitAbundanceScore?: number;
    rabbitDungSightings?: number;
    rabbitWarrensBurrows?: number;
    rabbitAbundanceScoreOld?: number;
    rabbitSpotlightAbundanceScore?: number;
    rabbitActiveEntrancesScore?: number;
    k5Released: boolean;
    broadscaleSite: boolean;
    spotlightTransectLength?: number;
    spotlightCount1?: number;
    spotlightCount2?: number;
    spotlightCount3?: number;
    platformVersion: string;
}

export interface ISiteEventSightingStarling extends ISiteEvent
{
    starlingAbundanceScore?: number;
}

export interface ISiteEventSightingToad extends ISiteEvent, IHasAdministratorAssessment, IHasPropertyName
{
    phoneNumber: string;
    fullName: string;
    streetAddress: string;
    toadAbundanceScore?: number;
    age?: number;
    describeWhere: string;
    possessionScore?: number;
    typeScore?: number;
    removedFromEnvironment?: number;
    administratorNotes: string;
    emailNsw: string;
}

export interface IHasAdministratorAssessment
{
    administratorAssessment?: number;
}

export interface ISiteEventSightingWildDog extends ISiteEvent, IHasSiteNumber, IHasPropertyName
{
    wildDogAbundanceScore?: number;
    wildDogSightingType?: number;
    wildDogSightingAgeScore?: number;
    sex?: number;
    colour?: number;
    recommendationMonitor?: boolean;
    recommendationMonitorScore?: number;
    recommendationConsider?: boolean;
    recommendationConsiderScore?: number;
    recommendationNone?: boolean;
    recommendationOther?: boolean;
}

export interface IFormFieldValidation
{
    validation?: FormValidation[];
}

export interface IFormFieldDisplayCondition
{
    conditions?: FormFieldDisplayCondition[];
}

export interface IHasParent
{
    parentId?: number;
    parentType?: FormFieldType;
}

export interface IFormFieldRow
{
    row?: boolean;
    rowRatio?: number;
}

export interface IFormFieldRowNative
{
    rowNative?: boolean;
    rowNativeRatio?: number;
}

export interface IFormFieldTitle
{
    title?: string;
    titleWidth?: number;
    titleHeight?: number;
    titlePos?: TitlePosition;
}

export interface IFormFieldTitleNative
{
    titleNative?: string;
    titleNativeWidth?: number;
    titleNativeHeight?: number;
    titleNativePos?: TitlePosition;
}

export interface IHasChildren
{
    children?: IFormField[];
}

export interface ISiteEventExport
{
    id: string;
    parentId?: number;
    modifiedByUserId?: number;
    dateEntered: string;
    obsolete: boolean;
    latitude: string;
    longitude: string;
    state: string;
    startDateTime?: string;
    comments: string;
    userId?: number;
    userEmail: string;
    userFullName: string;
    userMobile: string;
    userIsMemberOfCommunityGroup: boolean;
    platformType: string;
    imageUrl: string[];
    markerURL: string;
    privateData?: boolean;
    llsRegionId?: number;
    llsRegionName?: string;
    lgaRegionId?: number;
    lgaRegionName?: string;
}

export interface ISiteEventAla
{
    occurrenceID: string;
    dateEntered: string;
    decimalLatitude: string;
    decimalLongitude: string;
    stateProvince: string;
    eventDate?: string;
    recordedByID?: number;
    scientificName: string;
}

export interface IBinarySerialize
{
}

export interface ISqlSpatialGridIndexable
{
}

export class UserRegistrationResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public userId: string;
    public sessionId: string;
    public userName: string;
    public displayName: string;
    public bearerToken: string;
    public refreshToken: string;

    public constructor(init?: Partial<UserRegistrationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ForgotPasswordResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ForgotPasswordResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetCommunityGroupsResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public groups?: CommunityGroupExport[];

    public constructor(init?: Partial<GetCommunityGroupsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ExportCommunityGroupMembersResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public members?: CommunityGroupMemberExport[];

    public constructor(init?: Partial<ExportCommunityGroupMembersResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class DataAccessRegionPolygonJsonsResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public listOfPolygonStringLists: DataAccessRestrictedPolygon[];

    public constructor(init?: Partial<DataAccessRegionPolygonJsonsResponse>) { (Object as any).assign(this, init); }
}

export class SearchExternalRecordResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public externalRecords: ExternalRecord[];

    public constructor(init?: Partial<SearchExternalRecordResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetExternalRecordSyncScheduleResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public externalRecordSyncSchedule?: ExternalRecordSyncSchedule;

    public constructor(init?: Partial<GetExternalRecordSyncScheduleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetAllExternalRecordSyncSchedulesResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public externalRecordSyncSchedules?: ExternalRecordSyncSchedule[];

    public constructor(init?: Partial<GetAllExternalRecordSyncSchedulesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UpdateExternalRecordSyncScheduleLastSyncDateResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public externalRecordSyncSchedule?: ExternalRecordSyncSchedule;

    public constructor(init?: Partial<UpdateExternalRecordSyncScheduleLastSyncDateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetExternalRecordLastestEventDateBySpeciesResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public lastestEventDate?: string;

    public constructor(init?: Partial<GetExternalRecordLastestEventDateBySpeciesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class BulkSaveExternalRecordsResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<BulkSaveExternalRecordsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ObsoleteExternalRecordResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<ObsoleteExternalRecordResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ExternalRecordCountResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public count: number;

    public constructor(init?: Partial<ExternalRecordCountResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetKmlUrlByRegionIdResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public kmlFilePath?: string;

    public constructor(init?: Partial<GetKmlUrlByRegionIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetPolygonByRegionIdResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public polygon?: string;

    public constructor(init?: Partial<GetPolygonByRegionIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetUserResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public user?: User;

    public constructor(init?: Partial<GetUserResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetUserGroupsConfigResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public communityGroups?: CommunityGroup[];

    // @DataMember(Order=3)
    public pendingCommunityGroups?: CommunityGroup[];

    // @DataMember(Order=4)
    public emailNotifications?: EmailNotificationConfig[];

    // @DataMember(Order=5)
    public emailNotificationOptOuts?: EmailNotificationOptOut[];

    // @DataMember(Order=6)
    public sightingType?: SightingType[];

    // @DataMember(Order=7)
    public totalCount?: number;

    // @DataMember(Order=8)
    public communityGroupStatuses: CommunityGroupStatus[];

    public constructor(init?: Partial<GetUserGroupsConfigResponse>) { (Object as any).assign(this, init); }
}

export class UpdateUserResponse
{
    [immerable] = true;

    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<UpdateUserResponse>) { (Object as any).assign(this, init); }
}

export class UpdateUserPasswordResponse
{
    [immerable] = true;

    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<UpdateUserPasswordResponse>) { (Object as any).assign(this, init); }
}

export class UpdateUserEmailOptOutResponse
{
    [immerable] = true;

    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<UpdateUserEmailOptOutResponse>) { (Object as any).assign(this, init); }
}

export class UpdateUserGroupStatusResponse
{
    [immerable] = true;

    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<UpdateUserGroupStatusResponse>) { (Object as any).assign(this, init); }
}

export class UserDeleteResponse
{
    [immerable] = true;

    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<UserDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetSpeciesContentResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public content?: SpeciesContent;

    public constructor(init?: Partial<GetSpeciesContentResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetSpeciesNavContentResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public items?: NavMenuItem[];

    public constructor(init?: Partial<GetSpeciesNavContentResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetCommunityGroupResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public communityGroup?: CommunityGroup;

    public constructor(init?: Partial<GetCommunityGroupResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetCommunityGroupMembersResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public members: CommunityGroupMember[];

    // @DataMember(Order=3)
    public totalCount: number;

    public constructor(init?: Partial<GetCommunityGroupMembersResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetCommunityGroupsMembersResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public groupedMembers?: { [index: number]: CommunityGroupMember[]; };

    public constructor(init?: Partial<GetCommunityGroupsMembersResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PostCommunityGroupMemberDownloadRightsResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PostCommunityGroupMemberDownloadRightsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PostCommunityGroupMemberViewRightsResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PostCommunityGroupMemberViewRightsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PostRemoveCommunityGroupMemberResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PostRemoveCommunityGroupMemberResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetAllCommunityGroupMembersResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public communityGroupMembers: CommunityGroupMember[];

    public constructor(init?: Partial<GetAllCommunityGroupMembersResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetCommunityGroupDocumentsResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public communityGroupDocuments: CommunityGroupDocument[];

    public constructor(init?: Partial<GetCommunityGroupDocumentsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PostRemoveCommunityGroupDocumentResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PostRemoveCommunityGroupDocumentResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PostUploadCommunityGroupDocumentResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PostUploadCommunityGroupDocumentResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PostCommunityGroupInvitePeopleResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PostCommunityGroupInvitePeopleResponse>) { (Object as any).assign(this, init); }
}

export class PostCommunityGroupRegistrationResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PostCommunityGroupRegistrationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetSpeciesFormsResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public speciesForms?: SpeciesForm[];

    public constructor(init?: Partial<GetSpeciesFormsResponse>) { (Object as any).assign(this, init); }
}

export class PostUploadSpeciesFormFileResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<PostUploadSpeciesFormFileResponse>) { (Object as any).assign(this, init); }
}

export class PostUploadTemporaryImageResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public guid?: string;

    public constructor(init?: Partial<PostUploadTemporaryImageResponse>) { (Object as any).assign(this, init); }
}

export class PostDeleteTemporaryImageResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<PostDeleteTemporaryImageResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetTermsOfUseContentResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public content?: ContentVersion;

    public constructor(init?: Partial<GetTermsOfUseContentResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetStaticTypesResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public siteEventCollectionResponse: ISiteEventCollectionResponse<SiteEventControlCamel>;

    public constructor(init?: Partial<GetStaticTypesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetEmailTemplateResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public template: EmailTemplate;

    public constructor(init?: Partial<GetEmailTemplateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SendWelcomeEmailResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<SendWelcomeEmailResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CheckForEmailNotificationResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<CheckForEmailNotificationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SendSignUpEmailResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<SendSignUpEmailResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SendCustomAlertResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<SendCustomAlertResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SendDataAccessRequestEmailResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<SendDataAccessRequestEmailResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SendForgotPasswordResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<SendForgotPasswordResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SendFeedbackResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<SendFeedbackResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssignAnonymousSiteEventsToUserAccountResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AssignAnonymousSiteEventsToUserAccountResponse>) { (Object as any).assign(this, init); }
}

export class CoordinatesStateResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public state: string;

    public constructor(init?: Partial<CoordinatesStateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetAllRegionsResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public regions: Region[];

    public constructor(init?: Partial<GetAllRegionsResponse>) { (Object as any).assign(this, init); }
}

export class GetSubSpeciesResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public subSpecies: SubSpecies[];

    public constructor(init?: Partial<GetSubSpeciesResponse>) { (Object as any).assign(this, init); }
}

export class GetSpeciesByIdResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public species: SpeciesDto;

    public constructor(init?: Partial<GetSpeciesByIdResponse>) { (Object as any).assign(this, init); }
}

export class NewGetSiteEventResponse
{
    [immerable] = true;

    public responseStatus?: ResponseStatus;
    public siteEvent?: ISiteEvent;

    public constructor(init?: Partial<NewGetSiteEventResponse>) { (Object as any).assign(this, init); }
}

export class NewGetSiteEventCollectionResponse
{
    [immerable] = true;

    public responseStatus?: ResponseStatus;
    public siteEvents?: ISiteEvent[];
    public lookups?: Lookup[];
    public totalCount?: number;
    public chartDataByDate?: ChartGroupByMonthYear[];
    public tableData?: TableRow[];
    public groupName?: string;
    public groupChartDataSets?: GroupChartDataSet[];
    public groupChartMemberNames?: string[];
    public activeGroupMembers?: number[];
    public groupChartLabels?: string[];

    public constructor(init?: Partial<NewGetSiteEventCollectionResponse>) { (Object as any).assign(this, init); }
}

export class NewGetSiteEventGalleryCollectionResponse
{
    [immerable] = true;

    public responseStatus?: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<NewGetSiteEventGalleryCollectionResponse>) { (Object as any).assign(this, init); }
}

export class NewGetSiteEventHistoryResponse
{
    [immerable] = true;

    public responseStatus?: ResponseStatus;
    public historyItems?: HistoryItem[];

    public constructor(init?: Partial<NewGetSiteEventHistoryResponse>) { (Object as any).assign(this, init); }
}

export class NewPostInsertSiteEventResponse
{
    [immerable] = true;

    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<NewPostInsertSiteEventResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class NotificationsResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public userNotifications: UserNotification[];

    public constructor(init?: Partial<NotificationsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FlutterNotificationsResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public userNotifications: FlutterUserNotification[];

    public constructor(init?: Partial<FlutterNotificationsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class WebsiteNotificationsResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public userNotifications: WebsiteUserNotification[];

    // @DataMember(Order=3)
    public totalCount: number;

    // @DataMember(Order=4)
    public pageNumber: number;

    // @DataMember(Order=5)
    public pageSize: number;

    // @DataMember(Order=6)
    public hasNextPage: boolean;

    public constructor(init?: Partial<WebsiteNotificationsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetUnreadNotificationCountResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public totalCount: number;

    public constructor(init?: Partial<GetUnreadNotificationCountResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class NotificationViewedResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<NotificationViewedResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class DeleteNotificationResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteNotificationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RecordResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public recordDetails: string;

    // @DataMember(Order=3)
    public latitude?: string;

    // @DataMember(Order=4)
    public longitude?: string;

    public constructor(init?: Partial<RecordResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class WebsiteNotificationRecordResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public websiteNotificationRecordDetails?: string;

    // @DataMember(Order=3)
    public userNotification?: WebsiteUserNotification;

    public constructor(init?: Partial<WebsiteNotificationRecordResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CheckNotificationsResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CheckNotificationsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class QueryResponse<EmailNotificationLogDetailsDo>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public offset: number;

    // @DataMember(Order=2)
    public total: number;

    // @DataMember(Order=3)
    public results: EmailNotificationLogDetailsDo[];

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    // @DataMember(Order=5)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueryResponse<EmailNotificationLogDetailsDo>>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PostFirebaseTokenResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PostFirebaseTokenResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class DeleteFirebaseTokenResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteFirebaseTokenResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ClientAppSettingsResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public appSettings?: ClientAppSettings;

    public constructor(init?: Partial<ClientAppSettingsResponse>) { (Object as any).assign(this, init); }
}

export class GetSiteEventMetadataResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEventDefinitions: SiteEventMetadata[];

    public constructor(init?: Partial<GetSiteEventMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetSiteEventGetMarkerContentResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public id: number;
    public speciesSiteEventType: SpeciesSiteEventType;
    public latitude: string;
    public longitude: string;
    public content: string;
    public markerGalleryPhoto: GalleryPhoto;
    public siteEventMarker: SiteEventMarker;

    public constructor(init?: Partial<GetSiteEventGetMarkerContentResponse>) { (Object as any).assign(this, init); }
}

export class GetCustomSiteEventChartDataResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public tableData: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<GetCustomSiteEventChartDataResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventGetHeatmapCollectionResponse
{
    [immerable] = true;

    public weightedHeatmapLocations: WeightedHeatmapLocation[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SiteEventGetHeatmapCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventGetCollectionResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public markers: Marker[];

    public constructor(init?: Partial<SiteEventGetCollectionResponse>) { (Object as any).assign(this, init); }
}

export class PostSiteEventMarkerCollectionResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public markers: Marker[];
    public sightingMin?: number;
    public sightingMax?: number;
    public damageMin?: number;
    public damageMax?: number;
    public controlMin?: number;
    public controlMax?: number;
    public diseaseMin?: number;
    public diseaseMax?: number;
    public managementMin?: number;
    public managementMax?: number;
    public communityGroupMembers: number[];
    public lookups: { [index: string]: Lookup[]; };

    public constructor(init?: Partial<PostSiteEventMarkerCollectionResponse>) { (Object as any).assign(this, init); }
}

export class PostSiteEventMarkerContentResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public content: Marker;

    public constructor(init?: Partial<PostSiteEventMarkerContentResponse>) { (Object as any).assign(this, init); }
}

export class PostSiteEventMarkerExcludeRangesCollectionResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventMarker[];
    public sightingMin?: number;
    public sightingMax?: number;
    public damageMin?: number;
    public damageMax?: number;
    public controlMin?: number;
    public controlMax?: number;
    public diseaseMin?: number;
    public diseaseMax?: number;
    public managementMin?: number;
    public managementMax?: number;
    public communityGroupMembers: number[];
    public lookups: { [index: string]: Lookup[]; };
    public syncCutoffUtc?: string;

    public constructor(init?: Partial<PostSiteEventMarkerExcludeRangesCollectionResponse>) { (Object as any).assign(this, init); }
}

export class PostSiteEventMarkerIncludeRangesCollectionResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventMarker[];

    public constructor(init?: Partial<PostSiteEventMarkerIncludeRangesCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetMapLegendResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public legendItems?: LegendItem[];

    public constructor(init?: Partial<GetMapLegendResponse>) { (Object as any).assign(this, init); }
}

export class UpdateMapMarkersResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UpdateMapMarkersResponse>) { (Object as any).assign(this, init); }
}

export class GetGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public gallery: Gallery;

    public constructor(init?: Partial<GetGalleryResponse>) { (Object as any).assign(this, init); }
}

export class GetGalleryPhotoMetaInfoResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryPhoto: GalleryPhoto;

    public constructor(init?: Partial<GetGalleryPhotoMetaInfoResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UpdateMissingLGAAndLLSResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UpdateMissingLGAAndLLSResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UpdateMissingStatesResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UpdateMissingStatesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class DeleteSiteEventResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteSiteEventResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UpdateMissingGeoPointsResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UpdateMissingGeoPointsResponse>) { (Object as any).assign(this, init); }
}

export class GetSpeciesResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public species: SpeciesDto[];

    public constructor(init?: Partial<GetSpeciesResponse>) { (Object as any).assign(this, init); }
}

export class GetSiteEventTypesResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEventTypes: SiteEventType[];

    public constructor(init?: Partial<GetSiteEventTypesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetUsersResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public users?: UserExport[];

    public constructor(init?: Partial<GetUsersResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetWebsiteContentResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public content?: ContentDo[];

    public constructor(init?: Partial<GetWebsiteContentResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AuthenticateResponse implements IHasSessionId, IHasBearerToken
{
    [immerable] = true;

    // @DataMember(Order=1)
    public userId: string;

    // @DataMember(Order=2)
    public sessionId: string;

    // @DataMember(Order=3)
    public userName: string;

    // @DataMember(Order=4)
    public displayName: string;

    // @DataMember(Order=5)
    public referrerUrl: string;

    // @DataMember(Order=6)
    public bearerToken: string;

    // @DataMember(Order=7)
    public refreshToken: string;

    // @DataMember(Order=8)
    public refreshTokenExpiry?: string;

    // @DataMember(Order=9)
    public profileUrl: string;

    // @DataMember(Order=10)
    public roles: string[];

    // @DataMember(Order=11)
    public permissions: string[];

    // @DataMember(Order=12)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=13)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<AuthenticateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetApiKeysResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public results: UserApiKey[];

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetApiKeysResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegenerateApiKeysResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public results: UserApiKey[];

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<RegenerateApiKeysResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetAccessTokenResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public accessToken: string;

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetAccessTokenResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlCamelSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventControlCamel;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventControlCamelSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlCamelCollectionResponse implements ISiteEventCollectionResponse<SiteEventControlCamel>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventControlCamel[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventControlCamel[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventControlCamelCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlCamelCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventControlCamelCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlCamelExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventControlCamelExport[];
    public totalCount: number;
    public chartData: SiteEventControlCamelExport[];

    public constructor(init?: Partial<SiteEventControlCamelExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlCamelSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventControlCamelSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlCamelHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventControlCamelHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlDeerSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventControlDeer;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventControlDeerSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlDeerCollectionResponse implements ISiteEventCollectionResponse<SiteEventControlDeer>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventControlDeer[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventControlDeer[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventControlDeerCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlDeerCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventControlDeerCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlDeerExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventControlDeerExport[];
    public totalCount: number;
    public chartData: SiteEventControlDeerExport[];

    public constructor(init?: Partial<SiteEventControlDeerExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlDeerSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventControlDeerSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlDeerHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventControlDeerHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralCatSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventControlFeralCat;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventControlFeralCatSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralCatCollectionResponse implements ISiteEventCollectionResponse<SiteEventControlFeralCat>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventControlFeralCat[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventControlFeralCat[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventControlFeralCatCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralCatCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventControlFeralCatCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralCatExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventControlFeralCatExport[];
    public totalCount: number;
    public chartData: SiteEventControlFeralCatExport[];

    public constructor(init?: Partial<SiteEventControlFeralCatExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralCatSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventControlFeralCatSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralCatHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventControlFeralCatHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralFishSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventControlFeralFish;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventControlFeralFishSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralFishCollectionResponse implements ISiteEventCollectionResponse<SiteEventControlFeralFish>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventControlFeralFish[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventControlFeralFish[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventControlFeralFishCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralFishCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventControlFeralFishCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralFishExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventControlFeralFishExport[];
    public totalCount: number;
    public chartData: SiteEventControlFeralFishExport[];

    public constructor(init?: Partial<SiteEventControlFeralFishExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralFishSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventControlFeralFishSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralFishHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventControlFeralFishHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralGoatSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventControlFeralGoat;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventControlFeralGoatSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralGoatCollectionResponse implements ISiteEventCollectionResponse<SiteEventControlFeralGoat>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventControlFeralGoat[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventControlFeralGoat[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventControlFeralGoatCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralGoatCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventControlFeralGoatCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralGoatExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventControlFeralGoatExport[];
    public totalCount: number;
    public chartData: SiteEventControlFeralGoatExport[];

    public constructor(init?: Partial<SiteEventControlFeralGoatExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralGoatSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventControlFeralGoatSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralGoatHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventControlFeralGoatHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralPigSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventControlFeralPig;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventControlFeralPigSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralPigCollectionResponse implements ISiteEventCollectionResponse<SiteEventControlFeralPig>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventControlFeralPig[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventControlFeralPig[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventControlFeralPigCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralPigCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventControlFeralPigCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralPigExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventControlFeralPigExport[];
    public totalCount: number;
    public chartData: SiteEventControlFeralPigExport[];

    public constructor(init?: Partial<SiteEventControlFeralPigExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralPigSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventControlFeralPigSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFeralPigHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventControlFeralPigHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFoxSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventControlFox;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventControlFoxSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFoxCollectionResponse implements ISiteEventCollectionResponse<SiteEventControlFox>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventControlFox[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventControlFox[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventControlFoxCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFoxCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventControlFoxCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFoxExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventControlFoxExport[];
    public totalCount: number;
    public chartData: SiteEventControlFoxExport[];

    public constructor(init?: Partial<SiteEventControlFoxExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFoxSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventControlFoxSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlFoxHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventControlFoxHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlMouseSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventControlMouse;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventControlMouseSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlMouseCollectionResponse implements ISiteEventCollectionResponse<SiteEventControlMouse>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventControlMouse[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventControlMouse[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventControlMouseCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlMouseCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventControlMouseCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlMouseExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventControlMouseExport[];
    public totalCount: number;
    public chartData: SiteEventControlMouseExport[];

    public constructor(init?: Partial<SiteEventControlMouseExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlMouseSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventControlMouseSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlMouseHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventControlMouseHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlMynaSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventControlMyna;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventControlMynaSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlMynaCollectionResponse implements ISiteEventCollectionResponse<SiteEventControlMyna>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventControlMyna[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventControlMyna[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventControlMynaCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlMynaCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventControlMynaCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlMynaExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventControlMynaExport[];
    public totalCount: number;
    public chartData: SiteEventControlMynaExport[];

    public constructor(init?: Partial<SiteEventControlMynaExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlMynaSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventControlMynaSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlMynaHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventControlMynaHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlOtherPestsSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventControlOtherPests;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventControlOtherPestsSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlOtherPestsCollectionResponse implements ISiteEventCollectionResponse<SiteEventControlOtherPests>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventControlOtherPests[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventControlOtherPests[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventControlOtherPestsCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlOtherPestsCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventControlOtherPestsCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlOtherPestsExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventControlOtherPestsExport[];
    public totalCount: number;
    public chartData: SiteEventControlOtherPestsExport[];

    public constructor(init?: Partial<SiteEventControlOtherPestsExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlOtherPestsSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventControlOtherPestsSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlOtherPestsHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventControlOtherPestsHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlRabbitSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventControlRabbit;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventControlRabbitSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlRabbitCollectionResponse implements ISiteEventCollectionResponse<SiteEventControlRabbit>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventControlRabbit[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventControlRabbit[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventControlRabbitCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlRabbitCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventControlRabbitCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlRabbitExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventControlRabbitExport[];
    public totalCount: number;
    public chartData: SiteEventControlRabbitExport[];

    public constructor(init?: Partial<SiteEventControlRabbitExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlRabbitSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventControlRabbitSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlRabbitHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventControlRabbitHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlStarlingSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventControlStarling;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventControlStarlingSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlStarlingCollectionResponse implements ISiteEventCollectionResponse<SiteEventControlStarling>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventControlStarling[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventControlStarling[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventControlStarlingCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlStarlingCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventControlStarlingCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlStarlingExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventControlStarlingExport[];
    public totalCount: number;
    public chartData: SiteEventControlStarlingExport[];

    public constructor(init?: Partial<SiteEventControlStarlingExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlStarlingSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventControlStarlingSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlStarlingHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventControlStarlingHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlToadSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventControlToad;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventControlToadSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlToadCollectionResponse implements ISiteEventCollectionResponse<SiteEventControlToad>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventControlToad[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventControlToad[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventControlToadCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlToadCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventControlToadCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlToadExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventControlToadExport[];
    public totalCount: number;
    public chartData: SiteEventControlToadExport[];

    public constructor(init?: Partial<SiteEventControlToadExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlToadSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventControlToadSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlToadHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventControlToadHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlWildDogSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventControlWildDog;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventControlWildDogSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlWildDogCollectionResponse implements ISiteEventCollectionResponse<SiteEventControlWildDog>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventControlWildDog[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventControlWildDog[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventControlWildDogCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlWildDogCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventControlWildDogCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlWildDogExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventControlWildDogExport[];
    public totalCount: number;
    public chartData: SiteEventControlWildDogExport[];

    public constructor(init?: Partial<SiteEventControlWildDogExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlWildDogSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventControlWildDogSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventControlWildDogHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventControlWildDogHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageCamelSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventDamageCamel;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventDamageCamelSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageCamelCollectionResponse implements ISiteEventCollectionResponse<SiteEventDamageCamel>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventDamageCamel[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventDamageCamel[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventDamageCamelCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageCamelCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventDamageCamelCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageCamelExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventDamageCamelExport[];
    public totalCount: number;
    public chartData: SiteEventDamageCamelExport[];

    public constructor(init?: Partial<SiteEventDamageCamelExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageCamelSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventDamageCamelSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageCamelHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventDamageCamelHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageDeerSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventDamageDeer;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventDamageDeerSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageDeerCollectionResponse implements ISiteEventCollectionResponse<SiteEventDamageDeer>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventDamageDeer[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventDamageDeer[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventDamageDeerCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageDeerCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventDamageDeerCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageDeerExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventDamageDeerExport[];
    public totalCount: number;
    public chartData: SiteEventDamageDeerExport[];

    public constructor(init?: Partial<SiteEventDamageDeerExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageDeerSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventDamageDeerSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageDeerHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventDamageDeerHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralCatSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventDamageFeralCat;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventDamageFeralCatSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralCatCollectionResponse implements ISiteEventCollectionResponse<SiteEventDamageFeralCat>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventDamageFeralCat[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventDamageFeralCat[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventDamageFeralCatCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralCatCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventDamageFeralCatCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralCatExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventDamageFeralCatExport[];
    public totalCount: number;
    public chartData: SiteEventDamageFeralCatExport[];

    public constructor(init?: Partial<SiteEventDamageFeralCatExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralCatSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventDamageFeralCatSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralCatHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventDamageFeralCatHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralFishSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventDamageFeralFish;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventDamageFeralFishSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralFishCollectionResponse implements ISiteEventCollectionResponse<SiteEventDamageFeralFish>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventDamageFeralFish[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventDamageFeralFish[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventDamageFeralFishCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralFishCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventDamageFeralFishCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralFishExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventDamageFeralFishExport[];
    public totalCount: number;
    public chartData: SiteEventDamageFeralFishExport[];

    public constructor(init?: Partial<SiteEventDamageFeralFishExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralFishSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventDamageFeralFishSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralFishHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventDamageFeralFishHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralGoatSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventDamageFeralGoat;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventDamageFeralGoatSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralGoatCollectionResponse implements ISiteEventCollectionResponse<SiteEventDamageFeralGoat>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventDamageFeralGoat[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventDamageFeralGoat[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventDamageFeralGoatCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralGoatCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventDamageFeralGoatCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralGoatExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventDamageFeralGoatExport[];
    public totalCount: number;
    public chartData: SiteEventDamageFeralGoatExport[];

    public constructor(init?: Partial<SiteEventDamageFeralGoatExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralGoatSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventDamageFeralGoatSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralGoatHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventDamageFeralGoatHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralPigSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventDamageFeralPig;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventDamageFeralPigSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralPigCollectionResponse implements ISiteEventCollectionResponse<SiteEventDamageFeralPig>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventDamageFeralPig[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventDamageFeralPig[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventDamageFeralPigCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralPigCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventDamageFeralPigCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralPigExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventDamageFeralPigExport[];
    public totalCount: number;
    public chartData: SiteEventDamageFeralPigExport[];

    public constructor(init?: Partial<SiteEventDamageFeralPigExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralPigSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventDamageFeralPigSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFeralPigHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventDamageFeralPigHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFoxSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventDamageFox;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventDamageFoxSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFoxCollectionResponse implements ISiteEventCollectionResponse<SiteEventDamageFox>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventDamageFox[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventDamageFox[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventDamageFoxCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFoxCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventDamageFoxCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFoxExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventDamageFoxExport[];
    public totalCount: number;
    public chartData: SiteEventDamageFoxExport[];

    public constructor(init?: Partial<SiteEventDamageFoxExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFoxSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventDamageFoxSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageFoxHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventDamageFoxHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageMouseSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventDamageMouse;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventDamageMouseSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageMouseCollectionResponse implements ISiteEventCollectionResponse<SiteEventDamageMouse>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventDamageMouse[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventDamageMouse[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventDamageMouseCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageMouseCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventDamageMouseCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageMouseExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventDamageMouseExport[];
    public totalCount: number;
    public chartData: SiteEventDamageMouseExport[];

    public constructor(init?: Partial<SiteEventDamageMouseExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageMouseSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventDamageMouseSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageMouseHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventDamageMouseHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageMynaSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventDamageMyna;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventDamageMynaSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageMynaCollectionResponse implements ISiteEventCollectionResponse<SiteEventDamageMyna>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventDamageMyna[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventDamageMyna[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventDamageMynaCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageMynaCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventDamageMynaCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageMynaExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventDamageMynaExport[];
    public totalCount: number;
    public chartData: SiteEventDamageMynaExport[];

    public constructor(init?: Partial<SiteEventDamageMynaExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageMynaSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventDamageMynaSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageMynaHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventDamageMynaHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageOtherPestsSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventDamageOtherPests;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventDamageOtherPestsSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageOtherPestsCollectionResponse implements ISiteEventCollectionResponse<SiteEventDamageOtherPests>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventDamageOtherPests[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventDamageOtherPests[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventDamageOtherPestsCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageOtherPestsCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventDamageOtherPestsCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageOtherPestsExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventDamageOtherPestsExport[];
    public totalCount: number;
    public chartData: SiteEventDamageOtherPestsExport[];

    public constructor(init?: Partial<SiteEventDamageOtherPestsExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageOtherPestsSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventDamageOtherPestsSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageOtherPestsHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventDamageOtherPestsHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageRabbitSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventDamageRabbit;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventDamageRabbitSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageRabbitCollectionResponse implements ISiteEventCollectionResponse<SiteEventDamageRabbit>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventDamageRabbit[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventDamageRabbit[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventDamageRabbitCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageRabbitCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventDamageRabbitCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageRabbitExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventDamageRabbitExport[];
    public totalCount: number;
    public chartData: SiteEventDamageRabbitExport[];

    public constructor(init?: Partial<SiteEventDamageRabbitExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageRabbitSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventDamageRabbitSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageRabbitHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventDamageRabbitHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageStarlingSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventDamageStarling;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventDamageStarlingSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageStarlingCollectionResponse implements ISiteEventCollectionResponse<SiteEventDamageStarling>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventDamageStarling[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventDamageStarling[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventDamageStarlingCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageStarlingCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventDamageStarlingCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageStarlingExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventDamageStarlingExport[];
    public totalCount: number;
    public chartData: SiteEventDamageStarlingExport[];

    public constructor(init?: Partial<SiteEventDamageStarlingExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageStarlingSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventDamageStarlingSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageStarlingHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventDamageStarlingHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageToadSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventDamageToad;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventDamageToadSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageToadCollectionResponse implements ISiteEventCollectionResponse<SiteEventDamageToad>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventDamageToad[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventDamageToad[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventDamageToadCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageToadCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventDamageToadCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageToadExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventDamageToadExport[];
    public totalCount: number;
    public chartData: SiteEventDamageToadExport[];

    public constructor(init?: Partial<SiteEventDamageToadExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageToadSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventDamageToadSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageToadHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventDamageToadHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageWildDogSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventDamageWildDog;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventDamageWildDogSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageWildDogCollectionResponse implements ISiteEventCollectionResponse<SiteEventDamageWildDog>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventDamageWildDog[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventDamageWildDog[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventDamageWildDogCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageWildDogCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventDamageWildDogCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageWildDogExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventDamageWildDogExport[];
    public totalCount: number;
    public chartData: SiteEventDamageWildDogExport[];

    public constructor(init?: Partial<SiteEventDamageWildDogExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageWildDogSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventDamageWildDogSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDamageWildDogHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventDamageWildDogHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDiseaseRabbitSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventDiseaseRabbit;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventDiseaseRabbitSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDiseaseRabbitCollectionResponse implements ISiteEventCollectionResponse<SiteEventDiseaseRabbit>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventDiseaseRabbit[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventDiseaseRabbit[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventDiseaseRabbitCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDiseaseRabbitCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventDiseaseRabbitCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDiseaseRabbitExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventDiseaseRabbitExport[];
    public totalCount: number;
    public chartData: SiteEventDiseaseRabbitExport[];

    public constructor(init?: Partial<SiteEventDiseaseRabbitExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDiseaseRabbitSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventDiseaseRabbitSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventDiseaseRabbitHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventDiseaseRabbitHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventManagementDeerSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventManagementDeer;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventManagementDeerSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventManagementDeerCollectionResponse implements ISiteEventCollectionResponse<SiteEventManagementDeer>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventManagementDeer[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventManagementDeer[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventManagementDeerCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventManagementDeerCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventManagementDeerCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventManagementDeerExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventManagementDeerExport[];
    public totalCount: number;
    public chartData: SiteEventManagementDeerExport[];

    public constructor(init?: Partial<SiteEventManagementDeerExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventManagementDeerSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventManagementDeerSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventManagementDeerHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventManagementDeerHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventManagementWildDogSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventManagementWildDog;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventManagementWildDogSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventManagementWildDogCollectionResponse implements ISiteEventCollectionResponse<SiteEventManagementWildDog>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventManagementWildDog[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventManagementWildDog[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventManagementWildDogCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventManagementWildDogCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventManagementWildDogCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventManagementWildDogExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventManagementWildDogExport[];
    public totalCount: number;
    public chartData: SiteEventManagementWildDogExport[];

    public constructor(init?: Partial<SiteEventManagementWildDogExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventManagementWildDogSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventManagementWildDogSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventManagementWildDogHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventManagementWildDogHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingCamelSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventSightingCamel;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventSightingCamelSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingCamelCollectionResponse implements ISiteEventCollectionResponse<SiteEventSightingCamel>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingCamel[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventSightingCamel[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventSightingCamelCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingCamelCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventSightingCamelCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingCamelExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingCamelExport[];
    public totalCount: number;
    public chartData: SiteEventSightingCamelExport[];

    public constructor(init?: Partial<SiteEventSightingCamelExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingCamelSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventSightingCamelSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingCamelHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventSightingCamelHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingDeerSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventSightingDeer;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventSightingDeerSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingDeerCollectionResponse implements ISiteEventCollectionResponse<SiteEventSightingDeer>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingDeer[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventSightingDeer[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventSightingDeerCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingDeerCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventSightingDeerCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingDeerExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingDeerExport[];
    public totalCount: number;
    public chartData: SiteEventSightingDeerExport[];

    public constructor(init?: Partial<SiteEventSightingDeerExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingDeerSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventSightingDeerSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingDeerHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventSightingDeerHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingDeerAlaResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingDeerAla[];
    public totalCount: number;

    public constructor(init?: Partial<SiteEventSightingDeerAlaResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralCatSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventSightingFeralCat;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventSightingFeralCatSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralCatCollectionResponse implements ISiteEventCollectionResponse<SiteEventSightingFeralCat>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingFeralCat[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventSightingFeralCat[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventSightingFeralCatCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralCatCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventSightingFeralCatCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralCatExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingFeralCatExport[];
    public totalCount: number;
    public chartData: SiteEventSightingFeralCatExport[];

    public constructor(init?: Partial<SiteEventSightingFeralCatExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralCatSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventSightingFeralCatSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralCatHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventSightingFeralCatHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralCatAlaResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingFeralCatAla[];
    public totalCount: number;

    public constructor(init?: Partial<SiteEventSightingFeralCatAlaResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralFishSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventSightingFeralFish;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventSightingFeralFishSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralFishCollectionResponse implements ISiteEventCollectionResponse<SiteEventSightingFeralFish>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingFeralFish[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventSightingFeralFish[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventSightingFeralFishCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralFishCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventSightingFeralFishCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralFishExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingFeralFishExport[];
    public totalCount: number;
    public chartData: SiteEventSightingFeralFishExport[];

    public constructor(init?: Partial<SiteEventSightingFeralFishExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralFishSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventSightingFeralFishSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralFishHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventSightingFeralFishHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralFishAlaResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingFeralFishAla[];
    public totalCount: number;

    public constructor(init?: Partial<SiteEventSightingFeralFishAlaResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralGoatSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventSightingFeralGoat;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventSightingFeralGoatSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralGoatCollectionResponse implements ISiteEventCollectionResponse<SiteEventSightingFeralGoat>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingFeralGoat[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventSightingFeralGoat[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventSightingFeralGoatCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralGoatCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventSightingFeralGoatCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralGoatExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingFeralGoatExport[];
    public totalCount: number;
    public chartData: SiteEventSightingFeralGoatExport[];

    public constructor(init?: Partial<SiteEventSightingFeralGoatExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralGoatSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventSightingFeralGoatSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralGoatHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventSightingFeralGoatHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralGoatAlaResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingFeralGoatAla[];
    public totalCount: number;

    public constructor(init?: Partial<SiteEventSightingFeralGoatAlaResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralPigSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventSightingFeralPig;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventSightingFeralPigSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralPigCollectionResponse implements ISiteEventCollectionResponse<SiteEventSightingFeralPig>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingFeralPig[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventSightingFeralPig[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventSightingFeralPigCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralPigCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventSightingFeralPigCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralPigExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingFeralPigExport[];
    public totalCount: number;
    public chartData: SiteEventSightingFeralPigExport[];

    public constructor(init?: Partial<SiteEventSightingFeralPigExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralPigSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventSightingFeralPigSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralPigHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventSightingFeralPigHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFeralPigAlaResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingFeralPigAla[];
    public totalCount: number;

    public constructor(init?: Partial<SiteEventSightingFeralPigAlaResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFoxSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventSightingFox;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventSightingFoxSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFoxCollectionResponse implements ISiteEventCollectionResponse<SiteEventSightingFox>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingFox[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventSightingFox[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventSightingFoxCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFoxCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventSightingFoxCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFoxExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingFoxExport[];
    public totalCount: number;
    public chartData: SiteEventSightingFoxExport[];

    public constructor(init?: Partial<SiteEventSightingFoxExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFoxSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventSightingFoxSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFoxHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventSightingFoxHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingFoxAlaResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingFoxAla[];
    public totalCount: number;

    public constructor(init?: Partial<SiteEventSightingFoxAlaResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingMouseSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventSightingMouse;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventSightingMouseSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingMouseCollectionResponse implements ISiteEventCollectionResponse<SiteEventSightingMouse>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingMouse[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventSightingMouse[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventSightingMouseCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingMouseCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventSightingMouseCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingMouseExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingMouseExport[];
    public totalCount: number;
    public chartData: SiteEventSightingMouseExport[];

    public constructor(init?: Partial<SiteEventSightingMouseExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingMouseSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventSightingMouseSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingMouseHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventSightingMouseHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingMouseAlaResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingMouseAla[];
    public totalCount: number;

    public constructor(init?: Partial<SiteEventSightingMouseAlaResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingMynaSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventSightingMyna;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventSightingMynaSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingMynaCollectionResponse implements ISiteEventCollectionResponse<SiteEventSightingMyna>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingMyna[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventSightingMyna[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventSightingMynaCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingMynaCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventSightingMynaCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingMynaExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingMynaExport[];
    public totalCount: number;
    public chartData: SiteEventSightingMynaExport[];

    public constructor(init?: Partial<SiteEventSightingMynaExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingMynaSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventSightingMynaSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingMynaHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventSightingMynaHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingMynaAlaResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingMynaAla[];
    public totalCount: number;

    public constructor(init?: Partial<SiteEventSightingMynaAlaResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingNewPestsSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventSightingNewPests;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventSightingNewPestsSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingNewPestsCollectionResponse implements ISiteEventCollectionResponse<SiteEventSightingNewPests>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingNewPests[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventSightingNewPests[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventSightingNewPestsCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingNewPestsCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventSightingNewPestsCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingNewPestsExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingNewPestsExport[];
    public totalCount: number;
    public chartData: SiteEventSightingNewPestsExport[];

    public constructor(init?: Partial<SiteEventSightingNewPestsExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingNewPestsSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventSightingNewPestsSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingNewPestsHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventSightingNewPestsHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingOtherPestsSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventSightingOtherPests;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventSightingOtherPestsSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingOtherPestsCollectionResponse implements ISiteEventCollectionResponse<SiteEventSightingOtherPests>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingOtherPests[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventSightingOtherPests[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventSightingOtherPestsCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingOtherPestsCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventSightingOtherPestsCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingOtherPestsExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingOtherPestsExport[];
    public totalCount: number;
    public chartData: SiteEventSightingOtherPestsExport[];

    public constructor(init?: Partial<SiteEventSightingOtherPestsExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingOtherPestsSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventSightingOtherPestsSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingOtherPestsHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventSightingOtherPestsHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingOtherPestsAlaResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingOtherPestsAla[];
    public totalCount: number;

    public constructor(init?: Partial<SiteEventSightingOtherPestsAlaResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingRabbitSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventSightingRabbit;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventSightingRabbitSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingRabbitCollectionResponse implements ISiteEventCollectionResponse<SiteEventSightingRabbit>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingRabbit[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventSightingRabbit[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventSightingRabbitCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingRabbitCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventSightingRabbitCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingRabbitExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingRabbitExport[];
    public totalCount: number;
    public chartData: SiteEventSightingRabbitExport[];

    public constructor(init?: Partial<SiteEventSightingRabbitExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingRabbitSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventSightingRabbitSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingRabbitHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventSightingRabbitHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingRabbitAlaResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingRabbitAla[];
    public totalCount: number;

    public constructor(init?: Partial<SiteEventSightingRabbitAlaResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingStarlingSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventSightingStarling;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventSightingStarlingSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingStarlingCollectionResponse implements ISiteEventCollectionResponse<SiteEventSightingStarling>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingStarling[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventSightingStarling[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventSightingStarlingCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingStarlingCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventSightingStarlingCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingStarlingExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingStarlingExport[];
    public totalCount: number;
    public chartData: SiteEventSightingStarlingExport[];

    public constructor(init?: Partial<SiteEventSightingStarlingExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingStarlingSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventSightingStarlingSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingStarlingHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventSightingStarlingHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingStarlingAlaResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingStarlingAla[];
    public totalCount: number;

    public constructor(init?: Partial<SiteEventSightingStarlingAlaResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingToadSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventSightingToad;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventSightingToadSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingToadCollectionResponse implements ISiteEventCollectionResponse<SiteEventSightingToad>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingToad[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventSightingToad[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventSightingToadCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingToadCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventSightingToadCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingToadExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingToadExport[];
    public totalCount: number;
    public chartData: SiteEventSightingToadExport[];

    public constructor(init?: Partial<SiteEventSightingToadExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingToadSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventSightingToadSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingToadHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventSightingToadHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingToadAlaResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingToadAla[];
    public totalCount: number;

    public constructor(init?: Partial<SiteEventSightingToadAlaResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingWildDogSingleResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvent: SiteEventSightingWildDog;
    public subSpeciesId: string;
    public marker: Marker;

    public constructor(init?: Partial<SiteEventSightingWildDogSingleResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingWildDogCollectionResponse implements ISiteEventCollectionResponse<SiteEventSightingWildDog>
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingWildDog[];
    public totalCount: number;
    public lookups: Lookup[];
    public chartData: SiteEventSightingWildDog[];
    public tableData: string[];
    public groupChartMemberNames: string[];
    public groupChartDataSets: GroupChartDataSet[];
    public groupName: string;
    public activeGroupMembers: number[];
    public groupChartLabels: string[];
    public chartDataByDate: ChartGroupByMonthYear[];

    public constructor(init?: Partial<SiteEventSightingWildDogCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingWildDogCollectionGalleryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public galleryItems: UserGroupGalleryItem[];

    public constructor(init?: Partial<SiteEventSightingWildDogCollectionGalleryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingWildDogExportResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingWildDogExport[];
    public totalCount: number;
    public chartData: SiteEventSightingWildDogExport[];

    public constructor(init?: Partial<SiteEventSightingWildDogExportResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingWildDogSingleDeleteResponse implements ISiteEventSingleDeleteResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public deleted: boolean;

    public constructor(init?: Partial<SiteEventSightingWildDogSingleDeleteResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingWildDogHistoryResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public historyItems: HistoryItem[];

    public constructor(init?: Partial<SiteEventSightingWildDogHistoryResponse>) { (Object as any).assign(this, init); }
}

export class SiteEventSightingWildDogAlaResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public siteEvents: SiteEventSightingWildDogAla[];
    public totalCount: number;

    public constructor(init?: Partial<SiteEventSightingWildDogAlaResponse>) { (Object as any).assign(this, init); }
}

export class MeTypeResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<MeTypeResponse>) { (Object as any).assign(this, init); }
}

/** @description Register a user to the website */
// @Route("/register")
export class UserRegistration implements IReturn<UserRegistrationResponse>, IPost
{
    [immerable] = true;

    public id?: number;
    public fullName: string;
    public email: string;
    public userName: string;
    public postcode: string;
    public mobileNumber: string;
    public emailOptOutKey: string;
    public password: string;
    public state: string;
    public beNotified: boolean;
    public species: string;
    public platformType?: number;

    public constructor(init?: Partial<UserRegistration>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserRegistration'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UserRegistrationResponse(); }
}

/** @description Resets a users password and emails the new password to the user */
// @Route("/forgotpassword", "POST")
// @DataContract
export class ForgotPassword implements IReturn<ForgotPasswordResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public email: string;

    public constructor(init?: Partial<ForgotPassword>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ForgotPassword'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ForgotPasswordResponse(); }
}

// @DataContract
export class GetCommunityGroups implements IReturn<GetCommunityGroupsResponse>
{
    [immerable] = true;


    public constructor(init?: Partial<GetCommunityGroups>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCommunityGroups'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCommunityGroupsResponse(); }
}

// @DataContract
export class ExportCommunityGroupMembers implements IReturn<ExportCommunityGroupMembersResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public communityGroupId?: number;

    // @DataMember(Order=2)
    public statusId?: CommunityGroupMemberStatus;

    public constructor(init?: Partial<ExportCommunityGroupMembers>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExportCommunityGroupMembers'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ExportCommunityGroupMembersResponse(); }
}

/** @description Gets region polygons */
// @Route("/dataaccess/restrictionregionpolygons/{regionIds}", "GET")
// @DataContract
export class DataAccessRegionPolygonJsons implements IReturn<DataAccessRegionPolygonJsonsResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public regionIds: string;

    public constructor(init?: Partial<DataAccessRegionPolygonJsons>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DataAccessRegionPolygonJsons'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new DataAccessRegionPolygonJsonsResponse(); }
}

// @Route("/search/externalrecord", "GET")
export class SearchExternalRecord implements IReturn<SearchExternalRecordResponse>
{
    [immerable] = true;

    public species: Species;
    public latestEventDate?: string;
    public query?: string;
    public filter?: string[];
    public externalSpecies?: string;
    public pageSize: number;
    public page: number;

    public constructor(init?: Partial<SearchExternalRecord>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SearchExternalRecord'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SearchExternalRecordResponse(); }
}

// @Route("/externalrecord/syncschedule/{Species}", "GET")
// @DataContract
export class GetExternalRecordSyncSchedule implements IReturn<GetExternalRecordSyncScheduleResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public species: Species;

    public constructor(init?: Partial<GetExternalRecordSyncSchedule>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetExternalRecordSyncSchedule'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetExternalRecordSyncScheduleResponse(); }
}

// @Route("/externalrecord/syncschedules", "GET")
// @DataContract
export class GetAllExternalRecordSyncSchedules implements IReturn<GetAllExternalRecordSyncSchedulesResponse>
{
    [immerable] = true;


    public constructor(init?: Partial<GetAllExternalRecordSyncSchedules>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAllExternalRecordSyncSchedules'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetAllExternalRecordSyncSchedulesResponse(); }
}

// @Route("/externalrecord/syncschedules/update/{Species}", "POST")
// @DataContract
export class UpdateExternalRecordSyncScheduleLastSyncDate implements IReturn<UpdateExternalRecordSyncScheduleLastSyncDateResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public species: Species;

    // @DataMember(Order=2)
    public lastSyncDate: string;

    public constructor(init?: Partial<UpdateExternalRecordSyncScheduleLastSyncDate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateExternalRecordSyncScheduleLastSyncDate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UpdateExternalRecordSyncScheduleLastSyncDateResponse(); }
}

// @Route("/externalrecord/lastesteventdate/{Species}", "GET")
// @DataContract
export class GetExternalRecordLastestEventDateBySpecies implements IReturn<GetExternalRecordLastestEventDateBySpeciesResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public species: Species;

    public constructor(init?: Partial<GetExternalRecordLastestEventDateBySpecies>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetExternalRecordLastestEventDateBySpecies'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetExternalRecordLastestEventDateBySpeciesResponse(); }
}

// @Route("/externalrecord/bulk/save", "POST")
// @DataContract
export class BulkSaveExternalRecords implements IReturn<BulkSaveExternalRecordsResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public externalRecords: ExternalRecord[];

    public constructor(init?: Partial<BulkSaveExternalRecords>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BulkSaveExternalRecords'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BulkSaveExternalRecordsResponse(); }
}

// @Route("/externalrecord/obsolete/{id}", "POST")
// @DataContract
export class ObsoleteExternalRecord implements IReturn<ObsoleteExternalRecordResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id: number;

    public constructor(init?: Partial<ObsoleteExternalRecord>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ObsoleteExternalRecord'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ObsoleteExternalRecordResponse(); }
}

// @Route("/externalrecord/count", "GET")
// @DataContract
export class ExternalRecordCount implements IReturn<ExternalRecordCountResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public species: Species;

    // @DataMember(Order=2)
    public startDateOnOrAfter?: string;

    // @DataMember(Order=3)
    public startDateOnOrBefore?: string;

    // @DataMember(Order=4)
    public locatedInRegionIds: number[];

    public constructor(init?: Partial<ExternalRecordCount>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExternalRecordCount'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ExternalRecordCountResponse(); }
}

/** @description Get images from server */
// @Route("/images/{**PathInfo}")
export class GetImage
{
    [immerable] = true;

    public pathInfo: string;

    public constructor(init?: Partial<GetImage>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetImage'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}

/** @description Get kmls from server */
// @Route("/kml/{**PathInfo}")
// @DataContract
export class GetKML implements IReturn<Blob>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public pathInfo?: string;

    public constructor(init?: Partial<GetKML>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetKML'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

/** @description Get's a kml file url using region ID */
// @Route("/kml/regionUrl/{RegionId}", "GET")
// @DataContract
export class GetKmlUrlByRegionId implements IReturn<GetKmlUrlByRegionIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public regionId?: number;

    public constructor(init?: Partial<GetKmlUrlByRegionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetKmlUrlByRegionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetKmlUrlByRegionIdResponse(); }
}

/** @description Get's a multi-polygon string using the specified region ID */
// @Route("/kml/polgyon/{RegionId}", "GET")
// @DataContract
export class GetPolygonByRegionId implements IReturn<GetPolygonByRegionIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public regionId?: number;

    public constructor(init?: Partial<GetPolygonByRegionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPolygonByRegionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPolygonByRegionIdResponse(); }
}

/** @description Gets user details */
// @Route("/user", "GET")
// @DataContract
export class GetUser implements IReturn<GetUserResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public species?: Species;

    public constructor(init?: Partial<GetUser>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUser'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetUserResponse(); }
}

/** @description Gets user email notifications config */
// @Route("/user/groups/config", "GET")
// @DataContract
export class GetUserGroupsConfig implements IReturn<GetUserGroupsConfigResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public includeKmlPolygons: boolean;

    public constructor(init?: Partial<GetUserGroupsConfig>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUserGroupsConfig'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetUserGroupsConfigResponse(); }
}

/** @description Updates user details */
// @Route("/user", "POST")
export class UpdateUser extends User implements IReturn<UpdateUserResponse>
{
    [immerable] = true;


    public constructor(init?: Partial<UpdateUser>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateUser'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UpdateUserResponse(); }
}

/** @description Updates the user password */
// @Route("/user/password", "POST")
export class UpdateUserPassword implements IReturn<UpdateUserPasswordResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public password?: string;

    public constructor(init?: Partial<UpdateUserPassword>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateUserPassword'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UpdateUserPasswordResponse(); }
}

/** @description Update user's opt out email status */
// @Route("/user/email/opt-out", "POST")
export class UpdateUserEmailOptOut implements IReturn<UpdateUserEmailOptOutResponse>
{
    [immerable] = true;

    public optOut?: boolean;
    public id?: number;
    public emailNotificationConfigId?: number;

    public constructor(init?: Partial<UpdateUserEmailOptOut>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateUserEmailOptOut'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UpdateUserEmailOptOutResponse(); }
}

/** @description Retire's user from community group */
// @Route("/user/groups/opt-out", "POST")
export class UpdateUserGroupStatus implements IReturn<UpdateUserGroupStatusResponse>
{
    [immerable] = true;

    public id?: number;
    public email?: string;
    public communityGroupId: number;
    public status: CommunityGroupMemberStatus;

    public constructor(init?: Partial<UpdateUserGroupStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateUserGroupStatus'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UpdateUserGroupStatusResponse(); }
}

/** @description Retire's user from community group */
// @Route("/user", "DELETE")
export class UserDelete implements IReturn<UserDeleteResponse>
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<UserDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new UserDeleteResponse(); }
}

/** @description Gets page content */
// @Route("/content/species-content")
// @DataContract
export class GetSpeciesContent implements IReturn<GetSpeciesContentResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public contentName?: string;

    // @DataMember(Order=2)
    public contentCode?: string;

    // @DataMember(Order=3)
    public contentCodeType?: ContentCodeType;

    // @DataMember(Order=4)
    public contentVersion?: number;

    // @DataMember(Order=5)
    public species: Species;

    // @DataMember(Order=6)
    public rightHandContentName?: string;

    public constructor(init?: Partial<GetSpeciesContent>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSpeciesContent'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSpeciesContentResponse(); }
}

/** @description Gets species navbar items */
// @Route("/content/nav-items")
// @DataContract
export class GetSpeciesNavContent implements IReturn<GetSpeciesNavContentResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public species: Species;

    public constructor(init?: Partial<GetSpeciesNavContent>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSpeciesNavContent'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSpeciesNavContentResponse(); }
}

// @Route("/communitygroup/{CommunityGroupId}", "GET")
// @DataContract
export class GetCommunityGroup implements IReturn<GetCommunityGroupResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public communityGroupId: number;

    public constructor(init?: Partial<GetCommunityGroup>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCommunityGroup'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCommunityGroupResponse(); }
}

// @Route("/communitygroup/{CommunityGroupId}/member", "GET")
// @DataContract
export class GetCommunityGroupMembers implements IReturn<GetCommunityGroupMembersResponse>, ISearch
{
    [immerable] = true;

    // @DataMember(Order=1)
    public communityGroupId: number;

    // @DataMember(Order=2)
    public skip?: number;

    // @DataMember(Order=3)
    public take?: number;

    public constructor(init?: Partial<GetCommunityGroupMembers>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCommunityGroupMembers'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCommunityGroupMembersResponse(); }
}

// @Route("/communitygroup/communitygroupsmembers", "GET")
// @DataContract
export class GetCommunityGroupsMembers implements IReturn<GetCommunityGroupsMembersResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public communityGroupIds?: number[];

    public constructor(init?: Partial<GetCommunityGroupsMembers>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCommunityGroupsMembers'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCommunityGroupsMembersResponse(); }
}

// @Route("/communitygroup/communitygroupmembers/downloadrights", "POST")
// @DataContract
export class PostCommunityGroupMemberDownloadRights implements IReturn<PostCommunityGroupMemberDownloadRightsResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public communityGroupId: number;

    // @DataMember(Order=2)
    public downloadRights: boolean;

    // @DataMember(Order=3)
    public userId: number;

    public constructor(init?: Partial<PostCommunityGroupMemberDownloadRights>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostCommunityGroupMemberDownloadRights'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostCommunityGroupMemberDownloadRightsResponse(); }
}

// @Route("/communitygroup/communitygroupmembers/viewrights", "POST")
// @DataContract
export class PostCommunityGroupMemberViewRights implements IReturn<PostCommunityGroupMemberViewRightsResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public communityGroupId: number;

    // @DataMember(Order=2)
    public viewRights: boolean;

    // @DataMember(Order=3)
    public userId: number;

    public constructor(init?: Partial<PostCommunityGroupMemberViewRights>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostCommunityGroupMemberViewRights'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostCommunityGroupMemberViewRightsResponse(); }
}

// @Route("/communitygroup/communitygroupmembers/removemember", "POST")
// @DataContract
export class PostRemoveCommunityGroupMember implements IReturn<PostRemoveCommunityGroupMemberResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public communityGroupId: number;

    // @DataMember(Order=3)
    public userId: number;

    public constructor(init?: Partial<PostRemoveCommunityGroupMember>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostRemoveCommunityGroupMember'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostRemoveCommunityGroupMemberResponse(); }
}

// @Route("/communitygroup/communitygroupmembers/all", "GET")
// @DataContract
export class GetAllCommunityGroupMembers implements IReturn<GetAllCommunityGroupMembersResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public communityGroupId: number;

    public constructor(init?: Partial<GetAllCommunityGroupMembers>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAllCommunityGroupMembers'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetAllCommunityGroupMembersResponse(); }
}

// @Route("/communitygroup/documents", "GET")
// @DataContract
export class GetCommunityGroupDocuments implements IReturn<GetCommunityGroupDocumentsResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public communityGroupId: number;

    public constructor(init?: Partial<GetCommunityGroupDocuments>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCommunityGroupDocuments'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCommunityGroupDocumentsResponse(); }
}

// @Route("/communitygroup/documents/remove", "POST")
// @DataContract
export class PostRemoveCommunityGroupDocument implements IReturn<PostRemoveCommunityGroupDocumentResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id: number;

    // @DataMember(Order=2)
    public communityGroupId: number;

    public constructor(init?: Partial<PostRemoveCommunityGroupDocument>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostRemoveCommunityGroupDocument'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostRemoveCommunityGroupDocumentResponse(); }
}

// @Route("/communitygroup/documents/upload", "POST")
// @DataContract
export class PostUploadCommunityGroupDocument implements IReturn<PostUploadCommunityGroupDocumentResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public communityGroupId: number;

    // @DataMember(Order=2)
    public fileContent: string;

    // @DataMember(Order=3)
    public name: string;

    // @DataMember(Order=4)
    public fileName: string;

    public constructor(init?: Partial<PostUploadCommunityGroupDocument>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostUploadCommunityGroupDocument'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostUploadCommunityGroupDocumentResponse(); }
}

// @Route("/communitygroup/documents/download")
// @DataContract
export class GetCommunityGroupDocument implements IReturn<Blob>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public communityGroupId: number;

    // @DataMember(Order=2)
    public fileName: string;

    public constructor(init?: Partial<GetCommunityGroupDocument>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCommunityGroupDocument'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/communitygroup/invitepeople", "POST")
// @DataContract
export class PostCommunityGroupInvitePeople implements IReturn<PostCommunityGroupInvitePeopleResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public communityGroupId: number;

    // @DataMember(Order=2)
    public emailTo: string[];

    // @DataMember(Order=3)
    public subject: string;

    // @DataMember(Order=4)
    public personalisedMessage?: string;

    // @DataMember(Order=5)
    public autoAccept?: boolean;

    // @DataMember(Order=6)
    public species: Species;

    public constructor(init?: Partial<PostCommunityGroupInvitePeople>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostCommunityGroupInvitePeople'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostCommunityGroupInvitePeopleResponse(); }
}

/** @description Register a community group to the website */
// @Route("/communitygroup/register")
export class PostCommunityGroupRegistration implements IReturn<PostCommunityGroupRegistrationResponse>, IPost
{
    [immerable] = true;

    public id?: number;
    public groupName: string;
    public adminUsername: string;
    public email: string;
    public password: string;
    public autoLogin: boolean;
    public species: Species;

    public constructor(init?: Partial<PostCommunityGroupRegistration>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostCommunityGroupRegistration'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostCommunityGroupRegistrationResponse(); }
}

// @Route("/species-forms")
// @DataContract
export class GetSpeciesForms implements IReturn<GetSpeciesFormsResponse>, IGet
{
    [immerable] = true;

    // @DataMember(Order=1)
    public speciesType?: Species;

    // @DataMember(Order=2)
    public siteEventType?: SiteEventType;

    public constructor(init?: Partial<GetSpeciesForms>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSpeciesForms'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSpeciesFormsResponse(); }
}

// @Route("/species-forms/file/upload", "POST")
// @DataContract
export class PostUploadSpeciesFormFile implements IReturn<PostUploadSpeciesFormFileResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public siteEventId: number;

    // @DataMember(Order=2)
    public speciesSiteEventType: SpeciesSiteEventType;

    // @DataMember(Order=3)
    public author: string;

    // @DataMember(Order=4)
    public userId: number;

    // @DataMember(Order=5)
    public galleryId: number;

    // @DataMember(Order=6)
    public email: string;

    // @DataMember(Order=7)
    public caption?: string;

    // @DataMember(Order=8)
    public content: string;

    // @DataMember(Order=9)
    public fileExtension: string;

    public constructor(init?: Partial<PostUploadSpeciesFormFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostUploadSpeciesFormFile'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostUploadSpeciesFormFileResponse(); }
}

// @Route("/species-forms/temporary-file/upload", "POST")
// @DataContract
export class PostUploadTemporaryImage implements IReturn<PostUploadTemporaryImageResponse>
{
    [immerable] = true;


    public constructor(init?: Partial<PostUploadTemporaryImage>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostUploadTemporaryImage'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostUploadTemporaryImageResponse(); }
}

// @Route("/species-forms/temporary-file/delete", "DELETE")
// @DataContract
export class PostDeleteTemporaryImage implements IReturn<PostDeleteTemporaryImageResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public guid: string;

    // @DataMember(Order=2)
    public fileExtension: string;

    public constructor(init?: Partial<PostDeleteTemporaryImage>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostDeleteTemporaryImage'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new PostDeleteTemporaryImageResponse(); }
}

/** @description Gets the terms of use content */
// @Route("/content/termsofuse-content")
// @DataContract
export class GetTermsOfUseContent implements IReturn<GetTermsOfUseContentResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public contentName?: string;

    // @DataMember(Order=2)
    public species?: Species;

    public constructor(init?: Partial<GetTermsOfUseContent>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTermsOfUseContent'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTermsOfUseContentResponse(); }
}

export class GetStaticTypes implements IReturn<GetStaticTypesResponse>
{
    [immerable] = true;


    public constructor(init?: Partial<GetStaticTypes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetStaticTypes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetStaticTypesResponse(); }
}

// @Route("/emailtemplate")
// @DataContract
export class GetEmailTemplate implements IReturn<GetEmailTemplateResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public name: string;

    public constructor(init?: Partial<GetEmailTemplate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetEmailTemplate'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetEmailTemplateResponse(); }
}

// @Route("/emails/send-welcome-email", "POST")
// @DataContract
export class SendWelcomeEmail implements IReturn<SendWelcomeEmailResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public userId: number;

    // @DataMember(Order=2)
    public species: Species;

    public constructor(init?: Partial<SendWelcomeEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendWelcomeEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendWelcomeEmailResponse(); }
}

// @Route("/emails/check-email-notifications", "POST")
// @DataContract
export class CheckForEmailNotification implements IReturn<CheckForEmailNotificationResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public siteEventId: number;

    // @DataMember(Order=2)
    public speciesSiteEventType: SpeciesSiteEventType;

    public constructor(init?: Partial<CheckForEmailNotification>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CheckForEmailNotification'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CheckForEmailNotificationResponse(); }
}

// @Route("/emails/send-sign-up-email", "POST")
// @DataContract
export class SendSignUpEmail implements IReturn<SendSignUpEmailResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public email: string;

    public constructor(init?: Partial<SendSignUpEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendSignUpEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendSignUpEmailResponse(); }
}

// @Route("/emails/send-custom-alert", "POST")
// @DataContract
export class SendCustomAlert implements IReturn<SendCustomAlertResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public title: string;

    // @DataMember(Order=2)
    public message: string;

    // @DataMember(Order=3)
    public link: string;

    // @DataMember(Order=4)
    public communityGroupIds: number[];

    // @DataMember(Order=5)
    public allUsers: boolean;

    public constructor(init?: Partial<SendCustomAlert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendCustomAlert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendCustomAlertResponse(); }
}

// @Route("/emails/send-data-access-request", "POST")
// @DataContract
export class SendDataAccessRequestEmail implements IReturn<SendDataAccessRequestEmailResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public species: Species;

    // @DataMember(Order=2)
    public fullName: string;

    // @DataMember(Order=3)
    public emailAddress: string;

    // @DataMember(Order=4)
    public organisationName: string;

    // @DataMember(Order=5)
    public details: string;

    public constructor(init?: Partial<SendDataAccessRequestEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendDataAccessRequestEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendDataAccessRequestEmailResponse(); }
}

// @Route("/emails/send-forgot-password", "POST")
// @DataContract
export class SendForgotPassword implements IReturn<SendForgotPasswordResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public subject: string;

    // @DataMember(Order=2)
    public plainTextBody: string;

    // @DataMember(Order=3)
    public htmlBody: string;

    // @DataMember(Order=4)
    public toAddress: string;

    public constructor(init?: Partial<SendForgotPassword>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendForgotPassword'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendForgotPasswordResponse(); }
}

// @Route("/emails/send-feedback-email", "POST")
// @DataContract
export class SendFeedback implements IReturn<SendFeedbackResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public rating?: string;

    // @DataMember(Order=2)
    public easilyUnderstood?: string;

    // @DataMember(Order=3)
    public relevantQuestions?: string;

    // @DataMember(Order=4)
    public difficulties?: string;

    // @DataMember(Order=5)
    public modifications?: string;

    // @DataMember(Order=6)
    public preparedToRevceiveEmails?: string;

    // @DataMember(Order=7)
    public suggestions?: string;

    // @DataMember(Order=8)
    public email?: string;

    // @DataMember(Order=9)
    public species: Species;

    public constructor(init?: Partial<SendFeedback>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendFeedback'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendFeedbackResponse(); }
}

// @Route("/siteevent/assign-anonymous-site-events-to-user-account", "POST")
// @DataContract
export class AssignAnonymousSiteEventsToUserAccount implements IReturn<AssignAnonymousSiteEventsToUserAccountResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public userId: number;

    public constructor(init?: Partial<AssignAnonymousSiteEventsToUserAccount>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssignAnonymousSiteEventsToUserAccount'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssignAnonymousSiteEventsToUserAccountResponse(); }
}

// @Route("/coordinatesState/{Longitude}/{Latitude}", "GET")
export class CoordinatesState implements IReturn<CoordinatesStateResponse>
{
    [immerable] = true;

    public longitude: string;
    public latitude: string;

    public constructor(init?: Partial<CoordinatesState>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CoordinatesState'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CoordinatesStateResponse(); }
}

// @Route("/regions/all", "GET")
// @DataContract
export class GetAllRegions implements IReturn<GetAllRegionsResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public excludeStates: boolean;

    public constructor(init?: Partial<GetAllRegions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAllRegions'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetAllRegionsResponse(); }
}

// @Route("/species/subspecies/{speciesid}", "GET")
export class GetSubSpecies implements IReturn<GetSubSpeciesResponse>
{
    [immerable] = true;

    public speciesId?: number;

    public constructor(init?: Partial<GetSubSpecies>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSubSpecies'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSubSpeciesResponse(); }
}

// @Route("/species/{id}", "GET")
export class GetSpeciesById implements IReturn<GetSpeciesByIdResponse>
{
    [immerable] = true;

    public id: number;

    public constructor(init?: Partial<GetSpeciesById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSpeciesById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSpeciesByIdResponse(); }
}

export class NewGetSiteEventById implements IReturn<NewGetSiteEventResponse>
{
    [immerable] = true;

    public species?: Species;
    public siteEventType?: SiteEventType;
    public id?: number;

    public constructor(init?: Partial<NewGetSiteEventById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'NewGetSiteEventById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new NewGetSiteEventResponse(); }
}

export class NewGetSiteEventCollection implements IReturn<NewGetSiteEventCollectionResponse>, ISiteEventGetCollection
{
    [immerable] = true;

    public species?: Species;
    public siteEventType?: SiteEventType;
    public id?: number;
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;
    public skip?: number;
    public take?: number;
    public accessToken: string;

    public constructor(init?: Partial<NewGetSiteEventCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'NewGetSiteEventCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new NewGetSiteEventCollectionResponse(); }
}

export class NewGetSiteEventGalleryCollection implements IReturn<NewGetSiteEventGalleryCollectionResponse>, ISiteEventGetCollectionGallery
{
    [immerable] = true;

    public species?: Species;
    public siteEventType?: SiteEventType;
    public id?: number;
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public subSpeciesId?: number;
    public dataAccessId?: number;
    public skip?: number;
    public take?: number;
    public accessToken: string;

    public constructor(init?: Partial<NewGetSiteEventGalleryCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'NewGetSiteEventGalleryCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new NewGetSiteEventGalleryCollectionResponse(); }
}

export class NewGetSiteEventHistory implements IReturn<NewGetSiteEventHistoryResponse>, ISiteEventGetHistory
{
    [immerable] = true;

    public species?: Species;
    public siteEventType?: SiteEventType;
    public id?: number;
    public accessToken: string;

    public constructor(init?: Partial<NewGetSiteEventHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'NewGetSiteEventHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new NewGetSiteEventHistoryResponse(); }
}

export class NewPostInsertSiteEvent implements IReturn<NewPostInsertSiteEventResponse>, ISiteEventPostInsert
{
    [immerable] = true;

    public species?: Species;
    public siteEventType?: SiteEventType;
    public formData?: { [index: string]: Object; };

    public constructor(init?: Partial<NewPostInsertSiteEvent>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'NewPostInsertSiteEvent'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new NewPostInsertSiteEventResponse(); }
}

/** @description Gets all user notifications */
// @Route("/notifications", "GET")
// @Route("/api/notifications", "GET")
// @DataContract
export class NotificationsRequest implements IReturn<NotificationsResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public userId: number;

    public constructor(init?: Partial<NotificationsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'NotificationsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new NotificationsResponse(); }
}

/** @description Gets all flutter user notifications */
// @Route("/notifications/flutter", "GET")
// @Route("/api/notifications/flutter", "GET")
// @DataContract
export class FlutterNotificationsRequest implements IReturn<FlutterNotificationsResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public userId: number;

    public constructor(init?: Partial<FlutterNotificationsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FlutterNotificationsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FlutterNotificationsResponse(); }
}

/** @description Gets user notifications */
// @Route("/notifications/website", "GET")
// @Route("/api/notifications/website", "GET")
// @DataContract
export class WebsiteNotificationsRequest implements IReturn<WebsiteNotificationsResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public userId: number;

    // @DataMember(Order=2)
    public pageSize: number;

    // @DataMember(Order=3)
    public pageNumber: number;

    // @DataMember(Order=4)
    public species?: Species;

    public constructor(init?: Partial<WebsiteNotificationsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WebsiteNotificationsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new WebsiteNotificationsResponse(); }
}

/** @description Get the total count of unread notifications for the provided user */
// @Route("/notifications/totalcount/{UserId}", "GET")
// @Route("/api/notifications/totalcount/{UserId}", "GET")
export class GetUnreadNotificationCount implements IReturn<GetUnreadNotificationCountResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public userId: number;

    public constructor(init?: Partial<GetUnreadNotificationCount>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUnreadNotificationCount'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetUnreadNotificationCountResponse(); }
}

/** @description Set if the notification is read */
// @Route("/notifications/view/{NotificationId}", "POST")
// @Route("/api/notifications/view/{NotificationId}", "POST")
// @DataContract
export class NotificationViewed implements IReturn<NotificationViewedResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public notificationId: number;

    // @DataMember(Order=2)
    public value: boolean;

    public constructor(init?: Partial<NotificationViewed>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'NotificationViewed'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new NotificationViewedResponse(); }
}

/** @description Deletes the notification */
// @Route("/notifications/{Id}", "DELETE")
// @Route("/api/notifications/{Id}", "DELETE")
export class DeleteNotificationRequest implements IReturn<DeleteNotificationResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id: number;

    public constructor(init?: Partial<DeleteNotificationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteNotificationRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new DeleteNotificationResponse(); }
}

/** @description Get the notifications site event details */
// @Route("/record/{Id}/{NotificationId}", "GET")
// @Route("/api/record/{Id}/{NotificationId}", "GET")
// @DataContract
export class RecordRequest implements IReturn<RecordResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id: string;

    // @DataMember(Order=2)
    public notificationId: string;

    public constructor(init?: Partial<RecordRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RecordRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RecordResponse(); }
}

/** @description Get the website notifications site event details */
// @Route("/record/{UserNotificationId}", "GET")
// @Route("/api/record/{UserNotificationId}", "GET")
// @DataContract
export class WebsiteNotificationRecordRequest implements IReturn<WebsiteNotificationRecordResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public userNotificationId: number;

    public constructor(init?: Partial<WebsiteNotificationRecordRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WebsiteNotificationRecordRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new WebsiteNotificationRecordResponse(); }
}

/** @description Checks if the given record has any notifications to be sent */
// @Route("/notification/{sightingTypeId}/{recordId}", "POST")
// @Route("/api/notification/{sightingTypeId}/{recordId}", "POST")
// @DataContract
export class CheckNotifications implements IReturn<CheckNotificationsResponse>, IGet
{
    [immerable] = true;

    // @DataMember(Order=1)
    public sightingTypeId: SpeciesSiteEventType;

    // @DataMember(Order=2)
    public recordId: number;

    public constructor(init?: Partial<CheckNotifications>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CheckNotifications'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CheckNotificationsResponse(); }
}

/** @description  */
// @Route("/emailnotification/config")
// @Route("/api/emailnotification/config")
// @DataContract
export class GetEmailNotificationConfig implements IReturn<EmailNotificationConfig[]>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public speciesId: Species;

    // @DataMember(Order=2)
    public communityGroupId?: number;

    public constructor(init?: Partial<GetEmailNotificationConfig>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetEmailNotificationConfig'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<EmailNotificationConfig>(); }
}

/** @description  */
// @Route("/emailnotification/log/query")
// @Route("/api/emailnotification/log/query")
export class QueryEmailNotificationLog extends QueryDb<EmailNotificationLogDetailsDo> implements IReturn<QueryResponse<EmailNotificationLogDetailsDo>>
{
    [immerable] = true;


    public constructor(init?: Partial<QueryEmailNotificationLog>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryEmailNotificationLog'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryResponse<EmailNotificationLogDetailsDo>(); }
}

/** @description  */
// @Route("/notifications/token", "POST")
// @Route("/api/notifications/token", "POST")
// @DataContract
export class PostFirebaseToken implements IReturn<PostFirebaseTokenResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public userId: number;

    // @DataMember(Order=2)
    public deviceId: string;

    // @DataMember(Order=3)
    public token: string;

    public constructor(init?: Partial<PostFirebaseToken>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostFirebaseToken'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostFirebaseTokenResponse(); }
}

/** @description  */
// @Route("/notifications/token", "DELETE")
// @Route("/api/notifications/token", "DELETE")
// @DataContract
export class DeleteFirebaseToken implements IReturn<DeleteFirebaseTokenResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public deviceId: string;

    public constructor(init?: Partial<DeleteFirebaseToken>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteFirebaseToken'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new DeleteFirebaseTokenResponse(); }
}

export class GetClientAppSettings implements IReturn<ClientAppSettingsResponse>
{
    [immerable] = true;


    public constructor(init?: Partial<GetClientAppSettings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetClientAppSettings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ClientAppSettingsResponse(); }
}

// @Route("/siteevent/metadata")
export class GetSiteEventMetadata implements IReturn<GetSiteEventMetadataResponse>
{
    [immerable] = true;


    public constructor(init?: Partial<GetSiteEventMetadata>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSiteEventMetadata'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSiteEventMetadataResponse(); }
}

// @Route("/{Species}/{SiteEventType}/siteevent/{Id}/content")
export class GetSiteEventGetMarkerContent implements IReturn<GetSiteEventGetMarkerContentResponse>, IAccessToken
{
    [immerable] = true;

    public accessToken: string;
    public viewMode: string;
    public id: number;
    public species: Species;
    public siteEventType: SiteEventType;
    public toadAdminAssessment: boolean;

    public constructor(init?: Partial<GetSiteEventGetMarkerContent>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSiteEventGetMarkerContent'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSiteEventGetMarkerContentResponse(); }
}

// @Route("/{Species}/custom/customsiteevent")
export class GetCustomSiteEventChartData implements IReturn<GetCustomSiteEventChartDataResponse>
{
    [immerable] = true;

    public species: Species;
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public getChartAndTableData?: boolean;
    public onlyPublicData?: boolean;
    public accessToken: string;
    public id?: number;
    public locatedInRegionIds: number[];
    public skip?: number;
    public userId?: number;
    public memberOfCommunityGroupIds: number[];
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<GetCustomSiteEventChartData>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCustomSiteEventChartData'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCustomSiteEventChartDataResponse(); }
}

// @Route("/{Species}/siteevent/heatmap")
export class SiteEventGetHeatmapCollection implements IReturn<SiteEventGetHeatmapCollectionResponse>
{
    [immerable] = true;

    public species: Species;
    public subSpecies?: number;

    public constructor(init?: Partial<SiteEventGetHeatmapCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventGetHeatmapCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventGetHeatmapCollectionResponse(); }
}

// @Route("/{Species}/siteevent")
export class SiteEventGetCollection implements IReturn<SiteEventGetCollectionResponse>, ISiteEventGetCollection
{
    [immerable] = true;

    public accessToken: string;
    public species: Species;
    public siteEventTypes: SiteEventType[];
    public includeContent: boolean;
    public skip?: number;
    public take?: number;
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public id?: number;
    public userIdNotEqualTo?: number;
    public userId?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;
    public toadAdminAssessment: boolean;
    public getChartAndTableData?: boolean;

    public constructor(init?: Partial<SiteEventGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventGetCollectionResponse(); }
}

// @Route("/{Species}/siteevents/mapmarkers")
export class PostSiteEventMarkerCollection implements IReturn<PostSiteEventMarkerCollectionResponse>
{
    [immerable] = true;

    public species: Species;
    public siteEventTypes: SiteEventType[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public bySubmitter?: BySubmitter;
    public groupId?: number;
    public groupMemberId?: number;
    public dataAccessId?: number;
    public locatedInRegionIds?: number[];
    public subSpeciesId?: number;
    public showExternallySourcedData?: boolean;

    public constructor(init?: Partial<PostSiteEventMarkerCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostSiteEventMarkerCollection'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostSiteEventMarkerCollectionResponse(); }
}

// @Route("/{Species}/siteevents/mapmarkers/content/{Id}")
export class PostSiteEventMarkerContent implements IReturn<PostSiteEventMarkerContentResponse>
{
    [immerable] = true;

    public species: Species;
    public siteEventType: SiteEventType;
    public id: number;
    public accessToken?: string;

    public constructor(init?: Partial<PostSiteEventMarkerContent>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostSiteEventMarkerContent'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostSiteEventMarkerContentResponse(); }
}

// @Route("/{Species}/siteevents/excluderanges")
export class PostSiteEventMarkerExcludeRangesCollection implements IReturn<PostSiteEventMarkerExcludeRangesCollectionResponse>
{
    [immerable] = true;

    public species: Species;
    public siteEventTypes: SiteEventType[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public sightingRanges?: MinMaxRange[];
    public damageRanges?: MinMaxRange[];
    public controlRanges?: MinMaxRange[];
    public diseaseRanges?: MinMaxRange[];
    public managementRanges?: MinMaxRange[];
    public sightingModifiedOnOrAfter?: string;
    public damageModifiedOnOrAfter?: string;
    public controlModifiedOnOrAfter?: string;
    public diseaseModifiedOnOrAfter?: string;
    public managementModifiedOnOrAfter?: string;
    public subSpeciesId?: number;
    public dataAccessId?: number;
    public locatedInRegionIds?: number[];

    public constructor(init?: Partial<PostSiteEventMarkerExcludeRangesCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostSiteEventMarkerExcludeRangesCollection'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostSiteEventMarkerExcludeRangesCollectionResponse(); }
}

// @Route("/{Species}/siteevents/includeranges")
export class PostSiteEventMarkerIncludeRangesCollection implements IReturn<PostSiteEventMarkerIncludeRangesCollectionResponse>
{
    [immerable] = true;

    public species: Species;
    public sightingRanges?: MinMaxRange[];
    public damageRanges?: MinMaxRange[];
    public controlRanges?: MinMaxRange[];
    public diseaseRanges?: MinMaxRange[];
    public managementRanges?: MinMaxRange[];
    public userIds: number[];

    public constructor(init?: Partial<PostSiteEventMarkerIncludeRangesCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostSiteEventMarkerIncludeRangesCollection'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostSiteEventMarkerIncludeRangesCollectionResponse(); }
}

/** @description Gets the map legend for the specified species */
// @Route("/{Species}/legend", "GET")
// @DataContract
export class GetMapLegend implements IReturn<GetMapLegendResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public species?: Species;

    // @DataMember(Order=2)
    public rhdvMap?: boolean;

    // @DataMember(Order=3)
    public subSpeciesId?: number;

    // @DataMember(Order=4)
    public toadAdminAssessmentMode?: boolean;

    public constructor(init?: Partial<GetMapLegend>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMapLegend'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMapLegendResponse(); }
}

// @Route("/map-marker/update")
export class UpdateMapMarkersAll implements IReturn<UpdateMapMarkersResponse>
{
    [immerable] = true;

    public onlyMissing?: boolean;

    public constructor(init?: Partial<UpdateMapMarkersAll>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateMapMarkersAll'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UpdateMapMarkersResponse(); }
}

// @Route("/map-marker/update/{Species}")
export class UpdateMapMarkersSpecies implements IReturn<UpdateMapMarkersResponse>
{
    [immerable] = true;

    public species?: Species;
    public onlyMissing?: boolean;

    public constructor(init?: Partial<UpdateMapMarkersSpecies>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateMapMarkersSpecies'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UpdateMapMarkersResponse(); }
}

// @Route("/map-marker/update/{Species}/{Event}")
export class UpdateMapMarkersSpeciesEvent implements IReturn<UpdateMapMarkersResponse>
{
    [immerable] = true;

    public species?: Species;
    public event?: SiteEventType;
    public onlyMissing?: boolean;

    public constructor(init?: Partial<UpdateMapMarkersSpeciesEvent>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateMapMarkersSpeciesEvent'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UpdateMapMarkersResponse(); }
}

// @Route("/map-marker/update/{Species}/{Event}/{Id}")
export class UpdateMapMarkerById implements IReturn<UpdateMapMarkersResponse>
{
    [immerable] = true;

    public species?: Species;
    public event?: SiteEventType;
    public id?: number;
    public onlyMissing?: boolean;

    public constructor(init?: Partial<UpdateMapMarkerById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateMapMarkerById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UpdateMapMarkersResponse(); }
}

// @Route("/map-markers")
export class ViewMapMarkers
{
    [immerable] = true;

    public species?: Species;
    public event?: SiteEventType;
    public id?: number;
    public page?: number;
    public pageSize?: number;

    public constructor(init?: Partial<ViewMapMarkers>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ViewMapMarkers'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}

// @Route("/gallery/{galleryId}")
export class GetGallery implements IReturn<GetGalleryResponse>
{
    [immerable] = true;

    public galleryId: number;

    public constructor(init?: Partial<GetGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetGalleryResponse(); }
}

// @Route("/photo/{photoId}/meta")
// @Route("/gallery/{galleryId}/photo/{photoId}/meta")
export class GetGalleryPhotoMetaInfo implements IReturn<GetGalleryPhotoMetaInfoResponse>
{
    [immerable] = true;

    /** @description Single use email access token. Ignore this field if you are authenticating normally (API Key or username/password credentials). */
    public accessToken: string;
    public galleryId?: number;
    public photoId: number;

    public constructor(init?: Partial<GetGalleryPhotoMetaInfo>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetGalleryPhotoMetaInfo'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetGalleryPhotoMetaInfoResponse(); }
}

// @Route("/photo/unapproved")
export class GetGalleryPhotoUnapproved implements IReturn<Blob>
{
    [immerable] = true;

    public thumbnail: boolean;

    public constructor(init?: Partial<GetGalleryPhotoUnapproved>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetGalleryPhotoUnapproved'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/photo/{photoId}")
// @Route("/photo/{photoId}/thumbnail")
// @Route("/gallery/{galleryId}/photo/{photoId}")
// @Route("/gallery/{galleryId}/photo/{photoId}/thumbnail")
export class GetGalleryPhoto implements IReturn<Blob>
{
    [immerable] = true;

    /** @description Single use email access token. Ignore this field if you are authenticating normally (API Key or username/password credentials). */
    public accessToken: string;
    public galleryId?: number;
    public photoId: number;

    public constructor(init?: Partial<GetGalleryPhoto>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetGalleryPhoto'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/siteevent/update-missing-lga-and-lls", "POST")
// @DataContract
export class UpdateMissingLGAAndLLS implements IReturn<UpdateMissingLGAAndLLSResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public lookbackDays: number;

    // @DataMember(Order=2)
    public species?: Species;

    public constructor(init?: Partial<UpdateMissingLGAAndLLS>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateMissingLGAAndLLS'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UpdateMissingLGAAndLLSResponse(); }
}

// @Route("/siteevent/update-missing-states", "POST")
// @DataContract
export class UpdateMissingStates implements IReturn<UpdateMissingStatesResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public lookbackDays: number;

    // @DataMember(Order=2)
    public species?: Species;

    public constructor(init?: Partial<UpdateMissingStates>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateMissingStates'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UpdateMissingStatesResponse(); }
}

// @Route("/siteevent/delete", "POST")
// @DataContract
export class DeleteSiteEvent implements IReturn<DeleteSiteEventResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public species: Species;

    // @DataMember(Order=2)
    public siteEventType: SiteEventType;

    // @DataMember(Order=3)
    public siteEventId: number;

    public constructor(init?: Partial<DeleteSiteEvent>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteSiteEvent'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DeleteSiteEventResponse(); }
}

// @Route("/siteevent/update-missing-geopoints", "POST")
// @DataContract
export class UpdateMissingGeoPoints implements IReturn<UpdateMissingGeoPointsResponse>
{
    [immerable] = true;


    public constructor(init?: Partial<UpdateMissingGeoPoints>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateMissingGeoPoints'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UpdateMissingGeoPointsResponse(); }
}

// @Route("/species", "GET")
export class GetSpecies implements IReturn<GetSpeciesResponse>
{
    [immerable] = true;


    public constructor(init?: Partial<GetSpecies>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSpecies'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSpeciesResponse(); }
}

// @Route("/species/siteeventtypes", "GET")
export class GetSiteEventTypes implements IReturn<GetSiteEventTypesResponse>
{
    [immerable] = true;

    public species: Species;

    public constructor(init?: Partial<GetSiteEventTypes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSiteEventTypes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSiteEventTypesResponse(); }
}

// @Route("/users")
// @DataContract
export class GetUsers implements IReturn<GetUsersResponse>
{
    [immerable] = true;


    public constructor(init?: Partial<GetUsers>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUsers'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetUsersResponse(); }
}

// @DataContract
export class GetWebsiteContent implements IReturn<GetWebsiteContentResponse>, IGet
{
    [immerable] = true;


    public constructor(init?: Partial<GetWebsiteContent>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetWebsiteContent'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetWebsiteContentResponse(); }
}

/** @description Sign In */
// @Route("/auth", "GET,POST")
// @Route("/auth/{provider}", "GET,POST")
// @Api(Description="Sign In")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost
{
    [immerable] = true;

    /** @description AuthProvider, e.g. credentials */
    // @DataMember(Order=1)
    public provider: string;

    // @DataMember(Order=2)
    public userName: string;

    // @DataMember(Order=3)
    public password: string;

    // @DataMember(Order=4)
    public rememberMe?: boolean;

    // @DataMember(Order=5)
    public accessToken: string;

    // @DataMember(Order=6)
    public accessTokenSecret: string;

    // @DataMember(Order=7)
    public returnUrl: string;

    // @DataMember(Order=8)
    public errorView: string;

    // @DataMember(Order=9)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<Authenticate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Authenticate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AuthenticateResponse(); }
}

/** @description  */
// @Route("/emailnotification/config/query")
// @Route("/api/emailnotification/config/query")
// @DataContract
export class QueryEmailNotificationConfig extends QueryData<EmailNotificationConfig> implements IReturn<QueryResponse<EmailNotificationConfig>>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public speciesId: Species;

    // @DataMember(Order=2)
    public communityGroupId?: number;

    public constructor(init?: Partial<QueryEmailNotificationConfig>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryEmailNotificationConfig'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryResponse<EmailNotificationConfig>(); }
}

// @Route("/apikeys")
// @Route("/apikeys/{Environment}")
// @DataContract
export class GetApiKeys implements IReturn<GetApiKeysResponse>, IGet
{
    [immerable] = true;

    // @DataMember(Order=1)
    public environment: string;

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<GetApiKeys>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetApiKeys'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetApiKeysResponse(); }
}

// @Route("/apikeys/regenerate")
// @Route("/apikeys/regenerate/{Environment}")
// @DataContract
export class RegenerateApiKeys implements IReturn<RegenerateApiKeysResponse>, IPost
{
    [immerable] = true;

    // @DataMember(Order=1)
    public environment: string;

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<RegenerateApiKeys>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegenerateApiKeys'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegenerateApiKeysResponse(); }
}

// @Route("/access-token")
// @DataContract
export class GetAccessToken implements IReturn<GetAccessTokenResponse>, IPost
{
    [immerable] = true;

    // @DataMember(Order=1)
    public refreshToken: string;

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<GetAccessToken>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAccessToken'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetAccessTokenResponse(); }
}

// @Route("/camel/control/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlCamel) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlCamel) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlCamelGetSingleById implements IReturn<SiteEventControlCamelSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventControlCamelGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlCamelGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlCamelSingleResponse(); }
}

// @Route("/camel/control/siteevent", "GET")
// @Route("/api/camel/control/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlCamelGetCollection implements IReturn<SiteEventControlCamelCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlCamelGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlCamelGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlCamelCollectionResponse(); }
}

// @Route("/camel/control/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventControlCamelGetCollectionGallery implements IReturn<SiteEventControlCamelCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlCamelGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlCamelGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlCamelCollectionGalleryResponse(); }
}

// @Route("/camel/control/siteevent/export", "GET")
// @Route("/api/camel/control/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlCamelGetCollectionExport implements IReturn<SiteEventControlCamelExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlCamelGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlCamelGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlCamelExportResponse(); }
}

// @Route("/camel/control/siteevent/export/csv", "GET")
// @Route("/api/camel/control/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlCamelGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlCamelGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlCamelGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/camel/control/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlCamel) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlCamel) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventControlCamelPostInsert implements IReturn<SiteEventControlCamelSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventControlCamel;

    public constructor(init?: Partial<SiteEventControlCamelPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlCamelPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventControlCamelSingleResponse(); }
}

// @Route("/camel/control/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventControlCamel)")
// @ApiResponse(Description="SiteEvent (SiteEventControlCamel) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlCamel) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlCamel) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlCamel) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventControlCamelPutUpdateById implements IReturn<SiteEventControlCamelSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventControlCamel;

    public constructor(init?: Partial<SiteEventControlCamelPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlCamelPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventControlCamelSingleResponse(); }
}

// @Route("/camel/control/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlCamel) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlCamel) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlCamelDeleteSingleById implements IReturn<SiteEventControlCamelSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventControlCamelDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlCamelDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventControlCamelSingleDeleteResponse(); }
}

// @Route("/camel/control/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlCamel) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlCamel) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlCamelGetHistory implements IReturn<SiteEventControlCamelHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventControlCamelGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlCamelGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlCamelHistoryResponse(); }
}

// @Route("/deer/control/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlDeer) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlDeer) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlDeerGetSingleById implements IReturn<SiteEventControlDeerSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventControlDeerGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlDeerGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlDeerSingleResponse(); }
}

// @Route("/deer/control/siteevent", "GET")
// @Route("/api/deer/control/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlDeerGetCollection implements IReturn<SiteEventControlDeerCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlDeerGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlDeerGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlDeerCollectionResponse(); }
}

// @Route("/deer/control/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventControlDeerGetCollectionGallery implements IReturn<SiteEventControlDeerCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlDeerGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlDeerGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlDeerCollectionGalleryResponse(); }
}

// @Route("/deer/control/siteevent/export", "GET")
// @Route("/api/deer/control/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlDeerGetCollectionExport implements IReturn<SiteEventControlDeerExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlDeerGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlDeerGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlDeerExportResponse(); }
}

// @Route("/deer/control/siteevent/export/csv", "GET")
// @Route("/api/deer/control/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlDeerGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlDeerGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlDeerGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/deer/control/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlDeer) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlDeer) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventControlDeerPostInsert implements IReturn<SiteEventControlDeerSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventControlDeer;

    public constructor(init?: Partial<SiteEventControlDeerPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlDeerPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventControlDeerSingleResponse(); }
}

// @Route("/deer/control/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventControlDeer)")
// @ApiResponse(Description="SiteEvent (SiteEventControlDeer) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlDeer) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlDeer) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlDeer) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventControlDeerPutUpdateById implements IReturn<SiteEventControlDeerSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventControlDeer;

    public constructor(init?: Partial<SiteEventControlDeerPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlDeerPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventControlDeerSingleResponse(); }
}

// @Route("/deer/control/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlDeer) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlDeer) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlDeerDeleteSingleById implements IReturn<SiteEventControlDeerSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventControlDeerDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlDeerDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventControlDeerSingleDeleteResponse(); }
}

// @Route("/deer/control/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlDeer) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlDeer) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlDeerGetHistory implements IReturn<SiteEventControlDeerHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventControlDeerGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlDeerGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlDeerHistoryResponse(); }
}

// @Route("/feralcat/control/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralCat) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralCat) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlFeralCatGetSingleById implements IReturn<SiteEventControlFeralCatSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventControlFeralCatGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralCatGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlFeralCatSingleResponse(); }
}

// @Route("/feralcat/control/siteevent", "GET")
// @Route("/api/feralcat/control/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlFeralCatGetCollection implements IReturn<SiteEventControlFeralCatCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlFeralCatGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralCatGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlFeralCatCollectionResponse(); }
}

// @Route("/feralcat/control/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventControlFeralCatGetCollectionGallery implements IReturn<SiteEventControlFeralCatCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlFeralCatGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralCatGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlFeralCatCollectionGalleryResponse(); }
}

// @Route("/feralcat/control/siteevent/export", "GET")
// @Route("/api/feralcat/control/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlFeralCatGetCollectionExport implements IReturn<SiteEventControlFeralCatExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlFeralCatGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralCatGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlFeralCatExportResponse(); }
}

// @Route("/feralcat/control/siteevent/export/csv", "GET")
// @Route("/api/feralcat/control/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlFeralCatGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlFeralCatGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralCatGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/feralcat/control/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralCat) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralCat) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventControlFeralCatPostInsert implements IReturn<SiteEventControlFeralCatSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventControlFeralCat;

    public constructor(init?: Partial<SiteEventControlFeralCatPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralCatPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventControlFeralCatSingleResponse(); }
}

// @Route("/feralcat/control/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventControlFeralCat)")
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralCat) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralCat) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralCat) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralCat) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventControlFeralCatPutUpdateById implements IReturn<SiteEventControlFeralCatSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventControlFeralCat;

    public constructor(init?: Partial<SiteEventControlFeralCatPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralCatPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventControlFeralCatSingleResponse(); }
}

// @Route("/feralcat/control/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralCat) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralCat) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlFeralCatDeleteSingleById implements IReturn<SiteEventControlFeralCatSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventControlFeralCatDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralCatDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventControlFeralCatSingleDeleteResponse(); }
}

// @Route("/feralcat/control/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralCat) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralCat) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlFeralCatGetHistory implements IReturn<SiteEventControlFeralCatHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventControlFeralCatGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralCatGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlFeralCatHistoryResponse(); }
}

// @Route("/feralfish/control/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralFish) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralFish) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlFeralFishGetSingleById implements IReturn<SiteEventControlFeralFishSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventControlFeralFishGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralFishGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlFeralFishSingleResponse(); }
}

// @Route("/feralfish/control/siteevent", "GET")
// @Route("/api/feralfish/control/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlFeralFishGetCollection implements IReturn<SiteEventControlFeralFishCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlFeralFishGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralFishGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlFeralFishCollectionResponse(); }
}

// @Route("/feralfish/control/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventControlFeralFishGetCollectionGallery implements IReturn<SiteEventControlFeralFishCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlFeralFishGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralFishGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlFeralFishCollectionGalleryResponse(); }
}

// @Route("/feralfish/control/siteevent/export", "GET")
// @Route("/api/feralfish/control/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlFeralFishGetCollectionExport implements IReturn<SiteEventControlFeralFishExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlFeralFishGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralFishGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlFeralFishExportResponse(); }
}

// @Route("/feralfish/control/siteevent/export/csv", "GET")
// @Route("/api/feralfish/control/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlFeralFishGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlFeralFishGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralFishGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/feralfish/control/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralFish) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralFish) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventControlFeralFishPostInsert implements IReturn<SiteEventControlFeralFishSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventControlFeralFish;

    public constructor(init?: Partial<SiteEventControlFeralFishPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralFishPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventControlFeralFishSingleResponse(); }
}

// @Route("/feralfish/control/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventControlFeralFish)")
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralFish) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralFish) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralFish) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralFish) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventControlFeralFishPutUpdateById implements IReturn<SiteEventControlFeralFishSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventControlFeralFish;

    public constructor(init?: Partial<SiteEventControlFeralFishPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralFishPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventControlFeralFishSingleResponse(); }
}

// @Route("/feralfish/control/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralFish) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralFish) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlFeralFishDeleteSingleById implements IReturn<SiteEventControlFeralFishSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventControlFeralFishDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralFishDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventControlFeralFishSingleDeleteResponse(); }
}

// @Route("/feralfish/control/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralFish) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralFish) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlFeralFishGetHistory implements IReturn<SiteEventControlFeralFishHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventControlFeralFishGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralFishGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlFeralFishHistoryResponse(); }
}

// @Route("/feralgoat/control/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralGoat) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralGoat) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlFeralGoatGetSingleById implements IReturn<SiteEventControlFeralGoatSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventControlFeralGoatGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralGoatGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlFeralGoatSingleResponse(); }
}

// @Route("/feralgoat/control/siteevent", "GET")
// @Route("/api/feralgoat/control/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlFeralGoatGetCollection implements IReturn<SiteEventControlFeralGoatCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlFeralGoatGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralGoatGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlFeralGoatCollectionResponse(); }
}

// @Route("/feralgoat/control/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventControlFeralGoatGetCollectionGallery implements IReturn<SiteEventControlFeralGoatCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlFeralGoatGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralGoatGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlFeralGoatCollectionGalleryResponse(); }
}

// @Route("/feralgoat/control/siteevent/export", "GET")
// @Route("/api/feralgoat/control/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlFeralGoatGetCollectionExport implements IReturn<SiteEventControlFeralGoatExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlFeralGoatGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralGoatGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlFeralGoatExportResponse(); }
}

// @Route("/feralgoat/control/siteevent/export/csv", "GET")
// @Route("/api/feralgoat/control/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlFeralGoatGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlFeralGoatGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralGoatGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/feralgoat/control/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralGoat) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralGoat) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventControlFeralGoatPostInsert implements IReturn<SiteEventControlFeralGoatSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventControlFeralGoat;

    public constructor(init?: Partial<SiteEventControlFeralGoatPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralGoatPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventControlFeralGoatSingleResponse(); }
}

// @Route("/feralgoat/control/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventControlFeralGoat)")
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralGoat) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralGoat) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralGoat) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralGoat) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventControlFeralGoatPutUpdateById implements IReturn<SiteEventControlFeralGoatSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventControlFeralGoat;

    public constructor(init?: Partial<SiteEventControlFeralGoatPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralGoatPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventControlFeralGoatSingleResponse(); }
}

// @Route("/feralgoat/control/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralGoat) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralGoat) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlFeralGoatDeleteSingleById implements IReturn<SiteEventControlFeralGoatSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventControlFeralGoatDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralGoatDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventControlFeralGoatSingleDeleteResponse(); }
}

// @Route("/feralgoat/control/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralGoat) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralGoat) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlFeralGoatGetHistory implements IReturn<SiteEventControlFeralGoatHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventControlFeralGoatGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralGoatGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlFeralGoatHistoryResponse(); }
}

// @Route("/feralpig/control/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralPig) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralPig) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlFeralPigGetSingleById implements IReturn<SiteEventControlFeralPigSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventControlFeralPigGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralPigGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlFeralPigSingleResponse(); }
}

// @Route("/feralpig/control/siteevent", "GET")
// @Route("/api/feralpig/control/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlFeralPigGetCollection implements IReturn<SiteEventControlFeralPigCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlFeralPigGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralPigGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlFeralPigCollectionResponse(); }
}

// @Route("/feralpig/control/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventControlFeralPigGetCollectionGallery implements IReturn<SiteEventControlFeralPigCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlFeralPigGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralPigGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlFeralPigCollectionGalleryResponse(); }
}

// @Route("/feralpig/control/siteevent/export", "GET")
// @Route("/api/feralpig/control/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlFeralPigGetCollectionExport implements IReturn<SiteEventControlFeralPigExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlFeralPigGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralPigGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlFeralPigExportResponse(); }
}

// @Route("/feralpig/control/siteevent/export/csv", "GET")
// @Route("/api/feralpig/control/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlFeralPigGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlFeralPigGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralPigGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/feralpig/control/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralPig) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralPig) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventControlFeralPigPostInsert implements IReturn<SiteEventControlFeralPigSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventControlFeralPig;

    public constructor(init?: Partial<SiteEventControlFeralPigPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralPigPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventControlFeralPigSingleResponse(); }
}

// @Route("/feralpig/control/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventControlFeralPig)")
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralPig) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralPig) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralPig) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralPig) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventControlFeralPigPutUpdateById implements IReturn<SiteEventControlFeralPigSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventControlFeralPig;

    public constructor(init?: Partial<SiteEventControlFeralPigPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralPigPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventControlFeralPigSingleResponse(); }
}

// @Route("/feralpig/control/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralPig) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralPig) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlFeralPigDeleteSingleById implements IReturn<SiteEventControlFeralPigSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventControlFeralPigDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralPigDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventControlFeralPigSingleDeleteResponse(); }
}

// @Route("/feralpig/control/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralPig) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFeralPig) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlFeralPigGetHistory implements IReturn<SiteEventControlFeralPigHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventControlFeralPigGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFeralPigGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlFeralPigHistoryResponse(); }
}

// @Route("/fox/control/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlFox) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFox) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlFoxGetSingleById implements IReturn<SiteEventControlFoxSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventControlFoxGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFoxGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlFoxSingleResponse(); }
}

// @Route("/fox/control/siteevent", "GET")
// @Route("/api/fox/control/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlFoxGetCollection implements IReturn<SiteEventControlFoxCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlFoxGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFoxGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlFoxCollectionResponse(); }
}

// @Route("/fox/control/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventControlFoxGetCollectionGallery implements IReturn<SiteEventControlFoxCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlFoxGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFoxGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlFoxCollectionGalleryResponse(); }
}

// @Route("/fox/control/siteevent/export", "GET")
// @Route("/api/fox/control/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlFoxGetCollectionExport implements IReturn<SiteEventControlFoxExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlFoxGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFoxGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlFoxExportResponse(); }
}

// @Route("/fox/control/siteevent/export/csv", "GET")
// @Route("/api/fox/control/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlFoxGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlFoxGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFoxGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/fox/control/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlFox) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFox) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventControlFoxPostInsert implements IReturn<SiteEventControlFoxSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventControlFox;

    public constructor(init?: Partial<SiteEventControlFoxPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFoxPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventControlFoxSingleResponse(); }
}

// @Route("/fox/control/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventControlFox)")
// @ApiResponse(Description="SiteEvent (SiteEventControlFox) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFox) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFox) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFox) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventControlFoxPutUpdateById implements IReturn<SiteEventControlFoxSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventControlFox;

    public constructor(init?: Partial<SiteEventControlFoxPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFoxPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventControlFoxSingleResponse(); }
}

// @Route("/fox/control/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlFox) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFox) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlFoxDeleteSingleById implements IReturn<SiteEventControlFoxSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventControlFoxDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFoxDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventControlFoxSingleDeleteResponse(); }
}

// @Route("/fox/control/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlFox) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlFox) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlFoxGetHistory implements IReturn<SiteEventControlFoxHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventControlFoxGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlFoxGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlFoxHistoryResponse(); }
}

// @Route("/mouse/control/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlMouse) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlMouse) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlMouseGetSingleById implements IReturn<SiteEventControlMouseSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventControlMouseGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlMouseGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlMouseSingleResponse(); }
}

// @Route("/mouse/control/siteevent", "GET")
// @Route("/api/mouse/control/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlMouseGetCollection implements IReturn<SiteEventControlMouseCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlMouseGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlMouseGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlMouseCollectionResponse(); }
}

// @Route("/mouse/control/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventControlMouseGetCollectionGallery implements IReturn<SiteEventControlMouseCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlMouseGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlMouseGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlMouseCollectionGalleryResponse(); }
}

// @Route("/mouse/control/siteevent/export", "GET")
// @Route("/api/mouse/control/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlMouseGetCollectionExport implements IReturn<SiteEventControlMouseExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlMouseGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlMouseGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlMouseExportResponse(); }
}

// @Route("/mouse/control/siteevent/export/csv", "GET")
// @Route("/api/mouse/control/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlMouseGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlMouseGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlMouseGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/mouse/control/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlMouse) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlMouse) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventControlMousePostInsert implements IReturn<SiteEventControlMouseSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventControlMouse;

    public constructor(init?: Partial<SiteEventControlMousePostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlMousePostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventControlMouseSingleResponse(); }
}

// @Route("/mouse/control/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventControlMouse)")
// @ApiResponse(Description="SiteEvent (SiteEventControlMouse) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlMouse) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlMouse) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlMouse) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventControlMousePutUpdateById implements IReturn<SiteEventControlMouseSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventControlMouse;

    public constructor(init?: Partial<SiteEventControlMousePutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlMousePutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventControlMouseSingleResponse(); }
}

// @Route("/mouse/control/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlMouse) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlMouse) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlMouseDeleteSingleById implements IReturn<SiteEventControlMouseSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventControlMouseDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlMouseDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventControlMouseSingleDeleteResponse(); }
}

// @Route("/mouse/control/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlMouse) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlMouse) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlMouseGetHistory implements IReturn<SiteEventControlMouseHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventControlMouseGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlMouseGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlMouseHistoryResponse(); }
}

// @Route("/myna/control/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlMyna) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlMyna) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlMynaGetSingleById implements IReturn<SiteEventControlMynaSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventControlMynaGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlMynaGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlMynaSingleResponse(); }
}

// @Route("/myna/control/siteevent", "GET")
// @Route("/api/myna/control/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlMynaGetCollection implements IReturn<SiteEventControlMynaCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlMynaGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlMynaGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlMynaCollectionResponse(); }
}

// @Route("/myna/control/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventControlMynaGetCollectionGallery implements IReturn<SiteEventControlMynaCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlMynaGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlMynaGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlMynaCollectionGalleryResponse(); }
}

// @Route("/myna/control/siteevent/export", "GET")
// @Route("/api/myna/control/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlMynaGetCollectionExport implements IReturn<SiteEventControlMynaExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlMynaGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlMynaGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlMynaExportResponse(); }
}

// @Route("/myna/control/siteevent/export/csv", "GET")
// @Route("/api/myna/control/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlMynaGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlMynaGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlMynaGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/myna/control/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlMyna) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlMyna) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventControlMynaPostInsert implements IReturn<SiteEventControlMynaSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventControlMyna;

    public constructor(init?: Partial<SiteEventControlMynaPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlMynaPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventControlMynaSingleResponse(); }
}

// @Route("/myna/control/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventControlMyna)")
// @ApiResponse(Description="SiteEvent (SiteEventControlMyna) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlMyna) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlMyna) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlMyna) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventControlMynaPutUpdateById implements IReturn<SiteEventControlMynaSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventControlMyna;

    public constructor(init?: Partial<SiteEventControlMynaPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlMynaPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventControlMynaSingleResponse(); }
}

// @Route("/myna/control/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlMyna) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlMyna) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlMynaDeleteSingleById implements IReturn<SiteEventControlMynaSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventControlMynaDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlMynaDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventControlMynaSingleDeleteResponse(); }
}

// @Route("/myna/control/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlMyna) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlMyna) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlMynaGetHistory implements IReturn<SiteEventControlMynaHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventControlMynaGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlMynaGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlMynaHistoryResponse(); }
}

// @Route("/otherpests/control/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlOtherPests) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlOtherPests) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlOtherPestsGetSingleById implements IReturn<SiteEventControlOtherPestsSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventControlOtherPestsGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlOtherPestsGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlOtherPestsSingleResponse(); }
}

// @Route("/otherpests/control/siteevent", "GET")
// @Route("/api/otherpests/control/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlOtherPestsGetCollection implements IReturn<SiteEventControlOtherPestsCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlOtherPestsGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlOtherPestsGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlOtherPestsCollectionResponse(); }
}

// @Route("/otherpests/control/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventControlOtherPestsGetCollectionGallery implements IReturn<SiteEventControlOtherPestsCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlOtherPestsGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlOtherPestsGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlOtherPestsCollectionGalleryResponse(); }
}

// @Route("/otherpests/control/siteevent/export", "GET")
// @Route("/api/otherpests/control/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlOtherPestsGetCollectionExport implements IReturn<SiteEventControlOtherPestsExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlOtherPestsGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlOtherPestsGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlOtherPestsExportResponse(); }
}

// @Route("/otherpests/control/siteevent/export/csv", "GET")
// @Route("/api/otherpests/control/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlOtherPestsGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlOtherPestsGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlOtherPestsGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/otherpests/control/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlOtherPests) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlOtherPests) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventControlOtherPestsPostInsert implements IReturn<SiteEventControlOtherPestsSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventControlOtherPests;

    public constructor(init?: Partial<SiteEventControlOtherPestsPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlOtherPestsPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventControlOtherPestsSingleResponse(); }
}

// @Route("/otherpests/control/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventControlOtherPests)")
// @ApiResponse(Description="SiteEvent (SiteEventControlOtherPests) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlOtherPests) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlOtherPests) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlOtherPests) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventControlOtherPestsPutUpdateById implements IReturn<SiteEventControlOtherPestsSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventControlOtherPests;

    public constructor(init?: Partial<SiteEventControlOtherPestsPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlOtherPestsPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventControlOtherPestsSingleResponse(); }
}

// @Route("/otherpests/control/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlOtherPests) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlOtherPests) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlOtherPestsDeleteSingleById implements IReturn<SiteEventControlOtherPestsSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventControlOtherPestsDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlOtherPestsDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventControlOtherPestsSingleDeleteResponse(); }
}

// @Route("/otherpests/control/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlOtherPests) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlOtherPests) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlOtherPestsGetHistory implements IReturn<SiteEventControlOtherPestsHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventControlOtherPestsGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlOtherPestsGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlOtherPestsHistoryResponse(); }
}

// @Route("/rabbit/control/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlRabbit) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlRabbit) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlRabbitGetSingleById implements IReturn<SiteEventControlRabbitSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventControlRabbitGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlRabbitGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlRabbitSingleResponse(); }
}

// @Route("/rabbit/control/siteevent", "GET")
// @Route("/api/rabbit/control/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlRabbitGetCollection implements IReturn<SiteEventControlRabbitCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlRabbitGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlRabbitGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlRabbitCollectionResponse(); }
}

// @Route("/rabbit/control/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventControlRabbitGetCollectionGallery implements IReturn<SiteEventControlRabbitCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlRabbitGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlRabbitGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlRabbitCollectionGalleryResponse(); }
}

// @Route("/rabbit/control/siteevent/export", "GET")
// @Route("/api/rabbit/control/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlRabbitGetCollectionExport implements IReturn<SiteEventControlRabbitExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlRabbitGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlRabbitGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlRabbitExportResponse(); }
}

// @Route("/rabbit/control/siteevent/export/csv", "GET")
// @Route("/api/rabbit/control/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlRabbitGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlRabbitGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlRabbitGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/rabbit/control/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlRabbit) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlRabbit) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventControlRabbitPostInsert implements IReturn<SiteEventControlRabbitSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventControlRabbit;

    public constructor(init?: Partial<SiteEventControlRabbitPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlRabbitPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventControlRabbitSingleResponse(); }
}

// @Route("/rabbit/control/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventControlRabbit)")
// @ApiResponse(Description="SiteEvent (SiteEventControlRabbit) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlRabbit) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlRabbit) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlRabbit) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventControlRabbitPutUpdateById implements IReturn<SiteEventControlRabbitSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventControlRabbit;

    public constructor(init?: Partial<SiteEventControlRabbitPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlRabbitPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventControlRabbitSingleResponse(); }
}

// @Route("/rabbit/control/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlRabbit) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlRabbit) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlRabbitDeleteSingleById implements IReturn<SiteEventControlRabbitSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventControlRabbitDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlRabbitDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventControlRabbitSingleDeleteResponse(); }
}

// @Route("/rabbit/control/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlRabbit) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlRabbit) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlRabbitGetHistory implements IReturn<SiteEventControlRabbitHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventControlRabbitGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlRabbitGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlRabbitHistoryResponse(); }
}

// @Route("/starling/control/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlStarling) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlStarling) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlStarlingGetSingleById implements IReturn<SiteEventControlStarlingSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventControlStarlingGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlStarlingGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlStarlingSingleResponse(); }
}

// @Route("/starling/control/siteevent", "GET")
// @Route("/api/starling/control/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlStarlingGetCollection implements IReturn<SiteEventControlStarlingCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlStarlingGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlStarlingGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlStarlingCollectionResponse(); }
}

// @Route("/starling/control/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventControlStarlingGetCollectionGallery implements IReturn<SiteEventControlStarlingCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlStarlingGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlStarlingGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlStarlingCollectionGalleryResponse(); }
}

// @Route("/starling/control/siteevent/export", "GET")
// @Route("/api/starling/control/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlStarlingGetCollectionExport implements IReturn<SiteEventControlStarlingExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlStarlingGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlStarlingGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlStarlingExportResponse(); }
}

// @Route("/starling/control/siteevent/export/csv", "GET")
// @Route("/api/starling/control/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlStarlingGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlStarlingGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlStarlingGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/starling/control/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlStarling) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlStarling) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventControlStarlingPostInsert implements IReturn<SiteEventControlStarlingSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventControlStarling;

    public constructor(init?: Partial<SiteEventControlStarlingPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlStarlingPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventControlStarlingSingleResponse(); }
}

// @Route("/starling/control/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventControlStarling)")
// @ApiResponse(Description="SiteEvent (SiteEventControlStarling) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlStarling) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlStarling) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlStarling) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventControlStarlingPutUpdateById implements IReturn<SiteEventControlStarlingSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventControlStarling;

    public constructor(init?: Partial<SiteEventControlStarlingPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlStarlingPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventControlStarlingSingleResponse(); }
}

// @Route("/starling/control/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlStarling) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlStarling) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlStarlingDeleteSingleById implements IReturn<SiteEventControlStarlingSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventControlStarlingDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlStarlingDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventControlStarlingSingleDeleteResponse(); }
}

// @Route("/starling/control/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlStarling) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlStarling) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlStarlingGetHistory implements IReturn<SiteEventControlStarlingHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventControlStarlingGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlStarlingGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlStarlingHistoryResponse(); }
}

// @Route("/toad/control/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlToad) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlToad) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlToadGetSingleById implements IReturn<SiteEventControlToadSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventControlToadGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlToadGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlToadSingleResponse(); }
}

// @Route("/toad/control/siteevent", "GET")
// @Route("/api/toad/control/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlToadGetCollection implements IReturn<SiteEventControlToadCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlToadGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlToadGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlToadCollectionResponse(); }
}

// @Route("/toad/control/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventControlToadGetCollectionGallery implements IReturn<SiteEventControlToadCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlToadGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlToadGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlToadCollectionGalleryResponse(); }
}

// @Route("/toad/control/siteevent/export", "GET")
// @Route("/api/toad/control/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlToadGetCollectionExport implements IReturn<SiteEventControlToadExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlToadGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlToadGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlToadExportResponse(); }
}

// @Route("/toad/control/siteevent/export/csv", "GET")
// @Route("/api/toad/control/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlToadGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlToadGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlToadGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/toad/control/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlToad) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlToad) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventControlToadPostInsert implements IReturn<SiteEventControlToadSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventControlToad;

    public constructor(init?: Partial<SiteEventControlToadPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlToadPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventControlToadSingleResponse(); }
}

// @Route("/toad/control/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventControlToad)")
// @ApiResponse(Description="SiteEvent (SiteEventControlToad) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlToad) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlToad) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlToad) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventControlToadPutUpdateById implements IReturn<SiteEventControlToadSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventControlToad;

    public constructor(init?: Partial<SiteEventControlToadPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlToadPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventControlToadSingleResponse(); }
}

// @Route("/toad/control/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlToad) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlToad) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlToadDeleteSingleById implements IReturn<SiteEventControlToadSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventControlToadDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlToadDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventControlToadSingleDeleteResponse(); }
}

// @Route("/toad/control/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlToad) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlToad) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlToadGetHistory implements IReturn<SiteEventControlToadHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventControlToadGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlToadGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlToadHistoryResponse(); }
}

// @Route("/wilddog/control/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlWildDog) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlWildDog) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlWildDogGetSingleById implements IReturn<SiteEventControlWildDogSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventControlWildDogGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlWildDogGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlWildDogSingleResponse(); }
}

// @Route("/wilddog/control/siteevent", "GET")
// @Route("/api/wilddog/control/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlWildDogGetCollection implements IReturn<SiteEventControlWildDogCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlWildDogGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlWildDogGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlWildDogCollectionResponse(); }
}

// @Route("/wilddog/control/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventControlWildDogGetCollectionGallery implements IReturn<SiteEventControlWildDogCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlWildDogGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlWildDogGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlWildDogCollectionGalleryResponse(); }
}

// @Route("/wilddog/control/siteevent/export", "GET")
// @Route("/api/wilddog/control/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlWildDogGetCollectionExport implements IReturn<SiteEventControlWildDogExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlWildDogGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlWildDogGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlWildDogExportResponse(); }
}

// @Route("/wilddog/control/siteevent/export/csv", "GET")
// @Route("/api/wilddog/control/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventControlWildDogGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventControlWildDogGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlWildDogGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/wilddog/control/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlWildDog) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlWildDog) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventControlWildDogPostInsert implements IReturn<SiteEventControlWildDogSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventControlWildDog;

    public constructor(init?: Partial<SiteEventControlWildDogPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlWildDogPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventControlWildDogSingleResponse(); }
}

// @Route("/wilddog/control/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventControlWildDog)")
// @ApiResponse(Description="SiteEvent (SiteEventControlWildDog) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlWildDog) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlWildDog) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlWildDog) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventControlWildDogPutUpdateById implements IReturn<SiteEventControlWildDogSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventControlWildDog;

    public constructor(init?: Partial<SiteEventControlWildDogPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlWildDogPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventControlWildDogSingleResponse(); }
}

// @Route("/wilddog/control/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlWildDog) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlWildDog) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlWildDogDeleteSingleById implements IReturn<SiteEventControlWildDogSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventControlWildDogDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlWildDogDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventControlWildDogSingleDeleteResponse(); }
}

// @Route("/wilddog/control/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventControlWildDog) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventControlWildDog) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventControlWildDogGetHistory implements IReturn<SiteEventControlWildDogHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventControlWildDogGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventControlWildDogGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventControlWildDogHistoryResponse(); }
}

// @Route("/camel/damage/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageCamel) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageCamel) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageCamelGetSingleById implements IReturn<SiteEventDamageCamelSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventDamageCamelGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageCamelGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageCamelSingleResponse(); }
}

// @Route("/camel/damage/siteevent", "GET")
// @Route("/api/camel/damage/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageCamelGetCollection implements IReturn<SiteEventDamageCamelCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageCamelGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageCamelGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageCamelCollectionResponse(); }
}

// @Route("/camel/damage/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventDamageCamelGetCollectionGallery implements IReturn<SiteEventDamageCamelCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageCamelGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageCamelGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageCamelCollectionGalleryResponse(); }
}

// @Route("/camel/damage/siteevent/export", "GET")
// @Route("/api/camel/damage/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageCamelGetCollectionExport implements IReturn<SiteEventDamageCamelExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageCamelGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageCamelGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageCamelExportResponse(); }
}

// @Route("/camel/damage/siteevent/export/csv", "GET")
// @Route("/api/camel/damage/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageCamelGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageCamelGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageCamelGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/camel/damage/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageCamel) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageCamel) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventDamageCamelPostInsert implements IReturn<SiteEventDamageCamelSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventDamageCamel;

    public constructor(init?: Partial<SiteEventDamageCamelPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageCamelPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventDamageCamelSingleResponse(); }
}

// @Route("/camel/damage/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventDamageCamel)")
// @ApiResponse(Description="SiteEvent (SiteEventDamageCamel) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageCamel) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageCamel) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageCamel) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventDamageCamelPutUpdateById implements IReturn<SiteEventDamageCamelSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventDamageCamel;

    public constructor(init?: Partial<SiteEventDamageCamelPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageCamelPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventDamageCamelSingleResponse(); }
}

// @Route("/camel/damage/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageCamel) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageCamel) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageCamelDeleteSingleById implements IReturn<SiteEventDamageCamelSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventDamageCamelDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageCamelDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventDamageCamelSingleDeleteResponse(); }
}

// @Route("/camel/damage/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageCamel) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageCamel) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageCamelGetHistory implements IReturn<SiteEventDamageCamelHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventDamageCamelGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageCamelGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageCamelHistoryResponse(); }
}

// @Route("/deer/damage/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageDeer) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageDeer) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageDeerGetSingleById implements IReturn<SiteEventDamageDeerSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventDamageDeerGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageDeerGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageDeerSingleResponse(); }
}

// @Route("/deer/damage/siteevent", "GET")
// @Route("/api/deer/damage/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageDeerGetCollection implements IReturn<SiteEventDamageDeerCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageDeerGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageDeerGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageDeerCollectionResponse(); }
}

// @Route("/deer/damage/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventDamageDeerGetCollectionGallery implements IReturn<SiteEventDamageDeerCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageDeerGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageDeerGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageDeerCollectionGalleryResponse(); }
}

// @Route("/deer/damage/siteevent/export", "GET")
// @Route("/api/deer/damage/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageDeerGetCollectionExport implements IReturn<SiteEventDamageDeerExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageDeerGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageDeerGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageDeerExportResponse(); }
}

// @Route("/deer/damage/siteevent/export/csv", "GET")
// @Route("/api/deer/damage/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageDeerGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageDeerGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageDeerGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/deer/damage/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageDeer) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageDeer) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventDamageDeerPostInsert implements IReturn<SiteEventDamageDeerSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventDamageDeer;

    public constructor(init?: Partial<SiteEventDamageDeerPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageDeerPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventDamageDeerSingleResponse(); }
}

// @Route("/deer/damage/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventDamageDeer)")
// @ApiResponse(Description="SiteEvent (SiteEventDamageDeer) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageDeer) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageDeer) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageDeer) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventDamageDeerPutUpdateById implements IReturn<SiteEventDamageDeerSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventDamageDeer;

    public constructor(init?: Partial<SiteEventDamageDeerPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageDeerPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventDamageDeerSingleResponse(); }
}

// @Route("/deer/damage/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageDeer) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageDeer) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageDeerDeleteSingleById implements IReturn<SiteEventDamageDeerSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventDamageDeerDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageDeerDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventDamageDeerSingleDeleteResponse(); }
}

// @Route("/deer/damage/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageDeer) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageDeer) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageDeerGetHistory implements IReturn<SiteEventDamageDeerHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventDamageDeerGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageDeerGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageDeerHistoryResponse(); }
}

// @Route("/feralcat/damage/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralCat) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralCat) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageFeralCatGetSingleById implements IReturn<SiteEventDamageFeralCatSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventDamageFeralCatGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralCatGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageFeralCatSingleResponse(); }
}

// @Route("/feralcat/damage/siteevent", "GET")
// @Route("/api/feralcat/damage/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageFeralCatGetCollection implements IReturn<SiteEventDamageFeralCatCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageFeralCatGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralCatGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageFeralCatCollectionResponse(); }
}

// @Route("/feralcat/damage/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventDamageFeralCatGetCollectionGallery implements IReturn<SiteEventDamageFeralCatCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageFeralCatGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralCatGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageFeralCatCollectionGalleryResponse(); }
}

// @Route("/feralcat/damage/siteevent/export", "GET")
// @Route("/api/feralcat/damage/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageFeralCatGetCollectionExport implements IReturn<SiteEventDamageFeralCatExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageFeralCatGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralCatGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageFeralCatExportResponse(); }
}

// @Route("/feralcat/damage/siteevent/export/csv", "GET")
// @Route("/api/feralcat/damage/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageFeralCatGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageFeralCatGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralCatGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/feralcat/damage/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralCat) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralCat) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventDamageFeralCatPostInsert implements IReturn<SiteEventDamageFeralCatSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventDamageFeralCat;

    public constructor(init?: Partial<SiteEventDamageFeralCatPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralCatPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventDamageFeralCatSingleResponse(); }
}

// @Route("/feralcat/damage/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventDamageFeralCat)")
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralCat) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralCat) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralCat) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralCat) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventDamageFeralCatPutUpdateById implements IReturn<SiteEventDamageFeralCatSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventDamageFeralCat;

    public constructor(init?: Partial<SiteEventDamageFeralCatPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralCatPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventDamageFeralCatSingleResponse(); }
}

// @Route("/feralcat/damage/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralCat) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralCat) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageFeralCatDeleteSingleById implements IReturn<SiteEventDamageFeralCatSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventDamageFeralCatDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralCatDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventDamageFeralCatSingleDeleteResponse(); }
}

// @Route("/feralcat/damage/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralCat) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralCat) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageFeralCatGetHistory implements IReturn<SiteEventDamageFeralCatHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventDamageFeralCatGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralCatGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageFeralCatHistoryResponse(); }
}

// @Route("/feralfish/damage/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralFish) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralFish) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageFeralFishGetSingleById implements IReturn<SiteEventDamageFeralFishSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventDamageFeralFishGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralFishGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageFeralFishSingleResponse(); }
}

// @Route("/feralfish/damage/siteevent", "GET")
// @Route("/api/feralfish/damage/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageFeralFishGetCollection implements IReturn<SiteEventDamageFeralFishCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageFeralFishGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralFishGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageFeralFishCollectionResponse(); }
}

// @Route("/feralfish/damage/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventDamageFeralFishGetCollectionGallery implements IReturn<SiteEventDamageFeralFishCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageFeralFishGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralFishGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageFeralFishCollectionGalleryResponse(); }
}

// @Route("/feralfish/damage/siteevent/export", "GET")
// @Route("/api/feralfish/damage/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageFeralFishGetCollectionExport implements IReturn<SiteEventDamageFeralFishExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageFeralFishGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralFishGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageFeralFishExportResponse(); }
}

// @Route("/feralfish/damage/siteevent/export/csv", "GET")
// @Route("/api/feralfish/damage/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageFeralFishGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageFeralFishGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralFishGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/feralfish/damage/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralFish) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralFish) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventDamageFeralFishPostInsert implements IReturn<SiteEventDamageFeralFishSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventDamageFeralFish;

    public constructor(init?: Partial<SiteEventDamageFeralFishPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralFishPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventDamageFeralFishSingleResponse(); }
}

// @Route("/feralfish/damage/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventDamageFeralFish)")
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralFish) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralFish) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralFish) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralFish) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventDamageFeralFishPutUpdateById implements IReturn<SiteEventDamageFeralFishSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventDamageFeralFish;

    public constructor(init?: Partial<SiteEventDamageFeralFishPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralFishPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventDamageFeralFishSingleResponse(); }
}

// @Route("/feralfish/damage/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralFish) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralFish) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageFeralFishDeleteSingleById implements IReturn<SiteEventDamageFeralFishSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventDamageFeralFishDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralFishDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventDamageFeralFishSingleDeleteResponse(); }
}

// @Route("/feralfish/damage/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralFish) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralFish) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageFeralFishGetHistory implements IReturn<SiteEventDamageFeralFishHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventDamageFeralFishGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralFishGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageFeralFishHistoryResponse(); }
}

// @Route("/feralgoat/damage/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralGoat) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralGoat) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageFeralGoatGetSingleById implements IReturn<SiteEventDamageFeralGoatSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventDamageFeralGoatGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralGoatGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageFeralGoatSingleResponse(); }
}

// @Route("/feralgoat/damage/siteevent", "GET")
// @Route("/api/feralgoat/damage/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageFeralGoatGetCollection implements IReturn<SiteEventDamageFeralGoatCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageFeralGoatGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralGoatGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageFeralGoatCollectionResponse(); }
}

// @Route("/feralgoat/damage/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventDamageFeralGoatGetCollectionGallery implements IReturn<SiteEventDamageFeralGoatCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageFeralGoatGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralGoatGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageFeralGoatCollectionGalleryResponse(); }
}

// @Route("/feralgoat/damage/siteevent/export", "GET")
// @Route("/api/feralgoat/damage/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageFeralGoatGetCollectionExport implements IReturn<SiteEventDamageFeralGoatExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageFeralGoatGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralGoatGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageFeralGoatExportResponse(); }
}

// @Route("/feralgoat/damage/siteevent/export/csv", "GET")
// @Route("/api/feralgoat/damage/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageFeralGoatGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageFeralGoatGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralGoatGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/feralgoat/damage/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralGoat) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralGoat) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventDamageFeralGoatPostInsert implements IReturn<SiteEventDamageFeralGoatSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventDamageFeralGoat;

    public constructor(init?: Partial<SiteEventDamageFeralGoatPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralGoatPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventDamageFeralGoatSingleResponse(); }
}

// @Route("/feralgoat/damage/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventDamageFeralGoat)")
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralGoat) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralGoat) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralGoat) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralGoat) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventDamageFeralGoatPutUpdateById implements IReturn<SiteEventDamageFeralGoatSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventDamageFeralGoat;

    public constructor(init?: Partial<SiteEventDamageFeralGoatPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralGoatPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventDamageFeralGoatSingleResponse(); }
}

// @Route("/feralgoat/damage/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralGoat) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralGoat) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageFeralGoatDeleteSingleById implements IReturn<SiteEventDamageFeralGoatSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventDamageFeralGoatDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralGoatDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventDamageFeralGoatSingleDeleteResponse(); }
}

// @Route("/feralgoat/damage/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralGoat) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralGoat) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageFeralGoatGetHistory implements IReturn<SiteEventDamageFeralGoatHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventDamageFeralGoatGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralGoatGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageFeralGoatHistoryResponse(); }
}

// @Route("/feralpig/damage/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralPig) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralPig) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageFeralPigGetSingleById implements IReturn<SiteEventDamageFeralPigSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventDamageFeralPigGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralPigGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageFeralPigSingleResponse(); }
}

// @Route("/feralpig/damage/siteevent", "GET")
// @Route("/api/feralpig/damage/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageFeralPigGetCollection implements IReturn<SiteEventDamageFeralPigCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageFeralPigGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralPigGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageFeralPigCollectionResponse(); }
}

// @Route("/feralpig/damage/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventDamageFeralPigGetCollectionGallery implements IReturn<SiteEventDamageFeralPigCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageFeralPigGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralPigGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageFeralPigCollectionGalleryResponse(); }
}

// @Route("/feralpig/damage/siteevent/export", "GET")
// @Route("/api/feralpig/damage/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageFeralPigGetCollectionExport implements IReturn<SiteEventDamageFeralPigExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageFeralPigGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralPigGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageFeralPigExportResponse(); }
}

// @Route("/feralpig/damage/siteevent/export/csv", "GET")
// @Route("/api/feralpig/damage/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageFeralPigGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageFeralPigGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralPigGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/feralpig/damage/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralPig) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralPig) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventDamageFeralPigPostInsert implements IReturn<SiteEventDamageFeralPigSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventDamageFeralPig;

    public constructor(init?: Partial<SiteEventDamageFeralPigPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralPigPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventDamageFeralPigSingleResponse(); }
}

// @Route("/feralpig/damage/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventDamageFeralPig)")
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralPig) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralPig) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralPig) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralPig) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventDamageFeralPigPutUpdateById implements IReturn<SiteEventDamageFeralPigSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventDamageFeralPig;

    public constructor(init?: Partial<SiteEventDamageFeralPigPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralPigPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventDamageFeralPigSingleResponse(); }
}

// @Route("/feralpig/damage/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralPig) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralPig) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageFeralPigDeleteSingleById implements IReturn<SiteEventDamageFeralPigSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventDamageFeralPigDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralPigDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventDamageFeralPigSingleDeleteResponse(); }
}

// @Route("/feralpig/damage/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralPig) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFeralPig) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageFeralPigGetHistory implements IReturn<SiteEventDamageFeralPigHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventDamageFeralPigGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFeralPigGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageFeralPigHistoryResponse(); }
}

// @Route("/fox/damage/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageFox) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFox) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageFoxGetSingleById implements IReturn<SiteEventDamageFoxSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventDamageFoxGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFoxGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageFoxSingleResponse(); }
}

// @Route("/fox/damage/siteevent", "GET")
// @Route("/api/fox/damage/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageFoxGetCollection implements IReturn<SiteEventDamageFoxCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageFoxGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFoxGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageFoxCollectionResponse(); }
}

// @Route("/fox/damage/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventDamageFoxGetCollectionGallery implements IReturn<SiteEventDamageFoxCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageFoxGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFoxGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageFoxCollectionGalleryResponse(); }
}

// @Route("/fox/damage/siteevent/export", "GET")
// @Route("/api/fox/damage/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageFoxGetCollectionExport implements IReturn<SiteEventDamageFoxExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageFoxGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFoxGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageFoxExportResponse(); }
}

// @Route("/fox/damage/siteevent/export/csv", "GET")
// @Route("/api/fox/damage/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageFoxGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageFoxGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFoxGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/fox/damage/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageFox) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFox) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventDamageFoxPostInsert implements IReturn<SiteEventDamageFoxSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventDamageFox;

    public constructor(init?: Partial<SiteEventDamageFoxPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFoxPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventDamageFoxSingleResponse(); }
}

// @Route("/fox/damage/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventDamageFox)")
// @ApiResponse(Description="SiteEvent (SiteEventDamageFox) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFox) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFox) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFox) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventDamageFoxPutUpdateById implements IReturn<SiteEventDamageFoxSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventDamageFox;

    public constructor(init?: Partial<SiteEventDamageFoxPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFoxPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventDamageFoxSingleResponse(); }
}

// @Route("/fox/damage/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageFox) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFox) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageFoxDeleteSingleById implements IReturn<SiteEventDamageFoxSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventDamageFoxDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFoxDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventDamageFoxSingleDeleteResponse(); }
}

// @Route("/fox/damage/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageFox) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageFox) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageFoxGetHistory implements IReturn<SiteEventDamageFoxHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventDamageFoxGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageFoxGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageFoxHistoryResponse(); }
}

// @Route("/mouse/damage/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageMouse) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageMouse) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageMouseGetSingleById implements IReturn<SiteEventDamageMouseSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventDamageMouseGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageMouseGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageMouseSingleResponse(); }
}

// @Route("/mouse/damage/siteevent", "GET")
// @Route("/api/mouse/damage/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageMouseGetCollection implements IReturn<SiteEventDamageMouseCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageMouseGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageMouseGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageMouseCollectionResponse(); }
}

// @Route("/mouse/damage/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventDamageMouseGetCollectionGallery implements IReturn<SiteEventDamageMouseCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageMouseGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageMouseGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageMouseCollectionGalleryResponse(); }
}

// @Route("/mouse/damage/siteevent/export", "GET")
// @Route("/api/mouse/damage/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageMouseGetCollectionExport implements IReturn<SiteEventDamageMouseExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageMouseGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageMouseGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageMouseExportResponse(); }
}

// @Route("/mouse/damage/siteevent/export/csv", "GET")
// @Route("/api/mouse/damage/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageMouseGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageMouseGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageMouseGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/mouse/damage/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageMouse) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageMouse) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventDamageMousePostInsert implements IReturn<SiteEventDamageMouseSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventDamageMouse;

    public constructor(init?: Partial<SiteEventDamageMousePostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageMousePostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventDamageMouseSingleResponse(); }
}

// @Route("/mouse/damage/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventDamageMouse)")
// @ApiResponse(Description="SiteEvent (SiteEventDamageMouse) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageMouse) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageMouse) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageMouse) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventDamageMousePutUpdateById implements IReturn<SiteEventDamageMouseSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventDamageMouse;

    public constructor(init?: Partial<SiteEventDamageMousePutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageMousePutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventDamageMouseSingleResponse(); }
}

// @Route("/mouse/damage/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageMouse) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageMouse) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageMouseDeleteSingleById implements IReturn<SiteEventDamageMouseSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventDamageMouseDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageMouseDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventDamageMouseSingleDeleteResponse(); }
}

// @Route("/mouse/damage/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageMouse) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageMouse) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageMouseGetHistory implements IReturn<SiteEventDamageMouseHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventDamageMouseGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageMouseGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageMouseHistoryResponse(); }
}

// @Route("/myna/damage/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageMyna) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageMyna) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageMynaGetSingleById implements IReturn<SiteEventDamageMynaSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventDamageMynaGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageMynaGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageMynaSingleResponse(); }
}

// @Route("/myna/damage/siteevent", "GET")
// @Route("/api/myna/damage/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageMynaGetCollection implements IReturn<SiteEventDamageMynaCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageMynaGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageMynaGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageMynaCollectionResponse(); }
}

// @Route("/myna/damage/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventDamageMynaGetCollectionGallery implements IReturn<SiteEventDamageMynaCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageMynaGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageMynaGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageMynaCollectionGalleryResponse(); }
}

// @Route("/myna/damage/siteevent/export", "GET")
// @Route("/api/myna/damage/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageMynaGetCollectionExport implements IReturn<SiteEventDamageMynaExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageMynaGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageMynaGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageMynaExportResponse(); }
}

// @Route("/myna/damage/siteevent/export/csv", "GET")
// @Route("/api/myna/damage/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageMynaGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageMynaGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageMynaGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/myna/damage/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageMyna) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageMyna) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventDamageMynaPostInsert implements IReturn<SiteEventDamageMynaSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventDamageMyna;

    public constructor(init?: Partial<SiteEventDamageMynaPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageMynaPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventDamageMynaSingleResponse(); }
}

// @Route("/myna/damage/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventDamageMyna)")
// @ApiResponse(Description="SiteEvent (SiteEventDamageMyna) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageMyna) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageMyna) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageMyna) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventDamageMynaPutUpdateById implements IReturn<SiteEventDamageMynaSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventDamageMyna;

    public constructor(init?: Partial<SiteEventDamageMynaPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageMynaPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventDamageMynaSingleResponse(); }
}

// @Route("/myna/damage/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageMyna) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageMyna) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageMynaDeleteSingleById implements IReturn<SiteEventDamageMynaSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventDamageMynaDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageMynaDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventDamageMynaSingleDeleteResponse(); }
}

// @Route("/myna/damage/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageMyna) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageMyna) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageMynaGetHistory implements IReturn<SiteEventDamageMynaHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventDamageMynaGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageMynaGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageMynaHistoryResponse(); }
}

// @Route("/otherpests/damage/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageOtherPests) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageOtherPests) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageOtherPestsGetSingleById implements IReturn<SiteEventDamageOtherPestsSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventDamageOtherPestsGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageOtherPestsGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageOtherPestsSingleResponse(); }
}

// @Route("/otherpests/damage/siteevent", "GET")
// @Route("/api/otherpests/damage/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageOtherPestsGetCollection implements IReturn<SiteEventDamageOtherPestsCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageOtherPestsGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageOtherPestsGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageOtherPestsCollectionResponse(); }
}

// @Route("/otherpests/damage/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventDamageOtherPestsGetCollectionGallery implements IReturn<SiteEventDamageOtherPestsCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageOtherPestsGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageOtherPestsGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageOtherPestsCollectionGalleryResponse(); }
}

// @Route("/otherpests/damage/siteevent/export", "GET")
// @Route("/api/otherpests/damage/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageOtherPestsGetCollectionExport implements IReturn<SiteEventDamageOtherPestsExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageOtherPestsGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageOtherPestsGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageOtherPestsExportResponse(); }
}

// @Route("/otherpests/damage/siteevent/export/csv", "GET")
// @Route("/api/otherpests/damage/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageOtherPestsGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageOtherPestsGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageOtherPestsGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/otherpests/damage/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageOtherPests) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageOtherPests) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventDamageOtherPestsPostInsert implements IReturn<SiteEventDamageOtherPestsSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventDamageOtherPests;

    public constructor(init?: Partial<SiteEventDamageOtherPestsPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageOtherPestsPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventDamageOtherPestsSingleResponse(); }
}

// @Route("/otherpests/damage/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventDamageOtherPests)")
// @ApiResponse(Description="SiteEvent (SiteEventDamageOtherPests) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageOtherPests) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageOtherPests) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageOtherPests) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventDamageOtherPestsPutUpdateById implements IReturn<SiteEventDamageOtherPestsSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventDamageOtherPests;

    public constructor(init?: Partial<SiteEventDamageOtherPestsPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageOtherPestsPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventDamageOtherPestsSingleResponse(); }
}

// @Route("/otherpests/damage/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageOtherPests) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageOtherPests) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageOtherPestsDeleteSingleById implements IReturn<SiteEventDamageOtherPestsSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventDamageOtherPestsDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageOtherPestsDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventDamageOtherPestsSingleDeleteResponse(); }
}

// @Route("/otherpests/damage/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageOtherPests) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageOtherPests) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageOtherPestsGetHistory implements IReturn<SiteEventDamageOtherPestsHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventDamageOtherPestsGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageOtherPestsGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageOtherPestsHistoryResponse(); }
}

// @Route("/rabbit/damage/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageRabbit) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageRabbit) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageRabbitGetSingleById implements IReturn<SiteEventDamageRabbitSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventDamageRabbitGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageRabbitGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageRabbitSingleResponse(); }
}

// @Route("/rabbit/damage/siteevent", "GET")
// @Route("/api/rabbit/damage/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageRabbitGetCollection implements IReturn<SiteEventDamageRabbitCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageRabbitGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageRabbitGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageRabbitCollectionResponse(); }
}

// @Route("/rabbit/damage/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventDamageRabbitGetCollectionGallery implements IReturn<SiteEventDamageRabbitCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageRabbitGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageRabbitGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageRabbitCollectionGalleryResponse(); }
}

// @Route("/rabbit/damage/siteevent/export", "GET")
// @Route("/api/rabbit/damage/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageRabbitGetCollectionExport implements IReturn<SiteEventDamageRabbitExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageRabbitGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageRabbitGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageRabbitExportResponse(); }
}

// @Route("/rabbit/damage/siteevent/export/csv", "GET")
// @Route("/api/rabbit/damage/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageRabbitGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageRabbitGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageRabbitGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/rabbit/damage/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageRabbit) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageRabbit) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventDamageRabbitPostInsert implements IReturn<SiteEventDamageRabbitSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventDamageRabbit;

    public constructor(init?: Partial<SiteEventDamageRabbitPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageRabbitPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventDamageRabbitSingleResponse(); }
}

// @Route("/rabbit/damage/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventDamageRabbit)")
// @ApiResponse(Description="SiteEvent (SiteEventDamageRabbit) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageRabbit) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageRabbit) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageRabbit) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventDamageRabbitPutUpdateById implements IReturn<SiteEventDamageRabbitSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventDamageRabbit;

    public constructor(init?: Partial<SiteEventDamageRabbitPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageRabbitPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventDamageRabbitSingleResponse(); }
}

// @Route("/rabbit/damage/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageRabbit) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageRabbit) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageRabbitDeleteSingleById implements IReturn<SiteEventDamageRabbitSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventDamageRabbitDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageRabbitDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventDamageRabbitSingleDeleteResponse(); }
}

// @Route("/rabbit/damage/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageRabbit) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageRabbit) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageRabbitGetHistory implements IReturn<SiteEventDamageRabbitHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventDamageRabbitGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageRabbitGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageRabbitHistoryResponse(); }
}

// @Route("/starling/damage/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageStarling) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageStarling) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageStarlingGetSingleById implements IReturn<SiteEventDamageStarlingSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventDamageStarlingGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageStarlingGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageStarlingSingleResponse(); }
}

// @Route("/starling/damage/siteevent", "GET")
// @Route("/api/starling/damage/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageStarlingGetCollection implements IReturn<SiteEventDamageStarlingCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageStarlingGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageStarlingGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageStarlingCollectionResponse(); }
}

// @Route("/starling/damage/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventDamageStarlingGetCollectionGallery implements IReturn<SiteEventDamageStarlingCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageStarlingGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageStarlingGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageStarlingCollectionGalleryResponse(); }
}

// @Route("/starling/damage/siteevent/export", "GET")
// @Route("/api/starling/damage/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageStarlingGetCollectionExport implements IReturn<SiteEventDamageStarlingExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageStarlingGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageStarlingGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageStarlingExportResponse(); }
}

// @Route("/starling/damage/siteevent/export/csv", "GET")
// @Route("/api/starling/damage/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageStarlingGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageStarlingGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageStarlingGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/starling/damage/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageStarling) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageStarling) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventDamageStarlingPostInsert implements IReturn<SiteEventDamageStarlingSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventDamageStarling;

    public constructor(init?: Partial<SiteEventDamageStarlingPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageStarlingPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventDamageStarlingSingleResponse(); }
}

// @Route("/starling/damage/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventDamageStarling)")
// @ApiResponse(Description="SiteEvent (SiteEventDamageStarling) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageStarling) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageStarling) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageStarling) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventDamageStarlingPutUpdateById implements IReturn<SiteEventDamageStarlingSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventDamageStarling;

    public constructor(init?: Partial<SiteEventDamageStarlingPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageStarlingPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventDamageStarlingSingleResponse(); }
}

// @Route("/starling/damage/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageStarling) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageStarling) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageStarlingDeleteSingleById implements IReturn<SiteEventDamageStarlingSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventDamageStarlingDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageStarlingDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventDamageStarlingSingleDeleteResponse(); }
}

// @Route("/starling/damage/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageStarling) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageStarling) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageStarlingGetHistory implements IReturn<SiteEventDamageStarlingHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventDamageStarlingGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageStarlingGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageStarlingHistoryResponse(); }
}

// @Route("/toad/damage/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageToad) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageToad) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageToadGetSingleById implements IReturn<SiteEventDamageToadSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventDamageToadGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageToadGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageToadSingleResponse(); }
}

// @Route("/toad/damage/siteevent", "GET")
// @Route("/api/toad/damage/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageToadGetCollection implements IReturn<SiteEventDamageToadCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageToadGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageToadGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageToadCollectionResponse(); }
}

// @Route("/toad/damage/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventDamageToadGetCollectionGallery implements IReturn<SiteEventDamageToadCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageToadGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageToadGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageToadCollectionGalleryResponse(); }
}

// @Route("/toad/damage/siteevent/export", "GET")
// @Route("/api/toad/damage/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageToadGetCollectionExport implements IReturn<SiteEventDamageToadExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageToadGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageToadGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageToadExportResponse(); }
}

// @Route("/toad/damage/siteevent/export/csv", "GET")
// @Route("/api/toad/damage/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageToadGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageToadGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageToadGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/toad/damage/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageToad) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageToad) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventDamageToadPostInsert implements IReturn<SiteEventDamageToadSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventDamageToad;

    public constructor(init?: Partial<SiteEventDamageToadPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageToadPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventDamageToadSingleResponse(); }
}

// @Route("/toad/damage/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventDamageToad)")
// @ApiResponse(Description="SiteEvent (SiteEventDamageToad) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageToad) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageToad) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageToad) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventDamageToadPutUpdateById implements IReturn<SiteEventDamageToadSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventDamageToad;

    public constructor(init?: Partial<SiteEventDamageToadPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageToadPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventDamageToadSingleResponse(); }
}

// @Route("/toad/damage/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageToad) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageToad) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageToadDeleteSingleById implements IReturn<SiteEventDamageToadSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventDamageToadDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageToadDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventDamageToadSingleDeleteResponse(); }
}

// @Route("/toad/damage/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageToad) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageToad) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageToadGetHistory implements IReturn<SiteEventDamageToadHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventDamageToadGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageToadGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageToadHistoryResponse(); }
}

// @Route("/wilddog/damage/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageWildDog) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageWildDog) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageWildDogGetSingleById implements IReturn<SiteEventDamageWildDogSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventDamageWildDogGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageWildDogGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageWildDogSingleResponse(); }
}

// @Route("/wilddog/damage/siteevent", "GET")
// @Route("/api/wilddog/damage/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageWildDogGetCollection implements IReturn<SiteEventDamageWildDogCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageWildDogGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageWildDogGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageWildDogCollectionResponse(); }
}

// @Route("/wilddog/damage/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventDamageWildDogGetCollectionGallery implements IReturn<SiteEventDamageWildDogCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageWildDogGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageWildDogGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageWildDogCollectionGalleryResponse(); }
}

// @Route("/wilddog/damage/siteevent/export", "GET")
// @Route("/api/wilddog/damage/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageWildDogGetCollectionExport implements IReturn<SiteEventDamageWildDogExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageWildDogGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageWildDogGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageWildDogExportResponse(); }
}

// @Route("/wilddog/damage/siteevent/export/csv", "GET")
// @Route("/api/wilddog/damage/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDamageWildDogGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDamageWildDogGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageWildDogGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/wilddog/damage/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageWildDog) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageWildDog) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventDamageWildDogPostInsert implements IReturn<SiteEventDamageWildDogSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventDamageWildDog;

    public constructor(init?: Partial<SiteEventDamageWildDogPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageWildDogPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventDamageWildDogSingleResponse(); }
}

// @Route("/wilddog/damage/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventDamageWildDog)")
// @ApiResponse(Description="SiteEvent (SiteEventDamageWildDog) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageWildDog) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageWildDog) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageWildDog) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventDamageWildDogPutUpdateById implements IReturn<SiteEventDamageWildDogSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventDamageWildDog;

    public constructor(init?: Partial<SiteEventDamageWildDogPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageWildDogPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventDamageWildDogSingleResponse(); }
}

// @Route("/wilddog/damage/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageWildDog) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageWildDog) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageWildDogDeleteSingleById implements IReturn<SiteEventDamageWildDogSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventDamageWildDogDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageWildDogDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventDamageWildDogSingleDeleteResponse(); }
}

// @Route("/wilddog/damage/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDamageWildDog) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDamageWildDog) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDamageWildDogGetHistory implements IReturn<SiteEventDamageWildDogHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventDamageWildDogGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDamageWildDogGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDamageWildDogHistoryResponse(); }
}

// @Route("/rabbit/disease/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDiseaseRabbit) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDiseaseRabbit) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDiseaseRabbitGetSingleById implements IReturn<SiteEventDiseaseRabbitSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventDiseaseRabbitGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDiseaseRabbitGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDiseaseRabbitSingleResponse(); }
}

// @Route("/rabbit/disease/siteevent", "GET")
// @Route("/api/rabbit/disease/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDiseaseRabbitGetCollection implements IReturn<SiteEventDiseaseRabbitCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDiseaseRabbitGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDiseaseRabbitGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDiseaseRabbitCollectionResponse(); }
}

// @Route("/rabbit/disease/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventDiseaseRabbitGetCollectionGallery implements IReturn<SiteEventDiseaseRabbitCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDiseaseRabbitGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDiseaseRabbitGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDiseaseRabbitCollectionGalleryResponse(); }
}

// @Route("/rabbit/disease/siteevent/export", "GET")
// @Route("/api/rabbit/disease/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDiseaseRabbitGetCollectionExport implements IReturn<SiteEventDiseaseRabbitExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDiseaseRabbitGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDiseaseRabbitGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDiseaseRabbitExportResponse(); }
}

// @Route("/rabbit/disease/siteevent/export/csv", "GET")
// @Route("/api/rabbit/disease/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventDiseaseRabbitGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventDiseaseRabbitGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDiseaseRabbitGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/rabbit/disease/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDiseaseRabbit) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDiseaseRabbit) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventDiseaseRabbitPostInsert implements IReturn<SiteEventDiseaseRabbitSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventDiseaseRabbit;

    public constructor(init?: Partial<SiteEventDiseaseRabbitPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDiseaseRabbitPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventDiseaseRabbitSingleResponse(); }
}

// @Route("/rabbit/disease/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventDiseaseRabbit)")
// @ApiResponse(Description="SiteEvent (SiteEventDiseaseRabbit) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDiseaseRabbit) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDiseaseRabbit) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDiseaseRabbit) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventDiseaseRabbitPutUpdateById implements IReturn<SiteEventDiseaseRabbitSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventDiseaseRabbit;

    public constructor(init?: Partial<SiteEventDiseaseRabbitPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDiseaseRabbitPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventDiseaseRabbitSingleResponse(); }
}

// @Route("/rabbit/disease/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDiseaseRabbit) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDiseaseRabbit) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDiseaseRabbitDeleteSingleById implements IReturn<SiteEventDiseaseRabbitSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventDiseaseRabbitDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDiseaseRabbitDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventDiseaseRabbitSingleDeleteResponse(); }
}

// @Route("/rabbit/disease/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventDiseaseRabbit) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventDiseaseRabbit) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventDiseaseRabbitGetHistory implements IReturn<SiteEventDiseaseRabbitHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventDiseaseRabbitGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventDiseaseRabbitGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventDiseaseRabbitHistoryResponse(); }
}

// @Route("/deer/management/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventManagementDeer) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventManagementDeer) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventManagementDeerGetSingleById implements IReturn<SiteEventManagementDeerSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventManagementDeerGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventManagementDeerGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventManagementDeerSingleResponse(); }
}

// @Route("/deer/management/siteevent", "GET")
// @Route("/api/deer/management/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventManagementDeerGetCollection implements IReturn<SiteEventManagementDeerCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventManagementDeerGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventManagementDeerGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventManagementDeerCollectionResponse(); }
}

// @Route("/deer/management/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventManagementDeerGetCollectionGallery implements IReturn<SiteEventManagementDeerCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventManagementDeerGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventManagementDeerGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventManagementDeerCollectionGalleryResponse(); }
}

// @Route("/deer/management/siteevent/export", "GET")
// @Route("/api/deer/management/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventManagementDeerGetCollectionExport implements IReturn<SiteEventManagementDeerExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventManagementDeerGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventManagementDeerGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventManagementDeerExportResponse(); }
}

// @Route("/deer/management/siteevent/export/csv", "GET")
// @Route("/api/deer/management/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventManagementDeerGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventManagementDeerGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventManagementDeerGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/deer/management/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventManagementDeer) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventManagementDeer) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventManagementDeerPostInsert implements IReturn<SiteEventManagementDeerSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventManagementDeer;

    public constructor(init?: Partial<SiteEventManagementDeerPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventManagementDeerPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventManagementDeerSingleResponse(); }
}

// @Route("/deer/management/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventManagementDeer)")
// @ApiResponse(Description="SiteEvent (SiteEventManagementDeer) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventManagementDeer) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventManagementDeer) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventManagementDeer) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventManagementDeerPutUpdateById implements IReturn<SiteEventManagementDeerSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventManagementDeer;

    public constructor(init?: Partial<SiteEventManagementDeerPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventManagementDeerPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventManagementDeerSingleResponse(); }
}

// @Route("/deer/management/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventManagementDeer) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventManagementDeer) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventManagementDeerDeleteSingleById implements IReturn<SiteEventManagementDeerSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventManagementDeerDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventManagementDeerDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventManagementDeerSingleDeleteResponse(); }
}

// @Route("/deer/management/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventManagementDeer) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventManagementDeer) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventManagementDeerGetHistory implements IReturn<SiteEventManagementDeerHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventManagementDeerGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventManagementDeerGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventManagementDeerHistoryResponse(); }
}

// @Route("/wilddog/management/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventManagementWildDog) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventManagementWildDog) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventManagementWildDogGetSingleById implements IReturn<SiteEventManagementWildDogSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventManagementWildDogGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventManagementWildDogGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventManagementWildDogSingleResponse(); }
}

// @Route("/wilddog/management/siteevent", "GET")
// @Route("/api/wilddog/management/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventManagementWildDogGetCollection implements IReturn<SiteEventManagementWildDogCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventManagementWildDogGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventManagementWildDogGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventManagementWildDogCollectionResponse(); }
}

// @Route("/wilddog/management/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventManagementWildDogGetCollectionGallery implements IReturn<SiteEventManagementWildDogCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventManagementWildDogGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventManagementWildDogGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventManagementWildDogCollectionGalleryResponse(); }
}

// @Route("/wilddog/management/siteevent/export", "GET")
// @Route("/api/wilddog/management/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventManagementWildDogGetCollectionExport implements IReturn<SiteEventManagementWildDogExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventManagementWildDogGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventManagementWildDogGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventManagementWildDogExportResponse(); }
}

// @Route("/wilddog/management/siteevent/export/csv", "GET")
// @Route("/api/wilddog/management/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventManagementWildDogGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventManagementWildDogGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventManagementWildDogGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/wilddog/management/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventManagementWildDog) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventManagementWildDog) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventManagementWildDogPostInsert implements IReturn<SiteEventManagementWildDogSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventManagementWildDog;

    public constructor(init?: Partial<SiteEventManagementWildDogPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventManagementWildDogPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventManagementWildDogSingleResponse(); }
}

// @Route("/wilddog/management/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventManagementWildDog)")
// @ApiResponse(Description="SiteEvent (SiteEventManagementWildDog) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventManagementWildDog) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventManagementWildDog) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventManagementWildDog) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventManagementWildDogPutUpdateById implements IReturn<SiteEventManagementWildDogSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventManagementWildDog;

    public constructor(init?: Partial<SiteEventManagementWildDogPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventManagementWildDogPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventManagementWildDogSingleResponse(); }
}

// @Route("/wilddog/management/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventManagementWildDog) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventManagementWildDog) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventManagementWildDogDeleteSingleById implements IReturn<SiteEventManagementWildDogSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventManagementWildDogDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventManagementWildDogDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventManagementWildDogSingleDeleteResponse(); }
}

// @Route("/wilddog/management/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventManagementWildDog) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventManagementWildDog) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventManagementWildDogGetHistory implements IReturn<SiteEventManagementWildDogHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventManagementWildDogGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventManagementWildDogGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventManagementWildDogHistoryResponse(); }
}

// @Route("/camel/sighting/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingCamel) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingCamel) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingCamelGetSingleById implements IReturn<SiteEventSightingCamelSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventSightingCamelGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingCamelGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingCamelSingleResponse(); }
}

// @Route("/camel/sighting/siteevent", "GET")
// @Route("/api/camel/sighting/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingCamelGetCollection implements IReturn<SiteEventSightingCamelCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingCamelGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingCamelGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingCamelCollectionResponse(); }
}

// @Route("/camel/sighting/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventSightingCamelGetCollectionGallery implements IReturn<SiteEventSightingCamelCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingCamelGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingCamelGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingCamelCollectionGalleryResponse(); }
}

// @Route("/camel/sighting/siteevent/export", "GET")
// @Route("/api/camel/sighting/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingCamelGetCollectionExport implements IReturn<SiteEventSightingCamelExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingCamelGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingCamelGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingCamelExportResponse(); }
}

// @Route("/camel/sighting/siteevent/export/csv", "GET")
// @Route("/api/camel/sighting/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingCamelGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingCamelGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingCamelGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/camel/sighting/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingCamel) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingCamel) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventSightingCamelPostInsert implements IReturn<SiteEventSightingCamelSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventSightingCamel;

    public constructor(init?: Partial<SiteEventSightingCamelPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingCamelPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventSightingCamelSingleResponse(); }
}

// @Route("/camel/sighting/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventSightingCamel)")
// @ApiResponse(Description="SiteEvent (SiteEventSightingCamel) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingCamel) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingCamel) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingCamel) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventSightingCamelPutUpdateById implements IReturn<SiteEventSightingCamelSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventSightingCamel;

    public constructor(init?: Partial<SiteEventSightingCamelPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingCamelPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventSightingCamelSingleResponse(); }
}

// @Route("/camel/sighting/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingCamel) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingCamel) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingCamelDeleteSingleById implements IReturn<SiteEventSightingCamelSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventSightingCamelDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingCamelDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventSightingCamelSingleDeleteResponse(); }
}

// @Route("/camel/sighting/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingCamel) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingCamel) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingCamelGetHistory implements IReturn<SiteEventSightingCamelHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventSightingCamelGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingCamelGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingCamelHistoryResponse(); }
}

// @Route("/deer/sighting/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingDeer) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingDeer) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingDeerGetSingleById implements IReturn<SiteEventSightingDeerSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventSightingDeerGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingDeerGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingDeerSingleResponse(); }
}

// @Route("/deer/sighting/siteevent", "GET")
// @Route("/api/deer/sighting/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingDeerGetCollection implements IReturn<SiteEventSightingDeerCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingDeerGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingDeerGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingDeerCollectionResponse(); }
}

// @Route("/deer/sighting/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventSightingDeerGetCollectionGallery implements IReturn<SiteEventSightingDeerCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingDeerGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingDeerGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingDeerCollectionGalleryResponse(); }
}

// @Route("/deer/sighting/siteevent/export", "GET")
// @Route("/api/deer/sighting/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingDeerGetCollectionExport implements IReturn<SiteEventSightingDeerExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingDeerGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingDeerGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingDeerExportResponse(); }
}

// @Route("/deer/sighting/siteevent/export/csv", "GET")
// @Route("/api/deer/sighting/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingDeerGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingDeerGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingDeerGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/deer/sighting/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingDeer) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingDeer) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventSightingDeerPostInsert implements IReturn<SiteEventSightingDeerSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventSightingDeer;

    public constructor(init?: Partial<SiteEventSightingDeerPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingDeerPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventSightingDeerSingleResponse(); }
}

// @Route("/deer/sighting/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventSightingDeer)")
// @ApiResponse(Description="SiteEvent (SiteEventSightingDeer) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingDeer) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingDeer) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingDeer) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventSightingDeerPutUpdateById implements IReturn<SiteEventSightingDeerSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventSightingDeer;

    public constructor(init?: Partial<SiteEventSightingDeerPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingDeerPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventSightingDeerSingleResponse(); }
}

// @Route("/deer/sighting/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingDeer) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingDeer) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingDeerDeleteSingleById implements IReturn<SiteEventSightingDeerSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventSightingDeerDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingDeerDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventSightingDeerSingleDeleteResponse(); }
}

// @Route("/deer/sighting/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingDeer) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingDeer) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingDeerGetHistory implements IReturn<SiteEventSightingDeerHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventSightingDeerGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingDeerGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingDeerHistoryResponse(); }
}

// @Route("/deer/sighting/siteevent/ala", "GET")
// @Route("/api/deer/sighting/siteevent/ala", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingDeerGetCollectionAla implements IReturn<SiteEventSightingDeerAlaResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public returnDatabaseId: boolean;

    public constructor(init?: Partial<SiteEventSightingDeerGetCollectionAla>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingDeerGetCollectionAla'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingDeerAlaResponse(); }
}

// @Route("/deer/sighting/siteevent/ala/csv", "GET")
// @Route("/api/deer/sighting/siteevent/ala/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingDeerGetCollectionAlaCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public returnDatabaseId: boolean;

    public constructor(init?: Partial<SiteEventSightingDeerGetCollectionAlaCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingDeerGetCollectionAlaCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/feralcat/sighting/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralCat) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralCat) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingFeralCatGetSingleById implements IReturn<SiteEventSightingFeralCatSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventSightingFeralCatGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralCatGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingFeralCatSingleResponse(); }
}

// @Route("/feralcat/sighting/siteevent", "GET")
// @Route("/api/feralcat/sighting/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingFeralCatGetCollection implements IReturn<SiteEventSightingFeralCatCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingFeralCatGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralCatGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingFeralCatCollectionResponse(); }
}

// @Route("/feralcat/sighting/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventSightingFeralCatGetCollectionGallery implements IReturn<SiteEventSightingFeralCatCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingFeralCatGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralCatGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingFeralCatCollectionGalleryResponse(); }
}

// @Route("/feralcat/sighting/siteevent/export", "GET")
// @Route("/api/feralcat/sighting/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingFeralCatGetCollectionExport implements IReturn<SiteEventSightingFeralCatExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingFeralCatGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralCatGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingFeralCatExportResponse(); }
}

// @Route("/feralcat/sighting/siteevent/export/csv", "GET")
// @Route("/api/feralcat/sighting/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingFeralCatGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingFeralCatGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralCatGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/feralcat/sighting/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralCat) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralCat) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventSightingFeralCatPostInsert implements IReturn<SiteEventSightingFeralCatSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventSightingFeralCat;

    public constructor(init?: Partial<SiteEventSightingFeralCatPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralCatPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventSightingFeralCatSingleResponse(); }
}

// @Route("/feralcat/sighting/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventSightingFeralCat)")
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralCat) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralCat) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralCat) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralCat) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventSightingFeralCatPutUpdateById implements IReturn<SiteEventSightingFeralCatSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventSightingFeralCat;

    public constructor(init?: Partial<SiteEventSightingFeralCatPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralCatPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventSightingFeralCatSingleResponse(); }
}

// @Route("/feralcat/sighting/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralCat) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralCat) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingFeralCatDeleteSingleById implements IReturn<SiteEventSightingFeralCatSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventSightingFeralCatDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralCatDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventSightingFeralCatSingleDeleteResponse(); }
}

// @Route("/feralcat/sighting/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralCat) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralCat) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingFeralCatGetHistory implements IReturn<SiteEventSightingFeralCatHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventSightingFeralCatGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralCatGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingFeralCatHistoryResponse(); }
}

// @Route("/feralcat/sighting/siteevent/ala", "GET")
// @Route("/api/feralcat/sighting/siteevent/ala", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingFeralCatGetCollectionAla implements IReturn<SiteEventSightingFeralCatAlaResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public returnDatabaseId: boolean;

    public constructor(init?: Partial<SiteEventSightingFeralCatGetCollectionAla>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralCatGetCollectionAla'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingFeralCatAlaResponse(); }
}

// @Route("/feralcat/sighting/siteevent/ala/csv", "GET")
// @Route("/api/feralcat/sighting/siteevent/ala/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingFeralCatGetCollectionAlaCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public returnDatabaseId: boolean;

    public constructor(init?: Partial<SiteEventSightingFeralCatGetCollectionAlaCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralCatGetCollectionAlaCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/feralfish/sighting/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralFish) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralFish) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingFeralFishGetSingleById implements IReturn<SiteEventSightingFeralFishSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventSightingFeralFishGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralFishGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingFeralFishSingleResponse(); }
}

// @Route("/feralfish/sighting/siteevent", "GET")
// @Route("/api/feralfish/sighting/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingFeralFishGetCollection implements IReturn<SiteEventSightingFeralFishCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingFeralFishGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralFishGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingFeralFishCollectionResponse(); }
}

// @Route("/feralfish/sighting/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventSightingFeralFishGetCollectionGallery implements IReturn<SiteEventSightingFeralFishCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingFeralFishGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralFishGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingFeralFishCollectionGalleryResponse(); }
}

// @Route("/feralfish/sighting/siteevent/export", "GET")
// @Route("/api/feralfish/sighting/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingFeralFishGetCollectionExport implements IReturn<SiteEventSightingFeralFishExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingFeralFishGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralFishGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingFeralFishExportResponse(); }
}

// @Route("/feralfish/sighting/siteevent/export/csv", "GET")
// @Route("/api/feralfish/sighting/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingFeralFishGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingFeralFishGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralFishGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/feralfish/sighting/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralFish) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralFish) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventSightingFeralFishPostInsert implements IReturn<SiteEventSightingFeralFishSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventSightingFeralFish;

    public constructor(init?: Partial<SiteEventSightingFeralFishPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralFishPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventSightingFeralFishSingleResponse(); }
}

// @Route("/feralfish/sighting/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventSightingFeralFish)")
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralFish) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralFish) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralFish) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralFish) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventSightingFeralFishPutUpdateById implements IReturn<SiteEventSightingFeralFishSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventSightingFeralFish;

    public constructor(init?: Partial<SiteEventSightingFeralFishPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralFishPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventSightingFeralFishSingleResponse(); }
}

// @Route("/feralfish/sighting/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralFish) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralFish) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingFeralFishDeleteSingleById implements IReturn<SiteEventSightingFeralFishSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventSightingFeralFishDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralFishDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventSightingFeralFishSingleDeleteResponse(); }
}

// @Route("/feralfish/sighting/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralFish) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralFish) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingFeralFishGetHistory implements IReturn<SiteEventSightingFeralFishHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventSightingFeralFishGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralFishGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingFeralFishHistoryResponse(); }
}

// @Route("/feralfish/sighting/siteevent/ala", "GET")
// @Route("/api/feralfish/sighting/siteevent/ala", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingFeralFishGetCollectionAla implements IReturn<SiteEventSightingFeralFishAlaResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public returnDatabaseId: boolean;

    public constructor(init?: Partial<SiteEventSightingFeralFishGetCollectionAla>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralFishGetCollectionAla'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingFeralFishAlaResponse(); }
}

// @Route("/feralfish/sighting/siteevent/ala/csv", "GET")
// @Route("/api/feralfish/sighting/siteevent/ala/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingFeralFishGetCollectionAlaCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public returnDatabaseId: boolean;

    public constructor(init?: Partial<SiteEventSightingFeralFishGetCollectionAlaCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralFishGetCollectionAlaCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/feralgoat/sighting/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralGoat) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralGoat) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingFeralGoatGetSingleById implements IReturn<SiteEventSightingFeralGoatSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventSightingFeralGoatGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralGoatGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingFeralGoatSingleResponse(); }
}

// @Route("/feralgoat/sighting/siteevent", "GET")
// @Route("/api/feralgoat/sighting/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingFeralGoatGetCollection implements IReturn<SiteEventSightingFeralGoatCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingFeralGoatGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralGoatGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingFeralGoatCollectionResponse(); }
}

// @Route("/feralgoat/sighting/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventSightingFeralGoatGetCollectionGallery implements IReturn<SiteEventSightingFeralGoatCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingFeralGoatGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralGoatGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingFeralGoatCollectionGalleryResponse(); }
}

// @Route("/feralgoat/sighting/siteevent/export", "GET")
// @Route("/api/feralgoat/sighting/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingFeralGoatGetCollectionExport implements IReturn<SiteEventSightingFeralGoatExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingFeralGoatGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralGoatGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingFeralGoatExportResponse(); }
}

// @Route("/feralgoat/sighting/siteevent/export/csv", "GET")
// @Route("/api/feralgoat/sighting/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingFeralGoatGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingFeralGoatGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralGoatGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/feralgoat/sighting/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralGoat) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralGoat) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventSightingFeralGoatPostInsert implements IReturn<SiteEventSightingFeralGoatSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventSightingFeralGoat;

    public constructor(init?: Partial<SiteEventSightingFeralGoatPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralGoatPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventSightingFeralGoatSingleResponse(); }
}

// @Route("/feralgoat/sighting/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventSightingFeralGoat)")
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralGoat) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralGoat) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralGoat) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralGoat) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventSightingFeralGoatPutUpdateById implements IReturn<SiteEventSightingFeralGoatSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventSightingFeralGoat;

    public constructor(init?: Partial<SiteEventSightingFeralGoatPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralGoatPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventSightingFeralGoatSingleResponse(); }
}

// @Route("/feralgoat/sighting/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralGoat) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralGoat) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingFeralGoatDeleteSingleById implements IReturn<SiteEventSightingFeralGoatSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventSightingFeralGoatDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralGoatDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventSightingFeralGoatSingleDeleteResponse(); }
}

// @Route("/feralgoat/sighting/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralGoat) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralGoat) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingFeralGoatGetHistory implements IReturn<SiteEventSightingFeralGoatHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventSightingFeralGoatGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralGoatGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingFeralGoatHistoryResponse(); }
}

// @Route("/feralgoat/sighting/siteevent/ala", "GET")
// @Route("/api/feralgoat/sighting/siteevent/ala", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingFeralGoatGetCollectionAla implements IReturn<SiteEventSightingFeralGoatAlaResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public returnDatabaseId: boolean;

    public constructor(init?: Partial<SiteEventSightingFeralGoatGetCollectionAla>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralGoatGetCollectionAla'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingFeralGoatAlaResponse(); }
}

// @Route("/feralgoat/sighting/siteevent/ala/csv", "GET")
// @Route("/api/feralgoat/sighting/siteevent/ala/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingFeralGoatGetCollectionAlaCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public returnDatabaseId: boolean;

    public constructor(init?: Partial<SiteEventSightingFeralGoatGetCollectionAlaCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralGoatGetCollectionAlaCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/feralpig/sighting/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralPig) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralPig) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingFeralPigGetSingleById implements IReturn<SiteEventSightingFeralPigSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventSightingFeralPigGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralPigGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingFeralPigSingleResponse(); }
}

// @Route("/feralpig/sighting/siteevent", "GET")
// @Route("/api/feralpig/sighting/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingFeralPigGetCollection implements IReturn<SiteEventSightingFeralPigCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingFeralPigGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralPigGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingFeralPigCollectionResponse(); }
}

// @Route("/feralpig/sighting/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventSightingFeralPigGetCollectionGallery implements IReturn<SiteEventSightingFeralPigCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingFeralPigGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralPigGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingFeralPigCollectionGalleryResponse(); }
}

// @Route("/feralpig/sighting/siteevent/export", "GET")
// @Route("/api/feralpig/sighting/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingFeralPigGetCollectionExport implements IReturn<SiteEventSightingFeralPigExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingFeralPigGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralPigGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingFeralPigExportResponse(); }
}

// @Route("/feralpig/sighting/siteevent/export/csv", "GET")
// @Route("/api/feralpig/sighting/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingFeralPigGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingFeralPigGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralPigGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/feralpig/sighting/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralPig) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralPig) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventSightingFeralPigPostInsert implements IReturn<SiteEventSightingFeralPigSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventSightingFeralPig;

    public constructor(init?: Partial<SiteEventSightingFeralPigPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralPigPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventSightingFeralPigSingleResponse(); }
}

// @Route("/feralpig/sighting/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventSightingFeralPig)")
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralPig) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralPig) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralPig) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralPig) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventSightingFeralPigPutUpdateById implements IReturn<SiteEventSightingFeralPigSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventSightingFeralPig;

    public constructor(init?: Partial<SiteEventSightingFeralPigPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralPigPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventSightingFeralPigSingleResponse(); }
}

// @Route("/feralpig/sighting/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralPig) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralPig) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingFeralPigDeleteSingleById implements IReturn<SiteEventSightingFeralPigSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventSightingFeralPigDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralPigDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventSightingFeralPigSingleDeleteResponse(); }
}

// @Route("/feralpig/sighting/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralPig) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFeralPig) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingFeralPigGetHistory implements IReturn<SiteEventSightingFeralPigHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventSightingFeralPigGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralPigGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingFeralPigHistoryResponse(); }
}

// @Route("/feralpig/sighting/siteevent/ala", "GET")
// @Route("/api/feralpig/sighting/siteevent/ala", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingFeralPigGetCollectionAla implements IReturn<SiteEventSightingFeralPigAlaResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public returnDatabaseId: boolean;

    public constructor(init?: Partial<SiteEventSightingFeralPigGetCollectionAla>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralPigGetCollectionAla'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingFeralPigAlaResponse(); }
}

// @Route("/feralpig/sighting/siteevent/ala/csv", "GET")
// @Route("/api/feralpig/sighting/siteevent/ala/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingFeralPigGetCollectionAlaCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public returnDatabaseId: boolean;

    public constructor(init?: Partial<SiteEventSightingFeralPigGetCollectionAlaCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFeralPigGetCollectionAlaCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/fox/sighting/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingFox) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFox) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingFoxGetSingleById implements IReturn<SiteEventSightingFoxSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventSightingFoxGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFoxGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingFoxSingleResponse(); }
}

// @Route("/fox/sighting/siteevent", "GET")
// @Route("/api/fox/sighting/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingFoxGetCollection implements IReturn<SiteEventSightingFoxCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingFoxGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFoxGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingFoxCollectionResponse(); }
}

// @Route("/fox/sighting/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventSightingFoxGetCollectionGallery implements IReturn<SiteEventSightingFoxCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingFoxGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFoxGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingFoxCollectionGalleryResponse(); }
}

// @Route("/fox/sighting/siteevent/export", "GET")
// @Route("/api/fox/sighting/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingFoxGetCollectionExport implements IReturn<SiteEventSightingFoxExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingFoxGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFoxGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingFoxExportResponse(); }
}

// @Route("/fox/sighting/siteevent/export/csv", "GET")
// @Route("/api/fox/sighting/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingFoxGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingFoxGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFoxGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/fox/sighting/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingFox) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFox) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventSightingFoxPostInsert implements IReturn<SiteEventSightingFoxSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventSightingFox;

    public constructor(init?: Partial<SiteEventSightingFoxPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFoxPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventSightingFoxSingleResponse(); }
}

// @Route("/fox/sighting/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventSightingFox)")
// @ApiResponse(Description="SiteEvent (SiteEventSightingFox) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFox) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFox) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFox) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventSightingFoxPutUpdateById implements IReturn<SiteEventSightingFoxSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventSightingFox;

    public constructor(init?: Partial<SiteEventSightingFoxPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFoxPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventSightingFoxSingleResponse(); }
}

// @Route("/fox/sighting/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingFox) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFox) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingFoxDeleteSingleById implements IReturn<SiteEventSightingFoxSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventSightingFoxDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFoxDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventSightingFoxSingleDeleteResponse(); }
}

// @Route("/fox/sighting/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingFox) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingFox) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingFoxGetHistory implements IReturn<SiteEventSightingFoxHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventSightingFoxGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFoxGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingFoxHistoryResponse(); }
}

// @Route("/fox/sighting/siteevent/ala", "GET")
// @Route("/api/fox/sighting/siteevent/ala", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingFoxGetCollectionAla implements IReturn<SiteEventSightingFoxAlaResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public returnDatabaseId: boolean;

    public constructor(init?: Partial<SiteEventSightingFoxGetCollectionAla>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFoxGetCollectionAla'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingFoxAlaResponse(); }
}

// @Route("/fox/sighting/siteevent/ala/csv", "GET")
// @Route("/api/fox/sighting/siteevent/ala/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingFoxGetCollectionAlaCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public returnDatabaseId: boolean;

    public constructor(init?: Partial<SiteEventSightingFoxGetCollectionAlaCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingFoxGetCollectionAlaCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/mouse/sighting/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingMouse) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingMouse) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingMouseGetSingleById implements IReturn<SiteEventSightingMouseSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventSightingMouseGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingMouseGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingMouseSingleResponse(); }
}

// @Route("/mouse/sighting/siteevent", "GET")
// @Route("/api/mouse/sighting/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingMouseGetCollection implements IReturn<SiteEventSightingMouseCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingMouseGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingMouseGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingMouseCollectionResponse(); }
}

// @Route("/mouse/sighting/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventSightingMouseGetCollectionGallery implements IReturn<SiteEventSightingMouseCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingMouseGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingMouseGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingMouseCollectionGalleryResponse(); }
}

// @Route("/mouse/sighting/siteevent/export", "GET")
// @Route("/api/mouse/sighting/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingMouseGetCollectionExport implements IReturn<SiteEventSightingMouseExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingMouseGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingMouseGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingMouseExportResponse(); }
}

// @Route("/mouse/sighting/siteevent/export/csv", "GET")
// @Route("/api/mouse/sighting/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingMouseGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingMouseGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingMouseGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/mouse/sighting/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingMouse) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingMouse) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventSightingMousePostInsert implements IReturn<SiteEventSightingMouseSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventSightingMouse;

    public constructor(init?: Partial<SiteEventSightingMousePostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingMousePostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventSightingMouseSingleResponse(); }
}

// @Route("/mouse/sighting/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventSightingMouse)")
// @ApiResponse(Description="SiteEvent (SiteEventSightingMouse) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingMouse) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingMouse) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingMouse) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventSightingMousePutUpdateById implements IReturn<SiteEventSightingMouseSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventSightingMouse;

    public constructor(init?: Partial<SiteEventSightingMousePutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingMousePutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventSightingMouseSingleResponse(); }
}

// @Route("/mouse/sighting/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingMouse) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingMouse) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingMouseDeleteSingleById implements IReturn<SiteEventSightingMouseSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventSightingMouseDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingMouseDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventSightingMouseSingleDeleteResponse(); }
}

// @Route("/mouse/sighting/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingMouse) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingMouse) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingMouseGetHistory implements IReturn<SiteEventSightingMouseHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventSightingMouseGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingMouseGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingMouseHistoryResponse(); }
}

// @Route("/mouse/sighting/siteevent/ala", "GET")
// @Route("/api/mouse/sighting/siteevent/ala", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingMouseGetCollectionAla implements IReturn<SiteEventSightingMouseAlaResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public returnDatabaseId: boolean;

    public constructor(init?: Partial<SiteEventSightingMouseGetCollectionAla>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingMouseGetCollectionAla'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingMouseAlaResponse(); }
}

// @Route("/mouse/sighting/siteevent/ala/csv", "GET")
// @Route("/api/mouse/sighting/siteevent/ala/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingMouseGetCollectionAlaCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public returnDatabaseId: boolean;

    public constructor(init?: Partial<SiteEventSightingMouseGetCollectionAlaCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingMouseGetCollectionAlaCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/myna/sighting/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingMyna) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingMyna) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingMynaGetSingleById implements IReturn<SiteEventSightingMynaSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventSightingMynaGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingMynaGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingMynaSingleResponse(); }
}

// @Route("/myna/sighting/siteevent", "GET")
// @Route("/api/myna/sighting/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingMynaGetCollection implements IReturn<SiteEventSightingMynaCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingMynaGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingMynaGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingMynaCollectionResponse(); }
}

// @Route("/myna/sighting/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventSightingMynaGetCollectionGallery implements IReturn<SiteEventSightingMynaCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingMynaGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingMynaGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingMynaCollectionGalleryResponse(); }
}

// @Route("/myna/sighting/siteevent/export", "GET")
// @Route("/api/myna/sighting/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingMynaGetCollectionExport implements IReturn<SiteEventSightingMynaExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingMynaGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingMynaGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingMynaExportResponse(); }
}

// @Route("/myna/sighting/siteevent/export/csv", "GET")
// @Route("/api/myna/sighting/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingMynaGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingMynaGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingMynaGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/myna/sighting/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingMyna) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingMyna) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventSightingMynaPostInsert implements IReturn<SiteEventSightingMynaSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventSightingMyna;

    public constructor(init?: Partial<SiteEventSightingMynaPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingMynaPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventSightingMynaSingleResponse(); }
}

// @Route("/myna/sighting/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventSightingMyna)")
// @ApiResponse(Description="SiteEvent (SiteEventSightingMyna) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingMyna) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingMyna) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingMyna) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventSightingMynaPutUpdateById implements IReturn<SiteEventSightingMynaSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventSightingMyna;

    public constructor(init?: Partial<SiteEventSightingMynaPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingMynaPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventSightingMynaSingleResponse(); }
}

// @Route("/myna/sighting/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingMyna) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingMyna) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingMynaDeleteSingleById implements IReturn<SiteEventSightingMynaSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventSightingMynaDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingMynaDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventSightingMynaSingleDeleteResponse(); }
}

// @Route("/myna/sighting/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingMyna) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingMyna) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingMynaGetHistory implements IReturn<SiteEventSightingMynaHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventSightingMynaGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingMynaGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingMynaHistoryResponse(); }
}

// @Route("/myna/sighting/siteevent/ala", "GET")
// @Route("/api/myna/sighting/siteevent/ala", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingMynaGetCollectionAla implements IReturn<SiteEventSightingMynaAlaResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public returnDatabaseId: boolean;

    public constructor(init?: Partial<SiteEventSightingMynaGetCollectionAla>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingMynaGetCollectionAla'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingMynaAlaResponse(); }
}

// @Route("/myna/sighting/siteevent/ala/csv", "GET")
// @Route("/api/myna/sighting/siteevent/ala/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingMynaGetCollectionAlaCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public returnDatabaseId: boolean;

    public constructor(init?: Partial<SiteEventSightingMynaGetCollectionAlaCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingMynaGetCollectionAlaCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/newpests/sighting/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingNewPests) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingNewPests) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingNewPestsGetSingleById implements IReturn<SiteEventSightingNewPestsSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventSightingNewPestsGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingNewPestsGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingNewPestsSingleResponse(); }
}

// @Route("/newpests/sighting/siteevent", "GET")
// @Route("/api/newpests/sighting/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingNewPestsGetCollection implements IReturn<SiteEventSightingNewPestsCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingNewPestsGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingNewPestsGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingNewPestsCollectionResponse(); }
}

// @Route("/newpests/sighting/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventSightingNewPestsGetCollectionGallery implements IReturn<SiteEventSightingNewPestsCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingNewPestsGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingNewPestsGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingNewPestsCollectionGalleryResponse(); }
}

// @Route("/newpests/sighting/siteevent/export", "GET")
// @Route("/api/newpests/sighting/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingNewPestsGetCollectionExport implements IReturn<SiteEventSightingNewPestsExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingNewPestsGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingNewPestsGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingNewPestsExportResponse(); }
}

// @Route("/newpests/sighting/siteevent/export/csv", "GET")
// @Route("/api/newpests/sighting/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingNewPestsGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingNewPestsGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingNewPestsGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/newpests/sighting/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingNewPests) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingNewPests) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventSightingNewPestsPostInsert implements IReturn<SiteEventSightingNewPestsSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventSightingNewPests;

    public constructor(init?: Partial<SiteEventSightingNewPestsPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingNewPestsPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventSightingNewPestsSingleResponse(); }
}

// @Route("/newpests/sighting/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventSightingNewPests)")
// @ApiResponse(Description="SiteEvent (SiteEventSightingNewPests) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingNewPests) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingNewPests) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingNewPests) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventSightingNewPestsPutUpdateById implements IReturn<SiteEventSightingNewPestsSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventSightingNewPests;

    public constructor(init?: Partial<SiteEventSightingNewPestsPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingNewPestsPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventSightingNewPestsSingleResponse(); }
}

// @Route("/newpests/sighting/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingNewPests) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingNewPests) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingNewPestsDeleteSingleById implements IReturn<SiteEventSightingNewPestsSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventSightingNewPestsDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingNewPestsDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventSightingNewPestsSingleDeleteResponse(); }
}

// @Route("/newpests/sighting/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingNewPests) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingNewPests) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingNewPestsGetHistory implements IReturn<SiteEventSightingNewPestsHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventSightingNewPestsGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingNewPestsGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingNewPestsHistoryResponse(); }
}

// @Route("/otherpests/sighting/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingOtherPests) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingOtherPests) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingOtherPestsGetSingleById implements IReturn<SiteEventSightingOtherPestsSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventSightingOtherPestsGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingOtherPestsGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingOtherPestsSingleResponse(); }
}

// @Route("/otherpests/sighting/siteevent", "GET")
// @Route("/api/otherpests/sighting/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingOtherPestsGetCollection implements IReturn<SiteEventSightingOtherPestsCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingOtherPestsGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingOtherPestsGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingOtherPestsCollectionResponse(); }
}

// @Route("/otherpests/sighting/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventSightingOtherPestsGetCollectionGallery implements IReturn<SiteEventSightingOtherPestsCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingOtherPestsGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingOtherPestsGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingOtherPestsCollectionGalleryResponse(); }
}

// @Route("/otherpests/sighting/siteevent/export", "GET")
// @Route("/api/otherpests/sighting/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingOtherPestsGetCollectionExport implements IReturn<SiteEventSightingOtherPestsExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingOtherPestsGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingOtherPestsGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingOtherPestsExportResponse(); }
}

// @Route("/otherpests/sighting/siteevent/export/csv", "GET")
// @Route("/api/otherpests/sighting/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingOtherPestsGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingOtherPestsGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingOtherPestsGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/otherpests/sighting/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingOtherPests) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingOtherPests) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventSightingOtherPestsPostInsert implements IReturn<SiteEventSightingOtherPestsSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventSightingOtherPests;

    public constructor(init?: Partial<SiteEventSightingOtherPestsPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingOtherPestsPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventSightingOtherPestsSingleResponse(); }
}

// @Route("/otherpests/sighting/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventSightingOtherPests)")
// @ApiResponse(Description="SiteEvent (SiteEventSightingOtherPests) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingOtherPests) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingOtherPests) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingOtherPests) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventSightingOtherPestsPutUpdateById implements IReturn<SiteEventSightingOtherPestsSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventSightingOtherPests;

    public constructor(init?: Partial<SiteEventSightingOtherPestsPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingOtherPestsPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventSightingOtherPestsSingleResponse(); }
}

// @Route("/otherpests/sighting/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingOtherPests) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingOtherPests) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingOtherPestsDeleteSingleById implements IReturn<SiteEventSightingOtherPestsSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventSightingOtherPestsDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingOtherPestsDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventSightingOtherPestsSingleDeleteResponse(); }
}

// @Route("/otherpests/sighting/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingOtherPests) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingOtherPests) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingOtherPestsGetHistory implements IReturn<SiteEventSightingOtherPestsHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventSightingOtherPestsGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingOtherPestsGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingOtherPestsHistoryResponse(); }
}

// @Route("/otherpests/sighting/siteevent/ala", "GET")
// @Route("/api/otherpests/sighting/siteevent/ala", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingOtherPestsGetCollectionAla implements IReturn<SiteEventSightingOtherPestsAlaResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public returnDatabaseId: boolean;

    public constructor(init?: Partial<SiteEventSightingOtherPestsGetCollectionAla>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingOtherPestsGetCollectionAla'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingOtherPestsAlaResponse(); }
}

// @Route("/otherpests/sighting/siteevent/ala/csv", "GET")
// @Route("/api/otherpests/sighting/siteevent/ala/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingOtherPestsGetCollectionAlaCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public returnDatabaseId: boolean;

    public constructor(init?: Partial<SiteEventSightingOtherPestsGetCollectionAlaCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingOtherPestsGetCollectionAlaCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/rabbit/sighting/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingRabbit) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingRabbit) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingRabbitGetSingleById implements IReturn<SiteEventSightingRabbitSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventSightingRabbitGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingRabbitGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingRabbitSingleResponse(); }
}

// @Route("/rabbit/sighting/siteevent", "GET")
// @Route("/api/rabbit/sighting/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingRabbitGetCollection implements IReturn<SiteEventSightingRabbitCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingRabbitGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingRabbitGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingRabbitCollectionResponse(); }
}

// @Route("/rabbit/sighting/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventSightingRabbitGetCollectionGallery implements IReturn<SiteEventSightingRabbitCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingRabbitGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingRabbitGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingRabbitCollectionGalleryResponse(); }
}

// @Route("/rabbit/sighting/siteevent/export", "GET")
// @Route("/api/rabbit/sighting/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingRabbitGetCollectionExport implements IReturn<SiteEventSightingRabbitExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingRabbitGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingRabbitGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingRabbitExportResponse(); }
}

// @Route("/rabbit/sighting/siteevent/export/csv", "GET")
// @Route("/api/rabbit/sighting/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingRabbitGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingRabbitGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingRabbitGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/rabbit/sighting/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingRabbit) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingRabbit) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventSightingRabbitPostInsert implements IReturn<SiteEventSightingRabbitSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventSightingRabbit;

    public constructor(init?: Partial<SiteEventSightingRabbitPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingRabbitPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventSightingRabbitSingleResponse(); }
}

// @Route("/rabbit/sighting/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventSightingRabbit)")
// @ApiResponse(Description="SiteEvent (SiteEventSightingRabbit) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingRabbit) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingRabbit) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingRabbit) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventSightingRabbitPutUpdateById implements IReturn<SiteEventSightingRabbitSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventSightingRabbit;

    public constructor(init?: Partial<SiteEventSightingRabbitPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingRabbitPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventSightingRabbitSingleResponse(); }
}

// @Route("/rabbit/sighting/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingRabbit) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingRabbit) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingRabbitDeleteSingleById implements IReturn<SiteEventSightingRabbitSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventSightingRabbitDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingRabbitDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventSightingRabbitSingleDeleteResponse(); }
}

// @Route("/rabbit/sighting/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingRabbit) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingRabbit) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingRabbitGetHistory implements IReturn<SiteEventSightingRabbitHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventSightingRabbitGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingRabbitGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingRabbitHistoryResponse(); }
}

// @Route("/rabbit/sighting/siteevent/ala", "GET")
// @Route("/api/rabbit/sighting/siteevent/ala", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingRabbitGetCollectionAla implements IReturn<SiteEventSightingRabbitAlaResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public returnDatabaseId: boolean;

    public constructor(init?: Partial<SiteEventSightingRabbitGetCollectionAla>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingRabbitGetCollectionAla'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingRabbitAlaResponse(); }
}

// @Route("/rabbit/sighting/siteevent/ala/csv", "GET")
// @Route("/api/rabbit/sighting/siteevent/ala/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingRabbitGetCollectionAlaCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public returnDatabaseId: boolean;

    public constructor(init?: Partial<SiteEventSightingRabbitGetCollectionAlaCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingRabbitGetCollectionAlaCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/starling/sighting/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingStarling) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingStarling) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingStarlingGetSingleById implements IReturn<SiteEventSightingStarlingSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventSightingStarlingGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingStarlingGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingStarlingSingleResponse(); }
}

// @Route("/starling/sighting/siteevent", "GET")
// @Route("/api/starling/sighting/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingStarlingGetCollection implements IReturn<SiteEventSightingStarlingCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingStarlingGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingStarlingGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingStarlingCollectionResponse(); }
}

// @Route("/starling/sighting/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventSightingStarlingGetCollectionGallery implements IReturn<SiteEventSightingStarlingCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingStarlingGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingStarlingGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingStarlingCollectionGalleryResponse(); }
}

// @Route("/starling/sighting/siteevent/export", "GET")
// @Route("/api/starling/sighting/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingStarlingGetCollectionExport implements IReturn<SiteEventSightingStarlingExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingStarlingGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingStarlingGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingStarlingExportResponse(); }
}

// @Route("/starling/sighting/siteevent/export/csv", "GET")
// @Route("/api/starling/sighting/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingStarlingGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingStarlingGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingStarlingGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/starling/sighting/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingStarling) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingStarling) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventSightingStarlingPostInsert implements IReturn<SiteEventSightingStarlingSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventSightingStarling;

    public constructor(init?: Partial<SiteEventSightingStarlingPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingStarlingPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventSightingStarlingSingleResponse(); }
}

// @Route("/starling/sighting/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventSightingStarling)")
// @ApiResponse(Description="SiteEvent (SiteEventSightingStarling) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingStarling) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingStarling) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingStarling) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventSightingStarlingPutUpdateById implements IReturn<SiteEventSightingStarlingSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventSightingStarling;

    public constructor(init?: Partial<SiteEventSightingStarlingPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingStarlingPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventSightingStarlingSingleResponse(); }
}

// @Route("/starling/sighting/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingStarling) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingStarling) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingStarlingDeleteSingleById implements IReturn<SiteEventSightingStarlingSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventSightingStarlingDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingStarlingDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventSightingStarlingSingleDeleteResponse(); }
}

// @Route("/starling/sighting/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingStarling) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingStarling) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingStarlingGetHistory implements IReturn<SiteEventSightingStarlingHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventSightingStarlingGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingStarlingGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingStarlingHistoryResponse(); }
}

// @Route("/starling/sighting/siteevent/ala", "GET")
// @Route("/api/starling/sighting/siteevent/ala", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingStarlingGetCollectionAla implements IReturn<SiteEventSightingStarlingAlaResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public returnDatabaseId: boolean;

    public constructor(init?: Partial<SiteEventSightingStarlingGetCollectionAla>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingStarlingGetCollectionAla'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingStarlingAlaResponse(); }
}

// @Route("/starling/sighting/siteevent/ala/csv", "GET")
// @Route("/api/starling/sighting/siteevent/ala/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingStarlingGetCollectionAlaCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public returnDatabaseId: boolean;

    public constructor(init?: Partial<SiteEventSightingStarlingGetCollectionAlaCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingStarlingGetCollectionAlaCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/toad/sighting/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingToad) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingToad) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingToadGetSingleById implements IReturn<SiteEventSightingToadSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventSightingToadGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingToadGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingToadSingleResponse(); }
}

// @Route("/toad/sighting/siteevent", "GET")
// @Route("/api/toad/sighting/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingToadGetCollection implements IReturn<SiteEventSightingToadCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingToadGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingToadGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingToadCollectionResponse(); }
}

// @Route("/toad/sighting/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventSightingToadGetCollectionGallery implements IReturn<SiteEventSightingToadCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingToadGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingToadGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingToadCollectionGalleryResponse(); }
}

// @Route("/toad/sighting/siteevent/export", "GET")
// @Route("/api/toad/sighting/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingToadGetCollectionExport implements IReturn<SiteEventSightingToadExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingToadGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingToadGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingToadExportResponse(); }
}

// @Route("/toad/sighting/siteevent/export/csv", "GET")
// @Route("/api/toad/sighting/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingToadGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingToadGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingToadGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/toad/sighting/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingToad) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingToad) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventSightingToadPostInsert implements IReturn<SiteEventSightingToadSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventSightingToad;

    public constructor(init?: Partial<SiteEventSightingToadPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingToadPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventSightingToadSingleResponse(); }
}

// @Route("/toad/sighting/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventSightingToad)")
// @ApiResponse(Description="SiteEvent (SiteEventSightingToad) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingToad) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingToad) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingToad) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventSightingToadPutUpdateById implements IReturn<SiteEventSightingToadSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventSightingToad;

    public constructor(init?: Partial<SiteEventSightingToadPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingToadPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventSightingToadSingleResponse(); }
}

// @Route("/toad/sighting/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingToad) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingToad) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingToadDeleteSingleById implements IReturn<SiteEventSightingToadSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventSightingToadDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingToadDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventSightingToadSingleDeleteResponse(); }
}

// @Route("/toad/sighting/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingToad) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingToad) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingToadGetHistory implements IReturn<SiteEventSightingToadHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventSightingToadGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingToadGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingToadHistoryResponse(); }
}

// @Route("/toad/sighting/siteevent/ala", "GET")
// @Route("/api/toad/sighting/siteevent/ala", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingToadGetCollectionAla implements IReturn<SiteEventSightingToadAlaResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public returnDatabaseId: boolean;

    public constructor(init?: Partial<SiteEventSightingToadGetCollectionAla>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingToadGetCollectionAla'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingToadAlaResponse(); }
}

// @Route("/toad/sighting/siteevent/ala/csv", "GET")
// @Route("/api/toad/sighting/siteevent/ala/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingToadGetCollectionAlaCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public returnDatabaseId: boolean;

    public constructor(init?: Partial<SiteEventSightingToadGetCollectionAlaCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingToadGetCollectionAlaCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/wilddog/sighting/siteevent/{Id}", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingWildDog) Get Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingWildDog) Get Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingWildDogGetSingleById implements IReturn<SiteEventSightingWildDogSingleResponse>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventSightingWildDogGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingWildDogGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingWildDogSingleResponse(); }
}

// @Route("/wilddog/sighting/siteevent", "GET")
// @Route("/api/wilddog/sighting/siteevent", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingWildDogGetCollection implements IReturn<SiteEventSightingWildDogCollectionResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingWildDogGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingWildDogGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingWildDogCollectionResponse(); }
}

// @Route("/wilddog/sighting/siteeventphotos", "GET")
// @Api(Description="SiteEventPhotos")
export class SiteEventSightingWildDogGetCollectionGallery implements IReturn<SiteEventSightingWildDogCollectionGalleryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingWildDogGetCollectionGallery>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingWildDogGetCollectionGallery'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingWildDogCollectionGalleryResponse(); }
}

// @Route("/wilddog/sighting/siteevent/export", "GET")
// @Route("/api/wilddog/sighting/siteevent/export", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingWildDogGetCollectionExport implements IReturn<SiteEventSightingWildDogExportResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingWildDogGetCollectionExport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingWildDogGetCollectionExport'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingWildDogExportResponse(); }
}

// @Route("/wilddog/sighting/siteevent/export/csv", "GET")
// @Route("/api/wilddog/sighting/siteevent/export/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingWildDogGetCollectionExportCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public includeObsolete: boolean;
    public includeHistory: boolean;
    public returnDatabaseId: boolean;
    public accessToken: string;
    public skip?: number;
    public take?: number;
    public id?: number;
    public userId?: number;
    public userIdNotEqualTo?: number;
    public locatedInRegionIds: number[];
    public memberOfCommunityGroupIds: number[];
    public startDateOnOrAfter?: string;
    public startDateOnOrBefore?: string;
    public onlyPublicData: boolean;
    public subSpeciesId?: number;
    public getChartAndTableData?: boolean;
    public dataAccessId?: number;

    public constructor(init?: Partial<SiteEventSightingWildDogGetCollectionExportCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingWildDogGetCollectionExportCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/wilddog/sighting/siteevent", "POST")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingWildDog) Post Insert: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingWildDog) Post Insert: SiteEvent was not provided.", StatusCode=400)
export class SiteEventSightingWildDogPostInsert implements IReturn<SiteEventSightingWildDogSingleResponse>, IPost
{
    [immerable] = true;

    public siteEvent: SiteEventSightingWildDog;

    public constructor(init?: Partial<SiteEventSightingWildDogPostInsert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingWildDogPostInsert'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SiteEventSightingWildDogSingleResponse(); }
}

// @Route("/wilddog/sighting/siteevent/{Id}", "PUT")
// @Api(Description="SiteEvent (SiteEventSightingWildDog)")
// @ApiResponse(Description="SiteEvent (SiteEventSightingWildDog) Put Update: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingWildDog) Put Update: SiteEvent ID was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingWildDog) Put Update: SiteEvent was not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingWildDog) Put Update: SiteEvent ID does not match location.", StatusCode=400)
export class SiteEventSightingWildDogPutUpdateById implements IReturn<SiteEventSightingWildDogSingleResponse>, IPut
{
    [immerable] = true;

    public id?: number;
    public siteEvent: SiteEventSightingWildDog;

    public constructor(init?: Partial<SiteEventSightingWildDogPutUpdateById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingWildDogPutUpdateById'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new SiteEventSightingWildDogSingleResponse(); }
}

// @Route("/wilddog/sighting/siteevent/{Id}", "DELETE")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingWildDog) Delete Single By ID: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingWildDog) Delete Single By ID: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingWildDogDeleteSingleById implements IReturn<SiteEventSightingWildDogSingleDeleteResponse>, IDelete
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<SiteEventSightingWildDogDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingWildDogDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SiteEventSightingWildDogSingleDeleteResponse(); }
}

// @Route("/wilddog/sighting/siteevent/{Id}/history", "GET")
// @Api(Description="SiteEvent")
// @ApiResponse(Description="SiteEvent (SiteEventSightingWildDog) Get History: Request not provided.", StatusCode=400)
// @ApiResponse(Description="SiteEvent (SiteEventSightingWildDog) Get History: SiteEvent Id was not provided.", StatusCode=400)
export class SiteEventSightingWildDogGetHistory implements IReturn<SiteEventSightingWildDogHistoryResponse>, IGet
{
    [immerable] = true;

    public accessToken: string;
    public id?: number;

    public constructor(init?: Partial<SiteEventSightingWildDogGetHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingWildDogGetHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingWildDogHistoryResponse(); }
}

// @Route("/wilddog/sighting/siteevent/ala", "GET")
// @Route("/api/wilddog/sighting/siteevent/ala", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingWildDogGetCollectionAla implements IReturn<SiteEventSightingWildDogAlaResponse>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public returnDatabaseId: boolean;

    public constructor(init?: Partial<SiteEventSightingWildDogGetCollectionAla>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingWildDogGetCollectionAla'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SiteEventSightingWildDogAlaResponse(); }
}

// @Route("/wilddog/sighting/siteevent/ala/csv", "GET")
// @Route("/api/wilddog/sighting/siteevent/ala/csv", "GET")
// @Api(Description="SiteEvent")
export class SiteEventSightingWildDogGetCollectionAlaCsv implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public noLogging: boolean;
    public returnDatabaseId: boolean;

    public constructor(init?: Partial<SiteEventSightingWildDogGetCollectionAlaCsv>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SiteEventSightingWildDogGetCollectionAlaCsv'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/me-types", "GET")
// @ApiResponse(Description="Oh no! I cannot get me types!", StatusCode=400)
export class GetMeTypes implements IReturn<MeTypeResponse>, IGet
{
    [immerable] = true;

    public autoSuggestFormField: AutoSuggestFormField;
    public checkboxFormField: CheckboxFormField;
    public checkboxGroupFormField: CheckboxGroupFormField;
    public customFormField: CustomFormField;
    public dateFormField: DateFormField;
    public dropdownFormField: DropdownFormField;
    public dropdownWithNumberFormField: DropdownWithNumberFormField;
    public googleAutocompleteFormField: GoogleAutocompleteFormField;
    public radioFormField: RadioFormField;
    public radioGroupFormField: RadioGroupFormField;
    public textFieldFormField: TextFieldFormField;
    public timeFormField: TimeFormField;

    public constructor(init?: Partial<GetMeTypes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMeTypes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MeTypeResponse(); }
}

//
// Custom Dto - Replaces "SqlGeography"
export class MyGeographyDto 
{
    stSrid?: number;
    lat?: number;
    lon?: number;

    public constructor(stSrid?: number, lat?: number, lon?: number) { this.stSrid = stSrid; this.lat = lat; this.lon = lon; } 
}

